import { crmFr as crm } from './crm';
/**
 * Traductions françaises — langue par défaut de HOREVIA.
 * Un objet par namespace (module). Aucune chaîne ne doit être écrite en dur
 * dans les composants (UX_ARCHITECTURE §10).
 */

export const common = {
  appName: 'HOREVIA',
  actions: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    confirm: 'Confirmer',
    edit: 'Modifier',
    delete: 'Supprimer',
    create: 'Créer',
    search: 'Rechercher',
    filter: 'Filtrer',
    retry: 'Réessayer',
    reset: 'Réinitialiser',
    back: 'Retour',
    loadMore: 'Charger plus',
    copy: 'Copier',
    copied: 'Copié',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    openMenu: 'Ouvrir le menu',
    clearFilters: 'Effacer les filtres',
    remove: 'Retirer',
    actions: 'Actions',
    yes: 'Oui',
    no: 'Non',
  },
  states: {
    loading: 'Chargement…',
    empty: 'Aucun résultat',
    errorTitle: 'Une erreur est survenue',
    errorDescription:
      "L'opération n'a pas pu aboutir. Réessayez ; si le problème persiste, transmettez l'identifiant de trace à l'assistance.",
    offline: 'Hors ligne — affichage des dernières données connues.',
    noPermissionTitle: 'Accès refusé',
    noPermissionDescription:
      "Vous n'avez pas accès à cette section. Demandez les droits nécessaires à l'administrateur de votre établissement.",
    notFoundTitle: 'Page introuvable',
    notFoundDescription: "L'adresse demandée n'existe pas ou l'élément a été supprimé.",
    moduleUnavailableTitle: 'Module non activé',
    moduleUnavailableDescription:
      'Le module {{module}} n’est pas activé pour votre organisation. Il n’apparaît ni dans la navigation ni dans les écrans.',
    comingSoonTitle: 'Bientôt disponible',
    comingSoonDescription:
      'Ce module fait partie du périmètre MVP et sera livré dans une prochaine phase. La navigation est déjà en place.',
    traceId: 'Identifiant de trace : {{traceId}}',
  },
  fields: {
    required: 'requis',
    optional: 'facultatif',
    email: 'Adresse e-mail',
    password: 'Mot de passe',
    fullName: 'Nom complet',
    phone: 'Téléphone',
    language: 'Langue',
    status: 'Statut',
    createdAt: 'Créé le',
    updatedAt: 'Modifié le',
  },
  languages: { fr: 'Français', en: 'Anglais' },
  country: {
    placeholder: 'Choisir un pays',
    search: 'Rechercher un pays…',
    empty: 'Aucun pays ne correspond.',
    nearby: 'Burkina Faso et pays voisins',
    all: 'Tous les pays',
  },
  theme: { toggle: 'Basculer le thème clair / sombre', light: 'Clair', dark: 'Sombre' },
  pagination: {
    showing: '{{count}} élément affiché',
    showing_other: '{{count}} éléments affichés',
    loadMore: 'Charger plus',
  },
  validation: {
    required: 'Ce champ est obligatoire.',
    email: 'Adresse e-mail invalide.',
    minLength: 'Au moins {{count}} caractères.',
    passwordPolicy: 'Le mot de passe doit contenir au moins 12 caractères.',
    passwordMismatch: 'Les deux mots de passe ne correspondent pas.',
    phone: 'Numéro au format international, par exemple +226 78 82 32 38.',
    code6: 'Le code comporte 6 chiffres.',
  },
};

export const nav = {
  mainLabel: 'Navigation principale',
  skipToContent: 'Aller au contenu principal',
  home: 'HOREVIA — tableau de bord',
  collapse: 'Réduire le menu',
  expand: 'Déplier le menu',
  toggleMenu: 'Afficher ou masquer le menu',
  search: 'Rechercher (⌘K)',
  notifications: 'Notifications',
  notificationsCount: 'Notifications ({{count}} non lues)',
  property: 'Établissement sélectionné',
  propertySwitch: 'Changer d’établissement',
  profileMenu: 'Menu du compte',
  items: {
    dashboard: 'Tableau de bord',
    reservations: 'Réservations',
    reservationsCalendar: 'Calendrier',
    reservationsList: 'Réservations',
    reservationsNew: 'Nouvelle réservation',
    customers: 'Clients',
    customersPeople: 'Personnes',
    customersCompanies: 'Entreprises',
    resources: 'Hébergements & salles',
    resourcesList: 'Ressources',
    resourcesAvailability: 'Disponibilités',
    resourcesMaintenance: 'Maintenance',
    operations: 'Opérations',
    operationsArrivals: 'Arrivées',
    operationsDepartures: 'Départs',
    operationsHousekeeping: 'Ménage',
    operationsTasks: 'Tâches',
    billing: 'Facturation',
    billingProformas: 'Proformas',
    billingInvoices: 'Factures',
    billingPayments: 'Paiements',
    billingCash: 'Caisse',
    billingExpenses: 'Dépenses',
    restaurant: 'Restaurant · Bar',
    restaurantPos: 'Caisse (POS)',
    restaurantOrders: 'Commandes',
    restaurantKitchen: 'Cuisine',
    restaurantTabs: 'Comptoir',
    restaurantTables: 'Plan de salle',
    restaurantCatalog: 'Carte',
    restaurantOutlets: 'Points de vente & impression',
    stock: 'Stocks',
    stockLevels: 'Niveaux & alertes',
    stockMovements: 'Mouvements',
    stockPurchases: 'Achats',
    stockCounts: 'Inventaires',
    stockItems: 'Articles & lieux',
    reports: 'Rapports',
    administration: 'Administration',
    adminUsers: 'Utilisateurs',
    adminRoles: 'Rôles',
    adminTaxes: 'Taxes',
    adminSettings: 'Établissement & paramètres',
    adminAudit: "Journal d'audit",
    platform: 'Plateforme',
    platformTenants: 'Tenants',
    platformBilling: 'Facturation',
    platformPricing: 'Tarifs',
    adminSupport: 'Accès support',
    adminSetup: 'Mise en route',
    analytics: 'Analytics',
    analyticsOverview: 'Vue consolidée',
    analyticsSales: 'Ventes',
    analyticsStock: 'Stocks & marges',
    crm: 'CRM',
    crmOverview: 'Vue d’ensemble',
    crmCustomers: 'Clients 360',
    crmFollowUps: 'Relances',
    crmSegments: 'Segments',
    crmLoyalty: 'Fidélité',
    crmDuplicates: 'Doublons',
    crmSettings: 'Réglages CRM',
  },
  palette: {
    actionCreateTenant: 'Nouveau tenant',
    actionRecordPayment: 'Enregistrer un paiement',
    actionOpenCash: 'Ouvrir la caisse',
    actionRecordExpense: 'Nouvelle dépense',
    actionSearchPayment: 'Rechercher un paiement',
    title: 'Palette de commandes',
    placeholder: 'Rechercher une page, une action…',
    empty: 'Aucun résultat pour cette recherche.',
    groupNavigation: 'Navigation',
    groupActions: 'Actions',
    groupResults: 'Résultats',
    groupPreferences: 'Préférences',
    actionInviteUser: 'Inviter un utilisateur',
    actionCreateRole: 'Créer un rôle',
    actionCreateReservation: 'Nouvelle réservation',
    actionCreateCustomer: 'Nouveau client',
    actionCreateResource: 'Nouvelle ressource',
    actionCreateBlock: 'Nouveau blocage',
    actionOpenCalendar: 'Ouvrir le calendrier',
    actionSearchAvailability: 'Rechercher une disponibilité',
    actionCreateProforma: 'Nouvelle proforma',
    actionSearchInvoice: 'Rechercher une facture (FAC/…)',
    actionOpenReports: 'Voir les rapports',
    actionExportReport: 'Exporter le rapport…',
    actionExportReportHint: 'CSV',
    shortcutNavigate: 'naviguer',
    shortcutOpen: 'ouvrir',
    shortcutClose: 'fermer',
    actionToggleTheme: 'Basculer le thème clair / sombre',
    actionLogout: 'Se déconnecter',
    soon: 'bientôt',
  },
  profile: {
    myProfile: 'Mon profil',
    security: 'Sécurité',
    logout: 'Se déconnecter',
  },
};

export const auth = {
  login: {
    title: 'Connexion',
    subtitle: 'Accédez à la gestion de votre établissement.',
    email: 'Adresse e-mail',
    emailPlaceholder: 'prenom.nom@exemple.com',
    password: 'Mot de passe',
    forgot: 'Mot de passe oublié ?',
    submit: 'Se connecter',
    mfaNoticeTitle: 'Double authentification active',
    mfaNoticeBody:
      "Un code à 6 chiffres vous sera demandé depuis votre application d'authentification (TOTP) après la vérification du mot de passe.",
    footer: 'HOREVIA — La voie digitale de l’hospitalité',
    sessionExpired: 'Votre session a expiré. Reconnectez-vous pour continuer.',
  },
  mfa: {
    title: 'Vérification en deux étapes',
    subtitle: "Saisissez le code à 6 chiffres affiché par votre application d'authentification.",
    codeLabel: 'Code de vérification',
    submit: 'Vérifier',
    backToLogin: 'Revenir à la connexion',
  },
  forgot: {
    title: 'Mot de passe oublié',
    subtitle:
      'Indiquez votre adresse professionnelle : si un compte existe, un lien de réinitialisation vous sera envoyé.',
    submit: 'Envoyer le lien',
    sentTitle: 'Vérifiez votre messagerie',
    sentBody:
      'Si un compte est associé à {{email}}, un lien de réinitialisation valable 1 heure vient d’être envoyé.',
    backToLogin: 'Revenir à la connexion',
  },
  reset: {
    title: 'Nouveau mot de passe',
    subtitle: 'Choisissez un mot de passe d’au moins 12 caractères, propre à HOREVIA.',
    password: 'Nouveau mot de passe',
    confirm: 'Confirmer le mot de passe',
    submit: 'Enregistrer le mot de passe',
    successTitle: 'Mot de passe modifié',
    successBody: 'Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.',
    invalidToken: 'Ce lien de réinitialisation est invalide ou a expiré. Demandez-en un nouveau.',
  },
  invitation: {
    title: 'Activer votre compte',
    subtitle: 'Vous rejoignez {{tenant}} en tant que {{roles}}.',
    fullName: 'Nom complet',
    password: 'Mot de passe',
    confirm: 'Confirmer le mot de passe',
    submit: 'Activer mon compte',
    invalid: 'Cette invitation est invalide, expirée ou déjà utilisée.',
    successTitle: 'Compte activé',
    successBody: 'Connectez-vous avec votre adresse professionnelle et votre nouveau mot de passe.',
  },
  brand: {
    badge: 'Plateforme hospitalité',
    headline: 'Le séjour, la conformité et la facture, au même endroit.',
    lead: "Hôtel, restaurant, bar et caisse : une plateforme modulaire conçue pour les professionnels de l'hospitalité.",
    promise1Title: 'Planning et disponibilités en temps réel',
    promise1Body:
      'Appartements et salle de réunion sur une seule timeline : plus de double réservation.',
    promise2Title: 'Conformité vérifiée avant facturation',
    promise2Body:
      'CNIB ou passeport et fiche de police remplie contrôlés : la facture définitive ne part jamais incomplète.',
    promise3Title: 'Proformas et factures aux normes',
    promise3Body:
      'Numérotation sans trou, mentions RCCM / IFU / CME, montant en toutes lettres, PDF immuable.',
    mockToday: "Aujourd'hui",
    mockArrivals: 'Arrivées',
    mockDepartures: 'Départs',
    mockOccupancy: 'Occupation',
  },
  errors: {
    INVALID_CREDENTIALS: 'Adresse e-mail ou mot de passe incorrect.',
    ACCOUNT_LOCKED:
      'Compte temporairement verrouillé après plusieurs tentatives. Réessayez dans quelques minutes.',
    ACCOUNT_DISABLED: 'Ce compte est désactivé. Contactez l’administrateur de votre établissement.',
    MFA_INVALID: 'Code de vérification incorrect ou expiré.',
    RATE_LIMITED: 'Trop de tentatives. Patientez avant de réessayer.',
  },
};

export const dashboard = {
  greeting: 'Bonjour {{name}}',
  subtitle: 'Voici l’activité de votre résidence pour le {{date}}.',
  todayTitle: "Aujourd'hui",
  today: 'Aujourd’hui',
  operations: 'Opérations',
  seeAll: 'Voir tout',
  scheduled: 'prévu',
  balance: 'Solde {{amount}}',
  incomplete: 'Dossier incomplet',
  incompleteTooltip: 'Pièce d’identité ou fiche de police manquante',
  incompleteFoot: 'facture définitive bloquée (R-001)',
  inHouseFoot: 'séjours en cours sur le site',
  collect: 'Encaisser',
  collectHint: 'Ouvrir la réservation pour encaisser le solde (onglet Paiements).',
  expectedPayments: 'Paiements attendus',
  expectedPaymentsFoot: 'soldes des arrivées et départs du jour',
  metrics: {
    arrivals: 'Arrivées prévues',
    departures: 'Départs prévus',
    inHouse: 'En séjour',
    incompleteCompliance: 'Dossiers incomplets',
    availableResources: 'Logements & chambres libres',
    expectedPayments: 'Paiements attendus',
    collectedToday: 'Encaissé aujourd’hui',
    cash: 'Caisse',
    cashOpen: 'Ouverte',
    cashClosed: 'Fermée',
  },
  arrivalsCard: 'Arrivées du jour',
  departuresCard: 'Départs du jour',
  inHouseCard: 'Séjours en cours',
  arrivalsTitle: 'Arrivées du jour',
  arrivalsSubtitle: 'Les arrivées attendues aujourd’hui, prêtes pour le check-in.',
  departuresTitle: 'Départs du jour',
  departuresSubtitle: 'Les départs attendus aujourd’hui, avec leur solde restant dû.',
  arrivalsEmptyTitle: 'Aucune arrivée aujourd’hui',
  arrivalsEmptyBody: 'Aucune réservation confirmée ne commence ce jour.',
  departuresEmptyTitle: 'Aucun départ aujourd’hui',
  departuresEmptyBody: 'Aucun séjour en cours ne se termine ce jour.',
  inHouseEmptyTitle: 'Aucun séjour en cours',
  inHouseEmptyBody: 'Aucun client n’est actuellement sur le site.',
};

export const users = {
  title: 'Utilisateurs',
  subtitle:
    'Comptes de votre organisation : rôles, périmètre, double authentification et sessions.',
  invite: 'Inviter un utilisateur',
  searchPlaceholder: 'Rechercher un utilisateur',
  searchLabel: 'Rechercher un utilisateur par nom ou e-mail',
  kpi: {
    active: 'Utilisateurs actifs',
    activeFoot: '{{count}} invitation en attente',
    activeFoot_other: '{{count}} invitations en attente',
    mfa: 'Double authentification',
    mfaFoot: '{{count}} compte à sécuriser',
    mfaFoot_other: '{{count}} comptes à sécuriser',
    roles: 'Rôles configurés',
    rolesFoot: 'dont {{count}} rôle personnalisé',
    rolesFoot_other: 'dont {{count}} rôles personnalisés',
    disabled: 'Comptes désactivés',
    disabledFoot: 'accès révoqué, historique conservé',
  },
  columns: {
    user: 'Utilisateur',
    roles: 'Rôles',
    scope: 'Périmètre',
    mfa: 'MFA',
    lastLogin: 'Dernière connexion',
    status: 'Statut',
    actions: 'Actions',
  },
  status: { INVITED: 'Invité', ACTIVE: 'Actif', DISABLED: 'Désactivé' },
  filters: { all: 'Tous', status: 'Statut', role: 'Rôle' },
  mfaEnabled: 'Activée',
  mfaDisabled: 'À activer',
  allProperties: 'Tous les sites',
  never: 'Jamais',
  emptyTitle: 'Aucun utilisateur',
  emptyBody: 'Invitez un collaborateur pour lui donner accès à HOREVIA.',
  emptySearchTitle: 'Aucun utilisateur ne correspond',
  emptySearchBody: 'Modifiez la recherche ou effacez les filtres.',
  drawer: {
    inviteTitle: 'Inviter un utilisateur',
    inviteSubtitle:
      "Le lien d'activation vous sera remis à l'écran (et envoyé par e-mail si la messagerie est configurée). Le compte reste « Invité » tant qu'il n'est pas activé.",
    editTitle: 'Modifier {{name}}',
    editSubtitle: 'Nom, langue et rôles attribués.',
    rolesLabel: 'Rôles',
    rolesHint: 'Au moins un rôle. Le périmètre par établissement sera géré en V1 (multi-sites).',
    submitInvite: "Créer l'invitation",
    submitEdit: 'Enregistrer les modifications',
  },
  detail: {
    title: 'Fiche utilisateur',
    profile: 'Profil',
    rolesCard: 'Rôles et permissions',
    sessionsCard: 'Sessions actives',
    securityCard: 'Sécurité',
    dangerCard: 'Zone sensible',
    sessionDevice: 'Appareil',
    sessionIp: 'Adresse IP',
    sessionLastSeen: 'Dernière activité',
    sessionCurrent: 'Session courante',
    noSessions: 'Aucune session active.',
    permissionsCount: '{{count}} permission effective',
    permissionsCount_other: '{{count}} permissions effectives',
  },
  actions: {
    edit: 'Modifier',
    deactivate: 'Désactiver le compte',
    activate: 'Réactiver le compte',
    resetPassword: 'Réinitialiser le mot de passe',
    revokeSessions: 'Révoquer les sessions',
    resendInvitation: "Renvoyer l'invitation",
  },
  confirm: {
    deactivateTitle: 'Désactiver {{name}} ?',
    deactivateBody:
      "L'utilisateur perdra immédiatement l'accès et ses sessions seront fermées. L'historique et l'audit sont conservés.",
    deactivateConfirm: 'Désactiver le compte',
    resetTitle: 'Réinitialiser le mot de passe de {{name}} ?',
    resetBody:
      "Un lien de réinitialisation valable 30 minutes vous sera remis à l'écran (et envoyé par e-mail si la messagerie est configurée). Les sessions de l'utilisateur restent ouvertes.",
    resetConfirm: 'Générer le lien',
    resendTitle: "Renvoyer l'invitation à {{name}} ?",
    resendBody:
      "Un nouveau lien d'activation valable 7 jours sera généré ; l'ancien lien cessera de fonctionner.",
    resendConfirm: 'Générer le lien',
    revokeTitle: 'Révoquer les sessions de {{name}} ?',
    revokeBody:
      "Toutes les sessions ouvertes seront fermées ; l'utilisateur devra se reconnecter. L'action est journalisée.",
    revokeConfirm: 'Révoquer les sessions',
  },
  toasts: {
    invited: 'Invitation envoyée à {{email}}.',
    invitedNoEmail: "Compte de {{email}} créé. Transmettez le lien d'activation.",
    updated: 'Utilisateur mis à jour.',
    deactivated: 'Compte désactivé.',
    activated: 'Compte réactivé.',
    passwordReset: 'Lien de réinitialisation envoyé par e-mail.',
    passwordResetNoEmail: 'Lien de réinitialisation généré. Transmettez-le vous-même.',
    sessionsRevoked: 'Sessions révoquées.',
    invitationResent: 'Invitation renvoyée par e-mail.',
    invitationResentNoEmail: "Nouveau lien d'activation généré. Transmettez-le vous-même.",
  },
  deliveryLink: {
    invitationTitle: "Lien d'activation",
    resetTitle: 'Lien de réinitialisation',
    recipient: 'Pour {{name}} ({{email}})',
    field: 'Lien à transmettre',
    expiresOn: 'expire le {{date}} à {{time}}',
    validFor: {
      minutes: 'Valable {{count}} minute ({{expiry}}).',
      minutes_other: 'Valable {{count}} minutes ({{expiry}}).',
      hours: 'Valable {{count}} heure ({{expiry}}).',
      hours_other: 'Valable {{count}} heures ({{expiry}}).',
      days: 'Valable {{count}} jour ({{expiry}}).',
      days_other: 'Valable {{count}} jours ({{expiry}}).',
    },
    expired: 'Lien expiré ({{expiry}}). Générez-en un nouveau.',
    copiedAnnouncement: 'Lien copié dans le presse-papiers.',
    manualCopy:
      'Copie automatique indisponible : le lien est sélectionné, copiez-le avec Ctrl+C (Cmd+C sur Mac).',
    emailSent: 'Un e-mail contenant ce lien a aussi été envoyé au destinataire.',
    noEmailTitle: 'Aucun e-mail envoyé (messagerie non configurée)',
    noEmailBody:
      "Transmettez ce lien vous-même, par un canal sûr (WhatsApp, en main propre). Ne l'envoyez pas à une autre personne : il donne accès au compte.",
  },
};

export const roles = {
  title: 'Rôles et permissions',
  subtitle:
    'Rôles système non modifiables et rôles personnalisés du tenant. Le serveur reste seul juge des autorisations.',
  create: 'Créer un rôle',
  columns: {
    role: 'Rôle',
    code: 'Code',
    users: 'Utilisateurs',
    permissions: 'Permissions',
    type: 'Type',
    actions: 'Actions',
  },
  system: 'Rôle système',
  custom: 'Personnalisé',
  readOnlyNotice:
    'Ce rôle système est fourni avec le produit : ses permissions sont en lecture seule. Dupliquez-le pour créer une variante.',
  usersCount: '{{count}} utilisateur',
  usersCount_other: '{{count}} utilisateurs',
  permissionsCount: '{{count}} permission',
  permissionsCount_other: '{{count}} permissions',
  drawer: {
    createTitle: 'Créer un rôle',
    editTitle: 'Modifier {{name}}',
    viewTitle: '{{name}}',
    name: 'Nom du rôle',
    code: 'Code technique',
    codeHint: 'Minuscules, chiffres et tirets bas ; non modifiable après création.',
    description: 'Description',
    permissions: 'Permissions',
    permissionsHint:
      "Cochez les actions autorisées. Les permissions marquées « sensible » déclenchent systématiquement un événement d'audit.",
    searchPermission: 'Filtrer les permissions',
    selectedCount: '{{count}} permission sélectionnée',
    selectedCount_other: '{{count}} permissions sélectionnées',
    selectAllDomain: 'Tout cocher',
    clearDomain: 'Tout décocher',
    submitCreate: 'Créer le rôle',
    submitEdit: 'Enregistrer',
  },
  sensitive: 'sensible',
  highPrivilege: 'haut privilège',
  domains: {
    tenant: 'Tenant et établissements',
    settings: 'Paramètres',
    user: 'Utilisateurs et rôles',
    resource: 'Ressources et tarifs',
    reservation: 'Réservations',
    customer: 'Clients',
    compliance: 'Conformité',
    document: 'Documents',
    proforma: 'Proformas',
    invoice: 'Factures',
    payment: 'Paiements',
    cash: 'Caisse',
    housekeeping: 'Ménage',
    maintenance: 'Maintenance',
    notification: 'Notifications',
    report: 'Rapports',
    audit: "Journal d'audit",
    platform: 'Plateforme',
  },
  systemRoles: {
    owner: 'Gérante (propriétaire)',
    manager: 'Manager',
    front_desk: 'Réception',
    accountant: 'Comptabilité',
    housekeeping: 'Ménage',
    waiter: 'Serveur',
    cashier: 'Caissier',
    kitchen: 'Cuisine',
    read_only: 'Lecture seule',
    platform_support: 'Support plateforme',
  },
  toasts: { created: 'Rôle créé.', updated: 'Rôle mis à jour.', deleted: 'Rôle supprimé.' },
  emptyTitle: 'Aucun rôle personnalisé',
  emptyBody: 'Créez un rôle pour ajuster finement les permissions de votre équipe.',
};

export const audit = {
  title: "Journal d'audit",
  subtitle:
    'Traçabilité append-only des actions sensibles : qui, quoi, quand, avant et après. Aucune ligne ne peut être modifiée ni supprimée.',
  columns: {
    occurredAt: 'Date',
    actor: 'Auteur',
    action: 'Action',
    entity: 'Entité',
    ip: 'IP',
    trace: 'Trace',
  },
  filters: {
    action: 'Action',
    entityType: 'Type d’entité',
    actor: 'Auteur',
    from: 'Du',
    to: 'Au',
    allActions: 'Toutes les actions',
    allEntities: 'Toutes les entités',
    allActors: 'Tous les auteurs',
    actorType: 'Type d’auteur',
    allActorTypes: 'Tous les types d’auteur',
  },
  actorSystem: 'Système',
  actorPlatform: 'Plateforme',
  actorTypes: { USER: 'Utilisateur', SYSTEM: 'Système', PLATFORM: 'Plateforme' },
  detailTitle: "Détail de l'événement",
  before: 'Avant',
  after: 'Après',
  noDiff: 'Aucune donnée détaillée pour cet événement.',
  reason: 'Motif',
  emptyTitle: 'Aucun événement',
  emptyBody: 'Aucune action ne correspond aux filtres sélectionnés.',
  actions: {
    'auth.login': 'Connexion',
    'auth.login_failed': 'Échec de connexion',
    'auth.logout': 'Déconnexion',
    'user.invite': "Invitation d'un utilisateur",
    'user.update': "Modification d'un utilisateur",
    'user.deactivate': "Désactivation d'un compte",
    'role.create': "Création d'un rôle",
    'role.update': "Modification d'un rôle",
    'role.delete': "Suppression d'un rôle",
    'role.assign': "Attribution d'un rôle",
    'tenant.update': 'Modification de la fiche tenant',
    'property.create': "Création d'un établissement",
    'property.update': "Modification d'un établissement",
    'session.revoke': 'Révocation de sessions',
    'mfa.enable': 'Activation de la double authentification',
    'mfa.disable': 'Désactivation de la double authentification',
    'password.reset': 'Réinitialisation de mot de passe',
    'support.access.requested': 'Demande d’accès support',
    'support.access.approved': 'Accès support approuvé',
    'support.access.declined': 'Accès support refusé',
    'support.access.cancelled': 'Demande d’accès support retirée',
    'support.access.entered': 'Entrée du support (lecture seule)',
    'support.access.left': 'Sortie du support',
    'support.access.revoked': 'Accès support révoqué',
    'support.access.expired': 'Accès support expiré',
  },
};

export const settings = {
  title: 'Établissement & paramètres',
  subtitle:
    'Identité de la société, mentions légales des documents, coordonnées bancaires, marque et horaires des établissements.',
  tabs: {
    identity: 'Identité',
    legal: 'Mentions légales',
    bank: 'Banque',
    branding: 'Marque',
    properties: 'Établissements',
    resourceCatalog: 'Types de ressources & caractéristiques',
    compliance: 'Conformité',
    billing: 'Facturation',
    modules: 'Modules',
    subscription: 'Abonnement',
  },
  modules: {
    subscriptionCard: 'Abonnement',
    planNotice:
      'Les modules inclus dans votre abonnement sont activés pour toute l’organisation ; vous pouvez les désactiver établissement par établissement. Pour ajouter un module, contactez HOREVIA.',
    noSubscription:
      'Aucun abonnement actif : les modules métier sont inaccessibles. Contactez HOREVIA.',
    since: 'Depuis le {{date}}',
    dependsOn: 'Nécessite : {{modules}}',
    toggleFor: '{{module}} pour {{property}}',
    goToSettings: 'Voir les modules',
    status: {
      TRIAL: 'Essai',
      ACTIVE: 'Actif',
      PAST_DUE: 'Paiement en retard',
      SUSPENDED: 'Suspendu',
      CANCELLED: 'Résilié',
    },
    state: {
      enabled: 'Activé',
      inPlan: 'Inclus, non activé',
      notSubscribed: 'Non souscrit',
      comingSoon: 'Bientôt disponible',
    },
    names: {
      hotel: 'Horevia Hotel',
      restaurant: 'Horevia Restaurant',
      bar: 'Horevia Bar',
      pos: 'Horevia POS',
      inventory: 'Horevia Inventory',
      crm: 'Horevia CRM',
      analytics: 'Horevia Analytics',
      housekeeping: 'Horevia Housekeeping',
      booking: 'Horevia Booking',
      pay: 'Horevia Pay',
    },
    toasts: {
      enabled: 'Module activé pour l’établissement.',
      disabled: 'Module désactivé pour l’établissement.',
    },
  },
  identity: {
    card: 'Identité de la société',
    legalName: 'Raison sociale',
    tradeName: 'Nom commercial',
    country: 'Pays',
    currency: 'Devise',
    timezone: 'Fuseau horaire',
    locale: 'Langue par défaut',
    email: 'E-mail de contact',
    phone: 'Téléphone',
    website: 'Site web',
    addressLine1: 'Adresse',
    addressLine2: "Complément d'adresse",
    poBox: 'Boîte postale',
    city: 'Ville',
  },
  legal: {
    card: 'Mentions légales des factures',
    hint: 'Ces informations sont figées dans chaque facture au moment de son émission (snapshot émetteur).',
    rccm: 'RCCM',
    ifu: 'IFU',
    taxRegime: 'Régime fiscal',
    taxDivision: 'Division fiscale',
    legalForm: 'Forme juridique',
    activity: 'Activité',
    activityHint:
      'Ligne affichée sous le nom de l’établissement en tête des factures, proformas, avoirs et reçus.',
  },
  bank: {
    card: 'Coordonnées bancaires',
    bankName: 'Banque',
    accountNumber: 'Numéro de compte',
    iban: 'IBAN',
    swift: 'Code SWIFT / BIC',
  },
  branding: {
    card: 'Marque et documents',
    primaryColor: 'Couleur principale',
    secondaryColor: 'Couleur secondaire',
    documentSignatory: 'Signataire des documents',
    logo: {
      card: 'Logo des documents',
      description:
        'Affiché en tête des factures, proformas, avoirs, reçus, tickets de caisse et confirmations de réservation. Sans logo, seul le nom de l’établissement apparaît.',
      preview: 'Logo du tenant',
      none: 'Aucun logo déposé.',
      dropTitle: 'Déposer un logo',
      dropHint: 'PNG, JPEG ou WebP · 512 Ko maximum · 16 à 4000 px de côté',
      browse: 'Choisir un fichier',
      remove: 'Retirer le logo',
      removeConfirm: 'Les documents rendus ensuite ne porteront plus de logo. Continuer ?',
    },
  },
  properties: {
    card: 'Établissements',
    name: 'Nom',
    code: 'Code',
    checkinFrom: 'Check-in à partir de',
    checkoutUntil: 'Check-out au plus tard',
    timezone: 'Fuseau',
    active: 'Actif',
    inactive: 'Inactif',
    hint: 'Décision D-021 : check-in à partir de 12:00, check-out au plus tard 12:00.',
    edit: "Modifier l'établissement",
    activities: 'Activités',
    activity: {
      HOTEL: 'Hôtel',
      RESTAURANT: 'Restaurant',
      BAR: 'Bar',
      OTHER: 'Autre',
    },
  },
  toasts: {
    tenantUpdated: 'Fiche tenant enregistrée.',
    propertyUpdated: 'Établissement enregistré.',
    logoUpdated: 'Logo enregistré.',
    logoRemoved: 'Logo retiré.',
  },
  readOnlyNotice: 'Vous consultez ces paramètres en lecture seule.',
};

export const profile = {
  title: 'Mon profil',
  subtitle: 'Vos informations, votre sécurité et vos sessions.',
  identityCard: 'Informations personnelles',
  passwordCard: 'Mot de passe',
  mfaCard: 'Double authentification',
  notifications: {
    title: 'Notifications',
    body: 'Choisissez, pour chaque sujet, les canaux qui vous alertent. Le canal interne alimente la cloche de la barre supérieure ; le canal e-mail envoie un message.',
    caption: 'Canaux de notification par sujet',
    topic: 'Sujet',
    internal: 'Interne',
    email: 'E-mail',
    internalAria: 'Notification interne — {{topic}}',
    emailAria: 'Notification par e-mail — {{topic}}',
    digestHour: 'Heure du récapitulatif quotidien',
    saved: 'Préférences de notification enregistrées.',
    topics: {
      RESERVATION_TO_CONFIRM: 'Réservation à confirmer',
      OPTION_EXPIRING: 'Option qui expire',
      ARRIVAL_TODAY: 'Arrivée du jour',
      DEPARTURE_TODAY: 'Départ du jour',
      DOCUMENT_MISSING: 'Document de conformité manquant',
      PAYMENT_OVERDUE: 'Paiement en retard',
      INVOICE_UNPAID: 'Facture impayée',
      RESERVATION_CANCELLED: 'Réservation annulée',
      MAINTENANCE: 'Maintenance et incidents',
      CASH_VARIANCE: 'Écart de caisse',
      DAILY_DIGEST: 'Récapitulatif quotidien',
      SUPPORT_ACCESS_REQUESTED: 'Demande d’accès support',
      SUBSCRIPTION_INVOICE: 'Facture d’abonnement HOREVIA',
      SUBSCRIPTION_OVERDUE: 'Retard d’abonnement HOREVIA',
    },
  },
  sessionsCard: 'Sessions actives',
  currentPassword: 'Mot de passe actuel',
  newPassword: 'Nouveau mot de passe',
  confirmPassword: 'Confirmer le nouveau mot de passe',
  changePassword: 'Changer le mot de passe',
  mfaEnabled: 'Activée',
  mfaDisabled: 'Désactivée',
  mfaEnabledBody:
    "Un code à 6 chiffres est demandé à chaque connexion depuis votre application d'authentification.",
  mfaDisabledBody:
    'Renforcez la sécurité de votre compte : la double authentification est recommandée pour les rôles Gérante et Comptabilité.',
  enableMfa: 'Activer la double authentification',
  disableMfa: 'Désactiver',
  mfaSetupTitle: 'Activer la double authentification',
  mfaSetupStep1: "1. Scannez ce QR code avec votre application d'authentification (TOTP).",
  mfaSetupStep2: '2. Saisissez le code à 6 chiffres affiché pour confirmer.',
  mfaSecret: 'Clé de secours (si le scan est impossible)',
  mfaDisableTitle: 'Désactiver la double authentification',
  mfaDisableBody:
    'Confirmez avec votre mot de passe et un code valide. Cette action est journalisée.',
  revokeOthers: 'Déconnecter les autres sessions',
  device: 'Appareil',
  ip: 'Adresse IP',
  lastSeen: 'Dernière activité',
  current: 'Session courante',
  toasts: {
    passwordChanged: 'Mot de passe modifié.',
    mfaEnabled: 'Double authentification activée.',
    mfaDisabled: 'Double authentification désactivée.',
    sessionRevoked: 'Session déconnectée.',
    othersRevoked: 'Les autres sessions ont été déconnectées.',
    profileUpdated: 'Profil mis à jour.',
  },
};

export const resources = {
  title: 'Ressources',
  subtitle:
    'Hébergements et salles de l’établissement : inventaire, tarifs, blocages et composition.',
  create: 'Nouvelle ressource',
  searchLabel: 'Rechercher une ressource',
  searchPlaceholder: 'Nom ou référence (110, F3…)',
  countLabel: '{{count}} ressource',
  countLabel_other: '{{count}} ressources',
  subCountLabel: '{{count}} sous-ressource',
  subCountLabel_other: '{{count}} sous-ressources',
  filters: {
    all: 'Toutes',
    allTypes: 'Tous les types',
    property: 'Établissement',
    type: 'Type',
    showInactive: 'Afficher les ressources archivées',
    active: 'Actives',
    archived: 'Archivées',
  },
  kpi: {
    total: 'Ressources actives',
    totalFoot: 'dont {{count}} sous-ressource',
    totalFoot_other: 'dont {{count}} sous-ressources',
    capacity: 'Capacité totale',
    capacityFoot: 'personnes hébergeables simultanément',
    blocked: 'Indisponibles',
    blockedFoot: 'maintenance ou blocage en cours',
    averageRate: 'Tarif moyen / nuit',
    averageRateFoot: 'sur les hébergements actifs',
  },
  card: {
    capacity: '{{standard}} pers. (max. {{max}})',
    floorGround: 'Rez-de-chaussée',
    floorFirst: '1er étage',
    floorOther: '{{count}}e étage',
    noRate: 'Aucun tarif par défaut',
    parent: 'Ressource parente',
    child: 'Sous-ressource',
    childOf: 'Sous-ressource de {{name}}',
    archived: 'Archivée',
    open: 'Ouvrir la fiche',
    rooms: '{{count}} chambre',
    rooms_other: '{{count}} chambres',
  },
  emptyTitle: 'Aucune ressource enregistrée',
  emptyBody:
    'Créez les chambres, appartements et salles de l’établissement pour alimenter le calendrier et les réservations.',
  emptySearchTitle: 'Aucune ressource ne correspond',
  emptySearchBody: 'Modifiez la recherche ou effacez les filtres pour retrouver l’inventaire.',
  compositeNotice: {
    title: 'Appartements F3 et chambres : des ressources liées',
    body: 'Les appartements F3 – 112 et F3 – 212 se louent en entier ou chambre par chambre. Les deux options s’excluent : réserver l’appartement entier rend ses chambres indisponibles, réserver une chambre seule rend l’appartement entier indisponible. Le contrôle est appliqué côté serveur (ADR-013).',
  },
  status: {
    label: 'Statut opérationnel',
    change: 'Changer le statut',
    AVAILABLE: 'Disponible',
    OCCUPIED: 'Occupé',
    DIRTY: 'Sale',
    CLEANING: 'Nettoyage',
    READY: 'Prêt',
    MAINTENANCE: 'Maintenance',
    BLOCKED: 'Bloqué',
  },
  category: { LODGING: 'Hébergement', SPACE: 'Espace' },
  actions: {
    edit: 'Modifier la ressource',
    archive: 'Archiver',
    archiveTitle: 'Archiver « {{name}} » ?',
    archiveBody:
      'La ressource disparaît du calendrier et des recherches de disponibilité. Les réservations passées et les factures sont conservées. L’archivage est refusé si une réservation ou un blocage futur existe.',
    archiveConfirm: 'Archiver la ressource',
  },
  toasts: {
    created: 'Ressource « {{name}} » créée.',
    updated: 'Ressource mise à jour.',
    statusChanged: 'Statut mis à jour : {{status}}.',
    archived: 'Ressource archivée.',
    ratePlanCreated: 'Tarif « {{name}} » ajouté.',
    ratePlanUpdated: 'Tarif mis à jour.',
    ratePlanDeleted: 'Tarif supprimé.',
    blockCreated: 'Blocage créé.',
    blockUpdated: 'Blocage modifié.',
    blockDeleted: 'Blocage supprimé.',
    feedCreated: 'Flux iCal ajouté.',
    feedSynced: 'Synchronisation terminée.',
    feedDeleted: 'Flux iCal supprimé.',
    typeRenamed: 'Type de ressource renommé.',
    amenitySaved: 'Caractéristique enregistrée.',
  },
  drawer: {
    createTitle: 'Nouvelle ressource',
    editTitle: 'Modifier « {{name}} »',
    subtitle: 'Inventaire et tarifs publics de l’établissement',
    sectionIdentity: 'Identification',
    sectionCapacity: 'Capacité et surface',
    sectionAmenities: 'Caractéristiques',
    sectionDuration: 'Durées de séjour',
    sectionNotes: 'Notes internes',
    submitCreate: 'Créer la ressource',
    submitEdit: 'Enregistrer les modifications',
    amenitiesHint:
      'Les caractéristiques cochées alimentent les filtres de disponibilité et le descriptif repris sur la proforma et la facture.',
    parentHint: 'Une sous-ressource et sa ressource parente s’excluent mutuellement (ADR-013).',
    parentNone: 'Aucune — ressource autonome',
    refHint: 'Référence interne courte, par exemple 110 ou 112-GC.',
    bedroomsHint: '0 pour un studio ou une salle de réunion.',
    durationHint: 'Nombre de nuits (ou d’unités) minimal et maximal acceptés.',
  },
  fields: {
    name: 'Nom de la ressource',
    internalRef: 'Référence',
    type: 'Type',
    floor: 'Étage',
    capacityStandard: 'Capacité standard',
    capacityMax: 'Capacité maximale',
    bedrooms: 'Nombre de chambres',
    bathrooms: 'Salles de bain',
    surface: 'Surface',
    description: 'Description',
    parent: 'Fait partie de',
    minDuration: 'Durée minimale',
    maxDuration: 'Durée maximale',
    internalNotes: 'Notes internes',
    persons: 'pers.',
    nights: 'nuits',
  },
  detail: {
    back: 'Retour aux ressources',
    tabs: {
      information: 'Informations',
      rates: 'Tarifs',
      blocks: 'Blocages',
      composition: 'Composition',
      photos: 'Photos',
    },
    identity: 'Identification',
    features: 'Caractéristiques',
    noAmenities: 'Aucune caractéristique renseignée.',
    openingHours: 'Horaires d’ouverture',
    noOpeningHours: 'Aucune contrainte horaire.',
    notFoundTitle: 'Ressource introuvable',
    notFoundBody:
      'Cette ressource a peut-être été archivée ou n’appartient pas à cet établissement.',
    photosSoon: 'Galerie photos bientôt disponible',
    photosSoonBody:
      'Le téléversement des photos (avec vignettes et légendes) arrive avec le module Documents. Les descriptions saisies ici sont déjà reprises sur les proformas.',
  },
  rates: {
    title: 'Plans tarifaires',
    add: 'Nouveau tarif',
    edit: 'Modifier le tarif',
    empty: 'Aucun tarif défini',
    emptyBody: 'Ajoutez au moins un tarif par défaut pour que la ressource soit réservable.',
    columns: {
      name: 'Tarif',
      unit: 'Unité',
      price: 'Prix',
      validity: 'Validité',
      segment: 'Segment',
      status: 'Statut',
    },
    default: 'Par défaut',
    inactive: 'Inactif',
    always: 'Sans limite',
    from: 'À partir du {{date}}',
    until: 'Jusqu’au {{date}}',
    deleteTitle: 'Supprimer le tarif « {{name}} » ?',
    deleteBody: 'Les réservations déjà créées conservent le prix qui leur a été appliqué.',
    fields: {
      name: 'Nom du tarif',
      unit: 'Unité de tarification',
      price: 'Prix',
      validFrom: 'Valide à partir du',
      validTo: 'Valide jusqu’au',
      minQuantity: 'Quantité minimale',
      segment: 'Segment client',
      isDefault: 'Tarif par défaut de la ressource',
      isActive: 'Tarif actif',
    },
    units: {
      NIGHT: 'Nuit',
      WEEK: 'Semaine',
      MONTH: 'Mois',
      HOUR: 'Heure',
      HALF_DAY: 'Demi-journée',
      DAY: 'Journée',
      PACKAGE: 'Forfait',
    },
    perUnit: {
      NIGHT: '/ nuit',
      WEEK: '/ semaine',
      MONTH: '/ mois',
      HOUR: '/ heure',
      HALF_DAY: '/ demi-journée',
      DAY: '/ journée',
      PACKAGE: '/ forfait',
    },
    segments: { PUBLIC: 'Public', CORPORATE: 'Entreprise' },
  },
  composition: {
    title: 'Composition et unités d’inventaire',
    ruleTitle: 'Règle d’exclusion mutuelle (ADR-013)',
    ruleBody:
      'Réserver une ressource verrouille chacune de ses unités d’inventaire pour la période. Une ressource composée reprend les unités de ses sous-ressources : l’appartement entier et ses chambres ne peuvent donc jamais être réservés en même temps. Deux chambres du même appartement restent en revanche louables à deux clients différents.',
    units: 'Unités d’inventaire verrouillées',
    children: 'Sous-ressources',
    noChildren: 'Cette ressource n’a pas de sous-ressource.',
    parentOf: 'Cette ressource est une sous-ressource de {{name}}.',
    unitCode: 'Code',
    unitName: 'Unité',
  },
  types: {
    title: 'Types de ressources',
    subtitle: 'Référentiel des types utilisés par l’inventaire et les tarifs.',
    columns: {
      code: 'Code',
      name: 'Libellé',
      category: 'Catégorie',
      unit: 'Unité par défaut',
      count: 'Ressources',
    },
    rename: 'Renommer',
    renameTitle: 'Renommer le type « {{name}} »',
    renameHint:
      'Le code technique ({{code}}) ne change pas : il est utilisé par l’API et les rapports.',
    system: 'Type système',
  },
  amenitiesAdmin: {
    title: 'Catalogue de caractéristiques',
    subtitle: 'Cases proposées lors de la création d’une ressource, et filtres de disponibilité.',
    add: 'Ajouter une caractéristique',
    addTitle: 'Nouvelle caractéristique',
    columns: { code: 'Code', label: 'Libellé', usage: 'Ressources', status: 'Activée' },
    codeHint: 'Majuscules et tirets bas, par exemple PISCINE ou SALLE_SPORT.',
    usage: '{{count}} ressource',
    usage_other: '{{count}} ressources',
    active: 'Activée',
    inactive: 'Désactivée',
  },
};

export const calendar = {
  title: 'Calendrier',
  subtitle: '{{resources}} et {{children}} · du {{from}} au {{to}}',
  today: "Aujourd'hui",
  previous: 'Période précédente',
  next: 'Période suivante',
  datePicker: 'Aller à la date',
  resourceColumn: 'Ressource',
  views: {
    label: 'Type de vue',
    day: 'Jour',
    week: 'Semaine',
    month: 'Mois',
    timeline: 'Timeline',
  },
  ranges: { label: 'Densité', 7: '7 jours', 14: '14 jours', 30: '30 jours' },
  monthSoonTitle: 'Vue mensuelle bientôt disponible',
  monthSoonBody:
    'La grille mensuelle (taux d’occupation par jour, arrivées et départs) arrive avec le module Réservations. Utilisez la timeline 30 jours pour couvrir un mois complet.',
  monthUseTimeline: 'Afficher 30 jours en timeline',
  filters: { type: 'Type de ressource', allTypes: 'Toutes les ressources' },
  expandGroup: 'Afficher les sous-ressources de {{name}}',
  collapseGroup: 'Masquer les sous-ressources de {{name}}',
  legend: {
    label: 'Légende',
    confirmed: 'Confirmée',
    checkedin: 'En séjour',
    option: 'Option',
    pending: 'À confirmer',
    maintenance: 'Maintenance',
    blocked: 'Blocage',
    unavailable: 'Indisponible — appartement / chambre liés',
    hint: 'Sélectionnez une barre pour voir le détail et les actions.',
  },
  unavailable: {
    label: 'Indisponible',
    parentBooked: 'Appartement réservé en entier',
    childBooked: 'Chambre réservée séparément',
    origin: 'À cause de {{name}}',
  },
  block: { label: 'Blocage', maintenance: 'Maintenance' },
  month: { caption: 'Occupation du mois, une cellule par ressource et par jour' },
  popover: {
    period: 'Période',
    resource: 'Ressource',
    reason: 'Motif',
    kind: 'Nature',
    status: 'Statut',
    origin: 'Origine',
    createBlock: 'Créer un blocage',
    openResource: 'Voir la ressource',
    openReservation: 'Ouvrir la réservation',
    checkIn: 'Effectuer le check-in',
    confirm: 'Confirmer la réservation',
    close: 'Fermer le détail',
  },
  selection: {
    title: 'Que souhaitez-vous créer ?',
    description: '{{resource}} · {{period}}',
    newReservation: 'Nouvelle réservation',
    newBlock: 'Nouveau blocage',
    cancel: 'Annuler la sélection',
    laneLabel: 'Sélectionner une période sur {{name}}',
  },
  emptyTitle: 'Aucune ressource à afficher',
  emptyBody: 'Créez une ressource ou modifiez le filtre de type pour alimenter le planning.',
  mobile: { dayLabel: 'Journée du {{date}}', free: 'Libre', events: 'Événements' },
  barLabel: '{{label}} — {{resource}} — du {{from}} au {{to}}',
};

export const availability = {
  title: 'Disponibilités',
  subtitle:
    'Vérifiez en une recherche quelles ressources sont libres sur une période, y compris les chambres liées à un appartement.',
  search: 'Rechercher',
  searching: 'Recherche…',
  form: {
    title: 'Critères de recherche',
    from: 'Arrivée',
    to: 'Départ',
    fromTime: 'Heure d’arrivée',
    toTime: 'Heure de départ',
    type: 'Type de ressource',
    anyType: 'Tous les types',
    capacity: 'Personnes',
    capacityHint: 'Laisser vide pour ignorer la capacité.',
    reset: 'Réinitialiser',
  },
  results: {
    title: 'Résultats',
    availableCount: '{{count}} ressource disponible',
    availableCount_other: '{{count}} ressources disponibles',
    unavailableCount: '{{count}} indisponible',
    unavailableCount_other: '{{count}} indisponibles',
    available: 'Disponible',
    unavailable: 'Indisponible',
    nights: '{{count}} nuit',
    nights_other: '{{count}} nuits',
    estimate: 'Estimation : {{amount}}',
    book: 'Réserver (bientôt)',
    block: 'Bloquer',
    conflictsTitle: 'Conflits sur la période',
    conflictFrom: 'du {{from}} au {{to}}',
    conflictReservation: 'Réservation sur {{resource}}',
    conflictBlock: 'Blocage sur {{resource}}',
    conflictParent: 'La ressource parente {{resource}} est occupée sur la période.',
    conflictChild: 'La sous-ressource {{resource}} est occupée sur la période.',
    conflictSelf: '{{resource}} est déjà occupée sur la période.',
    unit: 'Unité {{code}}',
  },
  emptyTitle: 'Lancez une recherche',
  emptyBody:
    'Choisissez une période, éventuellement un type et une capacité : les ressources libres apparaissent en vert avec leur tarif.',
  noResultTitle: 'Aucune ressource ne correspond',
  noResultBody: 'Élargissez la période, réduisez la capacité demandée ou changez de type.',
  invalidRange: 'La date de départ doit être postérieure à la date d’arrivée.',
};

export const maintenance = {
  title: 'Maintenance & blocages',
  subtitle:
    'Blocages d’inventaire (maintenance, usage propriétaire, fermeture) et flux iCal importés des plateformes externes.',
  create: 'Nouveau blocage',
  columns: {
    resource: 'Ressource',
    kind: 'Nature',
    period: 'Période',
    reason: 'Motif',
    createdBy: 'Créé par',
    actions: 'Actions',
  },
  kinds: {
    label: 'Nature du blocage',
    MAINTENANCE: 'Maintenance',
    ADMIN: 'Administratif',
    OWNER: 'Usage propriétaire',
    CLOSURE: 'Fermeture',
    EXTERNAL: 'Importé (iCal)',
  },
  filters: {
    all: 'Tous',
    resource: 'Ressource',
    allResources: 'Toutes les ressources',
    period: 'Période',
    upcoming: 'À venir',
    current: 'En cours',
    past: 'Passés',
  },
  emptyTitle: 'Aucun blocage enregistré',
  emptyBody:
    'Créez un blocage pour retirer une ressource de la vente pendant des travaux, une fermeture ou un usage propriétaire.',
  emptyFilteredTitle: 'Aucun blocage ne correspond',
  emptyFilteredBody: 'Effacez les filtres pour voir l’ensemble des blocages.',
  drawer: {
    createTitle: 'Nouveau blocage',
    editTitle: 'Modifier le blocage',
    subtitle: 'Le blocage retire la ressource de la vente sur la période, comme une réservation.',
    resource: 'Ressource',
    startDate: 'Début',
    startTime: 'Heure de début',
    endDate: 'Fin',
    endTime: 'Heure de fin',
    reason: 'Motif',
    reasonPlaceholder: 'Ex. Remplacement du climatiseur — prestataire Nikiéma Froid.',
    reasonHint: 'Le motif est repris dans le calendrier et le journal d’audit.',
    submitCreate: 'Créer le blocage',
    submitEdit: 'Enregistrer',
    externalReadOnly:
      'Ce blocage provient d’un flux iCal externe : il est mis à jour à chaque synchronisation et ne se modifie pas ici.',
  },
  conflict: {
    title: 'Période indisponible',
    body: 'Une réservation ou un blocage occupe déjà une unité de cette ressource. Choisissez une autre période ou libérez la ressource concernée.',
    detail: '{{resource}} — du {{from}} au {{to}}',
  },
  delete: {
    title: 'Supprimer le blocage ?',
    body: 'La ressource redevient disponible sur la période. L’action est tracée dans le journal d’audit.',
    confirm: 'Supprimer le blocage',
  },
  ical: {
    title: 'Flux iCal',
    subtitle:
      'Importez les réservations Booking.com ou Airbnb comme blocages, pour éviter les doubles réservations.',
    add: 'Ajouter un flux',
    addTitle: 'Nouveau flux iCal',
    sync: 'Synchroniser maintenant',
    syncing: 'Synchronisation…',
    columns: {
      resource: 'Ressource',
      source: 'Plateforme',
      lastSync: 'Dernière synchro',
      status: 'Statut',
    },
    sources: { BOOKING_COM: 'Booking.com', AIRBNB: 'Airbnb', OTHER: 'Autre plateforme' },
    urlLabel: 'URL du flux (.ics)',
    urlHint: 'Copiez l’adresse d’export du calendrier depuis la plateforme.',
    never: 'Jamais synchronisé',
    ok: 'Synchronisé',
    error: 'Échec',
    imported: '{{count}} blocage importé',
    imported_other: '{{count}} blocages importés',
    empty: 'Aucun flux iCal configuré',
    emptyBody:
      'Ajoutez l’URL d’export d’un calendrier Booking.com ou Airbnb pour synchroniser les indisponibilités.',
    deleteTitle: 'Supprimer le flux ?',
    deleteBody: 'Les blocages déjà importés sont conservés jusqu’à leur date de fin.',
  },
};

export const errors = {
  VALIDATION_ERROR: 'Certaines informations sont invalides. Corrigez les champs signalés.',
  UNAUTHENTICATED: 'Vous devez être connecté pour effectuer cette action.',
  SESSION_EXPIRED: 'Votre session a expiré. Reconnectez-vous.',
  MFA_REQUIRED: 'Une vérification en deux étapes est nécessaire.',
  INVALID_CREDENTIALS: 'Adresse e-mail ou mot de passe incorrect.',
  ACCOUNT_LOCKED: 'Compte temporairement verrouillé. Réessayez dans quelques minutes.',
  ACCOUNT_DISABLED: 'Ce compte est désactivé.',
  CSRF_TOKEN_INVALID: 'Session invalide. Rechargez la page et réessayez.',
  PERMISSION_DENIED: "Vous n'avez pas la permission d'effectuer cette action.",
  NOT_FOUND: "L'élément demandé est introuvable.",
  CONFLICT: 'Cette opération entre en conflit avec l’état actuel des données.',
  OPTIMISTIC_LOCK_CONFLICT:
    'Cette fiche a été modifiée entre-temps. Rechargez la page pour repartir de la dernière version.',
  EMAIL_ALREADY_USED: 'Cette adresse e-mail est déjà utilisée par un autre compte.',
  ROLE_IN_USE: 'Ce rôle est attribué à des utilisateurs : retirez-le avant de le supprimer.',
  SYSTEM_ROLE_IMMUTABLE: 'Les rôles système ne peuvent pas être modifiés.',
  PASSWORD_POLICY_VIOLATION: 'Ce mot de passe ne respecte pas la politique de sécurité.',
  INVITATION_INVALID: 'Cette invitation est invalide ou a expiré.',
  TOKEN_INVALID: 'Ce lien est invalide ou a expiré.',
  PERMISSION_ESCALATION:
    'Vous ne pouvez pas accorder une permission que vous ne détenez pas vous-même.',
  RESOURCE_NOT_AVAILABLE:
    'Cette ressource n’est pas disponible sur la période demandée : une réservation ou un blocage occupe déjà l’une de ses unités.',
  RESERVATION_INVALID_TRANSITION:
    'L’état actuel de la réservation ne permet pas cette action. Rechargez la fiche.',
  DEPOSIT_REQUIRED:
    'Une avance est requise pour confirmer cette réservation (D-020). Un motif est exigé pour y déroger.',
  BALANCE_DUE:
    'Le check-out avec solde restant dû nécessite une permission dédiée et un motif (R-010).',
  PAYMENT_EXCEEDS_BALANCE: 'Le montant saisi dépasse le solde restant dû.',
  PAYMENT_ALREADY_REVERSED: 'Ce paiement a déjà été annulé.',
  IDEMPOTENCY_KEY_REUSED:
    'Cette opération a déjà été enregistrée avec des informations différentes. Rechargez la page avant de recommencer.',
  PAYMENT_ALLOCATION_EXCEEDS_AMOUNT:
    'La somme des affectations dépasse le montant du paiement. Ajustez la répartition.',
  REFUND_EXCEEDS_PAYMENT:
    'Le remboursement dépasse le montant encore disponible sur cet encaissement.',
  CASH_SESSION_ALREADY_OPEN: 'Une session de caisse est déjà ouverte pour cet établissement.',
  CASH_SESSION_NOT_OPEN: 'Ouvrez une session de caisse pour enregistrer un règlement en espèces.',
  ORDER_INVALID_TRANSITION: 'Opération impossible dans l’état actuel de la commande.',
  ORDER_HAS_PAYMENTS:
    'Des paiements sont enregistrés : annulez-les ou remboursez-les avant d’annuler la commande.',
  TABLE_OCCUPIED: 'Cette table a déjà une commande ouverte.',
  PAYMENT_METHOD_NOT_ACCEPTED: 'Ce moyen de paiement n’est pas accepté par ce point de vente.',
  TAB_NAME_IN_USE: 'Une note ouverte porte déjà ce nom à ce point de vente.',
  PRODUCT_UNAVAILABLE: 'Ce produit n’est pas disponible à la vente.',
  STAY_NOT_IN_HOUSE:
    'Ce séjour n’est pas en cours : seule une réservation en check-in reçoit des charges.',
  STAY_PROPERTY_MISMATCH: 'Ce séjour n’appartient pas à l’établissement du point de vente.',
  FOLIO_CLOSED: 'Le folio de ce séjour est clos (check-out effectué) : plus aucune charge.',
  FOLIO_CHARGE_VOIDED: 'Cette charge est déjà annulée.',
  STOCK_CODE_IN_USE: 'Ce code est déjà utilisé dans cet établissement.',
  STOCK_LOCATION_MISMATCH:
    'Le lieu, l’article ou le point de vente n’appartient pas à cet établissement, ou est inactif.',
  STOCK_PURCHASE_NOT_DRAFT: 'Ce bon d’achat n’est plus un brouillon.',
  STOCK_COUNT_ALREADY_OPEN: 'Un inventaire est déjà ouvert sur ce lieu.',
  STOCK_COUNT_NOT_OPEN: 'Cet inventaire n’est plus ouvert.',
  TENANT_SUSPENDED:
    'Le compte de votre organisation est suspendu. Contactez la plateforme HOREVIA.',
  PLATFORM_MFA_REQUIRED:
    'La console plateforme exige la double authentification : activez-la dans votre profil.',
  TENANT_SLUG_IN_USE: 'Cet identifiant de tenant est déjà utilisé.',
  TENANT_INVALID_TRANSITION: 'Ce changement de statut est impossible dans l’état actuel du tenant.',
  PLAN_LIMIT_REACHED:
    'Limite du plan atteinte : augmentez votre abonnement pour ajouter cet élément.',
  SUBSCRIPTION_BILLING_INCOMPLETE:
    'Un abonnement facturé exige une périodicité, un prix et, en essai, une date de fin d’essai.',
  SUBSCRIPTION_INVOICE_INVALID_TRANSITION:
    'Cette opération est impossible dans l’état actuel de la facture d’abonnement.',
  SUBSCRIPTION_PAYMENT_EXCEEDS_BALANCE: 'Le règlement dépasse le solde restant de la facture.',
  CASH_SESSION_CLOSED: 'Cette session de caisse est clôturée : elle n’accepte plus de mouvement.',
  RATE_LIMITED: 'Trop de tentatives. Patientez quelques instants.',
  UPLOAD_TOO_LARGE: 'Fichier trop volumineux. Réduisez la taille du document.',
  UPLOAD_UNSUPPORTED_TYPE:
    'Format non pris en charge. Utilisez une photo (JPEG, PNG, WebP, HEIC) ou un PDF.',
  INVOICE_COMPLIANCE_DOCUMENTS_MISSING:
    'Facture définitive bloquée : des documents obligatoires manquent au dossier (R-001).',
  INVOICE_IMMUTABLE: 'Une facture émise est immuable : passez par un avoir.',
  INVOICE_ALREADY_EXISTS: 'Une facture définitive existe déjà pour cette réservation.',
  BILLING_DOCUMENT_NOT_EDITABLE:
    'Ce document n’est plus au brouillon : son contenu ne peut plus être modifié.',
  PROFORMA_NOT_ISSUED:
    'Cette proforma doit d’abord être émise puis acceptée avant d’être convertie en facture.',
  CREDIT_NOTE_EXCEEDS_INVOICE:
    'Le montant de l’avoir dépasse le net à payer de la facture d’origine.',
  NOT_IMPLEMENTED: 'Cette fonctionnalité n’est pas encore disponible.',
  INTERNAL_ERROR: 'Une erreur interne est survenue. Réessayez plus tard.',
  NETWORK_ERROR: 'Le serveur est injoignable. Vérifiez votre connexion.',
  MALFORMED_RESPONSE: "La réponse du serveur ne respecte pas le contrat de l'API.",
};

export const customers = {
  create: 'Nouveau client',
  countLabel: '{{count}} client',
  countLabel_other: '{{count}} clients',
  archived: 'Archivé',
  never: 'Jamais',
  searchLabel: 'Rechercher un client',
  searchPlaceholderPeople: 'Nom, téléphone, e-mail ou n° de pièce d’identité',
  searchPlaceholderCompanies: 'Raison sociale, IFU ou RCCM',
  emptyTitle: 'Aucun client',
  emptyBody: 'Créez une fiche client pour enregistrer une réservation à son nom.',
  emptySearchTitle: 'Aucun client ne correspond',
  emptySearchBody: 'Modifiez la recherche ou affichez les fiches archivées.',
  kind: { PERSON: 'Personne physique', COMPANY: 'Personne morale' },
  gender: { M: 'Monsieur', F: 'Madame', UNSPECIFIED: 'Non précisé' },
  idDocument: {
    CNIB: 'CNIB',
    PASSPORT: 'Passeport',
    RESIDENCE_PERMIT: 'Carte de séjour',
    DRIVING_LICENSE: 'Permis de conduire',
    OTHER: 'Autre pièce',
  },
  membershipRole: {
    EMPLOYEE: 'Employé',
    MANAGER: 'Dirigeant',
    BILLING_CONTACT: 'Contact facturation',
    OTHER: 'Autre',
  },
  people: {
    title: 'Personnes physiques',
    subtitle:
      'Occupants des logements : identité, pièce d’identité (CNIB ou passeport) et entreprises de rattachement.',
  },
  companies: {
    title: 'Personnes morales',
    subtitle:
      'Entreprises et institutions facturées : RCCM, IFU, régime fiscal et retenue à la source.',
  },
  kpi: {
    people: 'Personnes',
    companies: 'Entreprises',
    totalFoot: 'fiches actives sur ce site',
    withPhone: 'Joignables par téléphone',
    withPhoneFoot: 'numéro principal renseigné',
    withEmail: 'Joignables par e-mail',
    withEmailFoot: 'adresse e-mail renseignée',
    linked: 'Rattachements',
    linkedFoot: 'entreprise principale renseignée',
  },
  filters: { showArchived: 'Afficher les archivés' },
  columns: {
    person: 'Personne',
    company: 'Entreprise',
    contact: 'Coordonnées',
    phone: 'Téléphone',
    email: 'E-mail',
    legal: 'Identification',
    stays: 'Séjours',
    balance: 'Solde',
    lastStay: 'Dernier séjour',
    role: 'Rôle',
    primary: 'Payeur par défaut',
  },
  fields: {
    gender: 'Civilité',
    lastName: 'Nom',
    firstNames: 'Prénoms',
    birthDate: 'Date de naissance',
    nationality: 'Nationalité',
    profession: 'Profession',
    idDocumentIssuingCountry: 'Pays de délivrance',
    country: 'Pays',
    idDocument: 'CNIB ou passeport',
    idDocumentType: 'Type de pièce',
    idDocumentNumber: 'Numéro de pièce',
    idDocumentExpiresAt: 'Expiration',
    legalName: 'Raison sociale',
    legalForm: 'Forme juridique',
    taxRegime: 'Régime fiscal',
    taxDivision: 'Division fiscale',
    billingContactName: 'Contact facturation',
    billingEmail: 'E-mail de facturation',
    withholdingDefault: 'Proposer la retenue à la source (5 %)',
    taxExempt: 'Client exonéré',
    phonePrimary: 'Téléphone',
    phoneSecondary: 'Téléphone secondaire',
    email: 'Adresse e-mail',
    address: 'Adresse',
    poBox: 'Boîte postale',
    city: 'Ville',
    notes: 'Notes internes',
    company: 'Entreprise',
    person: 'Personne',
    membershipRole: 'Rôle dans l’entreprise',
  },
  search: {
    change: 'Changer',
    noResult: 'Aucun résultat pour « {{term}} »',
    create: 'Créer « {{term}} »',
    createPerson: 'Créer une personne',
    createCompany: 'Créer l’entreprise',
    personPlaceholder: 'Nom, téléphone, e-mail ou entreprise',
    companyPlaceholder: 'Raison sociale ou IFU',
  },
  drawer: {
    createTitle: 'Nouveau client',
    editTitle: 'Modifier {{name}}',
    subtitle:
      'Le dossier peut être complété plus tard : seuls le nom et le téléphone sont obligatoires.',
    kindLegend: 'Type de client',
    sectionIdentity: 'Identité',
    sectionIdDocument: 'CNIB ou passeport',
    idDocumentNotice:
      'La pièce d’identité (CNIB ou passeport) et la fiche de police remplie sont exigées avant l’émission d’une facture définitive (règle R-001).',
    sectionCompany: 'Identification de l’entreprise',
    sectionContact: 'Coordonnées',
    sectionEmployer: 'Rattachement à une entreprise',
    rccmHint: 'Figure sur chaque facture.',
    ifuHint: 'Identifiant financier unique.',
    withholdingHint:
      'Retenue de 5 % calculée sur le montant remisé, activable document par document (D-012).',
    employerHint:
      'La facture pourra être établie au nom de l’entreprise ; le rattachement est modifiable ensuite.',
    phoneHint: 'Format international, par exemple +226 70 24 18 55.',
    phoneInvalid: 'Numéro invalide pour le Burkina Faso.',
    submitCreate: 'Créer le client',
    submitEdit: 'Enregistrer les modifications',
  },
  actions: {
    newReservation: 'Nouvelle réservation',
    archive: 'Archiver la fiche',
    restore: 'Réactiver la fiche',
    archiveTitle: 'Archiver {{name}} ?',
    archiveBody:
      'La fiche reste consultable et l’historique est conservé, mais elle n’apparaît plus dans les listes ni dans la recherche.',
    restoreTitle: 'Réactiver {{name}} ?',
    restoreBody: 'La fiche redevient sélectionnable dans les réservations et la recherche.',
  },
  detail: {
    tabsLabel: 'Sections de la fiche client',
    tabs: {
      stays: 'Séjours',
      billing: 'Facturation',
      companies: 'Entreprises liées',
      employees: 'Employés',
      documents: 'Documents',
      notes: 'Notes',
      loyalty: 'Fidélité',
      interactions: 'Contacts',
    },
    staysTitle: 'Séjours du client',
    staysEmptyTitle: 'Aucun séjour',
    staysEmptyBody: 'Ce client n’a pas encore de réservation à son nom.',
    staysCount: 'Séjours',
    balance: 'Solde dû',
    lastStay: 'Dernier séjour',
    billedTitle: 'Séjours facturés à ce client',
    billedEmptyTitle: 'Aucune facturation',
    billedEmptyBody: 'Aucun séjour n’est facturé à cette fiche pour l’instant.',
    invoicesSoon: 'Proformas et factures définitives arrivent au sprint facturation.',
    linkCompany: 'Lier une entreprise',
    linkPerson: 'Lier une personne',
    linkBody: 'Le lien indique le rôle de la personne dans l’entreprise.',
    linkSubmit: 'Créer le lien',
    linksEmptyTitle: 'Aucun rattachement',
    linksEmptyBody: 'Reliez cette fiche à une entreprise pour préremplir « Facturé à ».',
    primaryBadge: 'Payeur par défaut',
    unlink: 'Supprimer le lien',
    documentsSoonTitle: 'Documents du client',
    documentsSoonBody:
      'Le téléversement des pièces d’identité et de la fiche de police arrive au sprint 2.4.',
    notesEmpty: 'Aucune note interne pour ce client.',
    complianceTitle: 'Pièce d’identité manquante',
    complianceBody:
      'Sans CNIB ni passeport enregistré, la facture définitive sera refusée par le serveur (R-001).',
    idMissing: 'Non renseignée',
  },
  toasts: {
    created: '{{name}} créé.',
    updated: 'Fiche client mise à jour.',
    archived: 'Fiche archivée.',
    restored: 'Fiche réactivée.',
    linked: 'Lien créé.',
    unlinked: 'Lien supprimé.',
  },
};

export const reservations = {
  title: 'Réservations',
  subtitle: 'Toutes les réservations du site : demandes, options, séjours en cours et historique.',
  listTitle: 'Liste des réservations',
  countLabel: '{{count}} réservation',
  countLabel_other: '{{count}} réservations',
  searchLabel: 'Rechercher une réservation',
  searchPlaceholder: 'Référence, client, entreprise ou ressource',
  emptyTitle: 'Aucune réservation',
  emptyBody: 'Créez une première réservation depuis le calendrier ou le bouton ci-dessus.',
  emptySearchTitle: 'Aucune réservation ne correspond',
  emptySearchBody: 'Modifiez la recherche ou effacez les filtres.',
  nightsCount: '{{count}} nuit',
  nightsCount_other: '{{count}} nuits',
  adultsCount: '{{count}} adulte',
  adultsCount_other: '{{count}} adultes',
  childrenCount: '{{count}} enfant',
  childrenCount_other: '{{count}} enfants',
  childrenNone: 'Aucun',
  status: {
    DRAFT: 'Brouillon',
    PENDING_CONFIRMATION: 'En attente',
    OPTION: 'Option',
    CONFIRMED: 'Confirmée',
    CHECKED_IN: 'En séjour',
    CHECKED_OUT: 'Terminée',
    CANCELLED: 'Annulée',
    NO_SHOW: 'No-show',
  },
  compliance: {
    NOT_REQUIRED: 'Non requise',
    INCOMPLETE: 'Conformité incomplète',
    COMPLETE: 'Conformité complète',
  },
  complianceItems: {
    IDENTITY_DOCUMENT: 'CNIB ou passeport',
    POLICE_FORM: 'Fiche de police remplie',
  },
  source: {
    DIRECT: 'Direct',
    PHONE: 'Téléphone',
    WHATSAPP: 'WhatsApp',
    EMAIL: 'E-mail',
    WEBSITE: 'Site web',
    BOOKING_COM: 'Booking.com',
    AIRBNB: 'Airbnb',
    CORPORATE: 'Entreprise',
    REFERRAL: 'Recommandation',
    OTHER: 'Autre',
  },
  kpi: {
    active: 'Réservations actives',
    activeFoot: 'options, confirmées et séjours en cours',
    options: 'Options en cours',
    optionsFoot: 'inventaire immobilisé jusqu’à expiration',
    balance: 'Solde à encaisser',
    balanceFoot: 'sur les réservations affichées',
    compliance: 'Dossiers incomplets',
    complianceFoot: 'facture définitive bloquée (R-001)',
  },
  filters: {
    resource: 'Ressource',
    allResources: 'Toutes les ressources',
    from: 'Arrivée à partir du',
    to: 'Arrivée jusqu’au',
    balanceDue: 'Solde dû',
  },
  columns: {
    reference: 'Référence',
    guest: 'Client',
    resource: 'Ressource',
    dates: 'Dates',
    nights: 'Nuits',
    total: 'Net à payer',
    balance: 'Solde',
    status: 'Statut',
    compliance: 'Conformité',
  },
  list: { billedTo: 'Facturé à {{name}}' },
  fields: {
    arrivalDate: 'Date d’arrivée',
    arrivalTime: 'Heure d’arrivée',
    departureDate: 'Date de départ',
    departureTime: 'Heure de départ',
    arrival: 'Arrivée',
    departure: 'Départ',
    nights: 'Nuitées',
    adults: 'Occupants — adultes',
    children: 'Occupants — enfants',
    occupants: 'Occupants',
    earlyCheckin: 'Arrivée anticipée demandée',
    guest: 'Occupant — rechercher un client existant',
    billingParty: 'Facturé à',
    billingCompany: 'Entreprise facturée',
    ratePlan: 'Grille tarifaire',
    unitPrice: 'Prix unitaire',
    quantity: 'Quantité facturée',
    discount: 'Remise commerciale',
    discountMode: 'Type de remise',
    extras: 'Extras',
    extraQuantity: 'Quantité — {{label}}',
    extraPrice: 'Prix unitaire — {{label}}',
    applyWithholding: 'Appliquer la retenue à la source ({{rate}})',
    notesInternal: 'Notes internes',
    optionExpiresAt: 'Expiration de l’option',
    resource: 'Ressource',
    property: 'Site',
    source: 'Canal',
    createdAt: 'Créée le',
  },
  extras: {
    BREAKFAST: 'Petit-déjeuner',
    AIRPORT_SHUTTLE: 'Navette aéroport',
    EXTRA_CLEANING: 'Ménage supplémentaire',
    LAUNDRY: 'Blanchisserie',
  },
  create: {
    action: 'Nouvelle réservation',
    title: 'Nouvelle réservation',
    subtitle: 'Trois étapes sur une seule page : le séjour, le client, le tarif.',
    breadcrumb: 'Nouvelle',
    step1: 'Séjour',
    step2: 'Client',
    step3: 'Tarif & extras',
    checkinHint: 'Check-in à partir de 12 h 00 (sauf demande express).',
    checkoutHint: 'Check-out au plus tard 12 h 00.',
    datesInvalid: 'Le départ doit être postérieur à l’arrivée.',
    earlyCheckinHint:
      'À signaler à la réception : l’arrivée avant 12 h 00 dépend de la disponibilité du logement.',
    capacityExceeded: '{{name}} accueille {{max}} personnes au maximum.',
    resourceLegend: 'Ressource proposée',
    availabilityCount:
      '{{count}} ressource disponible sur cette période pour {{people}} personnes.',
    availabilityCount_other:
      '{{count}} ressources disponibles sur cette période pour {{people}} personnes.',
    compositeNotice:
      'Réserver un appartement en entier rend ses chambres indisponibles ; réserver une chambre seule rend l’appartement entier indisponible. Le contrôle est appliqué par le serveur.',
    capacityLabel: '{{count}} personne maximum',
    capacityLabel_other: '{{count}} personnes maximum',
    subResource: 'fait partie d’un appartement',
    subResourceBadge: 'Sous-ressource',
    available: 'Disponible',
    unavailable: 'Indisponible',
    conflictWith: 'Occupée par {{name}}',
    guestHint: 'La recherche est instantanée dès 2 caractères.',
    billingHint:
      'La partie facturée peut être différente de l’occupant — c’est le cas des séjours pris en charge par un employeur.',
    billingGuest: 'L’occupant lui-même',
    billingCompany: 'Une entreprise',
    billingGuestNotice: 'La facture sera établie au nom de {{name}}, avec son adresse personnelle.',
    billingGuestEmpty: 'Sélectionnez d’abord l’occupant du logement.',
    noRatePlan: 'Aucun plan tarifaire',
    priceOverrideHint: 'Modifiable : toute révision est journalisée dans l’audit.',
    priceLockedHint: 'Lecture seule — permission « reservation.override_price » requise.',
    discountHint: 'Soit {{amount}} sur l’hébergement.',
    removeExtra: 'Retirer l’extra {{label}}',
    withholdingHint:
      'Régime CME : aucune TVA facturée. La retenue de 5 % est calculée sur le montant remisé.',
    notesPlaceholder: 'Visible par l’équipe uniquement.',
    confirmAction: 'Créer et confirmer',
    holdAction: 'Poser une option',
    draftAction: 'Enregistrer en brouillon',
    holdTitle: 'Poser une option',
    holdHint: 'Expiration proposée : +48 h. L’inventaire est immobilisé jusqu’à cette date.',
    holdSubmit: 'Créer l’option',
    depositTitle: 'Avance de confirmation',
    depositSubtitle:
      'Montant libre : toute avance enregistrée permet le passage au statut Confirmée (D-022).',
    depositSubmit: 'Encaisser et confirmer',
    depositNoPermission: 'Vous n’avez pas la permission d’enregistrer un paiement.',
    withoutDepositAction: 'Confirmer sans avance',
    withoutDepositTitle: 'Confirmer sans avance ?',
    withoutDepositWarning:
      'Le solde intégral de {{amount}} restera dû à l’arrivée. Aucun encaissement n’est enregistré par cette action.',
    withoutDepositReason: 'Motif de la confirmation sans avance',
    withoutDepositReasonHint:
      'Obligatoire (10 caractères minimum). Le motif est conservé dans le journal d’audit.',
    withoutDepositSubmit: 'Confirmer sans avance',
    incomplete: 'Complétez le séjour et le client avant d’enregistrer.',
  },
  summary: {
    title: 'Résumé',
    noResource: 'Aucune ressource sélectionnée',
    customer: 'Client',
    noGuest: 'Aucun occupant sélectionné',
    billedTo: 'Facturé à {{name}}',
    amounts: 'Montants',
    accommodation: 'Hébergement {{quantity}} × {{price}}',
    subtotal: 'Sous-total',
    discount: 'Remise',
    tax: 'TVA (régime CME)',
    withholding: 'Retenue à la source 5 %',
    net: 'Net à payer',
    paid: 'Payé',
    balance: 'Solde restant dû',
    depositTitle: 'Avance requise pour confirmer (montant libre)',
    depositHint:
      'Aucun pourcentage ni minimum imposé : toute avance enregistrée permet le passage au statut Confirmée.',
    quotePending: 'Choisissez une ressource et des dates pour obtenir le devis.',
    complianceNotice:
      'CNIB ou passeport et fiche de police remplie seront exigés au check-in avant toute facture définitive.',
  },
  deposit: {
    suggestBalance: 'Solde',
    suggestHalf: '50 %',
    amount: 'Montant de l’avance',
    amountHint: 'Montant libre, supérieur à 0 et inférieur ou égal au solde (D-022).',
    amountRequired: 'Indiquez un montant supérieur à 0.',
    amountTooHigh: 'Le montant dépasse le solde restant dû.',
    method: 'Mode de règlement',
    provider: 'Opérateur',
    reference: 'Référence de transaction',
    referenceHint: 'Obligatoire pour tous les modes sauf les espèces.',
    referenceRequired: 'Indiquez la référence de la transaction.',
    note: 'Note',
  },
  depositMethod: {
    CASH: 'Espèces',
    MOBILE_MONEY: 'Mobile Money',
    BANK_TRANSFER: 'Virement',
    CHEQUE: 'Chèque',
    CARD: 'Carte',
    OTHER: 'Autre',
  },
  // Catalogue `PaymentProvider` des contrats partagés.
  depositProvider: {
    ORANGE_MONEY: 'Orange Money',
    MOOV_MONEY: 'Moov Money',
    WAVE: 'Wave',
    CORIS_MONEY: 'Coris Money',
    CORIS_BANK: 'Coris Bank',
    ECOBANK: 'Ecobank',
    UBA: 'UBA',
    OTHER: 'Autre',
  },
  cancelReasons: {
    CUSTOMER_REQUEST: 'Annulation à la demande du client',
    NO_SHOW_ANTICIPATED: 'Non-présentation anticipée',
    INPUT_ERROR: 'Erreur de saisie',
    UNAVAILABLE: 'Indisponibilité de la ressource',
  },
  actions: {
    hold: 'Poser une option',
    holdTitle: 'Poser une option sur {{reference}}',
    holdBody: 'L’inventaire est immobilisé jusqu’à l’expiration de l’option.',
    holdHint: 'Expiration proposée : +48 h.',
    confirm: 'Confirmer',
    confirmTitle: 'Confirmer {{reference}} ?',
    confirmBody: 'La confirmation immobilise l’inventaire sur toute la période.',
    confirmDepositOk: 'Avance de {{amount}} déjà encaissée : la confirmation est possible.',
    confirmNoDepositWarning:
      'Aucune avance encaissée : le solde de {{amount}} restera dû. Motif obligatoire.',
    confirmDepositRequired:
      'Une avance est requise pour confirmer. Enregistrez un paiement ou demandez à la gérante de confirmer sans avance.',
    checkIn: 'Check-in',
    checkInTitle: 'Check-in — {{reference}}',
    checkInBody: 'Heure d’arrivée, occupants présents et remise des clés.',
    checkInComplianceTitle: 'Documents de conformité incomplets',
    checkInComplianceBody:
      'Le check-in reste autorisé, mais la facture définitive sera bloquée tant que les pièces manquent (R-001).',
    checkInTime: 'Heure d’arrivée réelle',
    occupants: 'Occupants (un par ligne)',
    occupantsHint: 'Le premier nom est l’occupant principal.',
    keysHanded: 'Clés remises',
    checkOut: 'Check-out',
    checkOutTitle: 'Check-out — {{reference}}',
    checkOutBody: 'Heure de départ et notes de fin de séjour.',
    checkOutTime: 'Heure de départ réelle',
    checkOutBalanceTitle: 'Solde restant dû : {{amount}}',
    checkOutBalanceBlocked:
      'Le check-out avec solde est réservé aux profils disposant de la permission dédiée (R-010). Encaissez le solde ou demandez à la gérante.',
    checkOutBalanceAllowed:
      'Le check-out avec solde est possible avec un motif obligatoire, journalisé dans l’audit (D-014).',
    checkOutReason: 'Motif du check-out avec solde',
    checkOutReasonHint: 'Obligatoire, 10 caractères minimum.',
    checkOutReasonTooShort: 'Le motif doit comporter au moins 10 caractères.',
    checkOutAccommodation: 'Hébergement et extras',
    checkOutFolio_one: 'Folio ({{count}} charge)',
    checkOutFolio_other: 'Folio ({{count}} charges)',
    checkOutConsolidated: 'Solde consolidé',
    departureNotes: 'Notes de départ',
    checkOutPageTitle: 'Check-out — {{reference}}',
    checkOutResourceState: 'État du logement au départ',
    checkOutResourceHint:
      'Le logement passe automatiquement au statut « Sale » : il apparaîtra dans Opérations › Ménage.',
    checkOutDirtyAfter: 'Après validation, {{name}} sera marqué « Sale ».',
    checkOutComplianceWarning:
      'Conformité incomplète : le check-out reste autorisé, mais la facture définitive restera bloquée (R-001).',
    checkOutBalanceRecordDeposit: 'Enregistrer une avance',
    checkOutPage: 'Ouvrir la page de check-in',
    cancel: 'Annuler la réservation',
    cancelTitle: 'Annuler {{reference}} ?',
    cancelBody: 'L’inventaire de {{name}} sera libéré. L’opération est tracée et irréversible.',
    cancelConfirm: 'Confirmer l’annulation',
    cancelReason: 'Motif d’annulation',
    cancelDetails: 'Précisions',
    cancelFee: 'Frais d’annulation',
    cancelFeeHint: 'Politique : annulation gratuite jusqu’à 48 h avant l’arrivée.',
    cancelDepositNotice:
      'L’avance de {{amount}} déjà encaissée devra faire l’objet d’un remboursement ou d’un avoir.',
    noShow: 'Déclarer un no-show',
    noShowTitle: 'Déclarer un no-show — {{reference}}',
    noShowBody: 'L’inventaire est libéré ; la réservation ne peut plus être réactivée.',
    noShowFee: 'Frais de no-show',
    noShowFeeHint: 'Politique : une nuitée par défaut.',
    recordDeposit: 'Enregistrer une avance',
    recordDepositTitle: 'Enregistrer une avance',
    sendConfirmation: 'Envoyer la confirmation',
    sendTitle: 'Envoyer la confirmation',
    sendBody: 'Un e-mail de confirmation de séjour est envoyé au client.',
    sendEmail: 'Envoyer par e-mail',
    sendWhatsappSoon: 'WhatsApp — bientôt',
    sendDocument: 'Ouvrir la confirmation (PDF)',
  },
  checkIn: {
    title: 'Check-in — {{guest}}',
    subtitle:
      '{{resource}} · arrivée prévue le {{date}} à partir de {{time}} · {{nights}} nuit(s) · {{adults}} adulte(s)',
    breadcrumb: 'Check-in',
    backToReservation: 'Retour à la réservation',
    complianceBannerTitle: 'Conformité INCOMPLETE — le check-in reste autorisé',
    complianceBannerBody:
      'Il reste {{count}} document obligatoire à valider. Vous pouvez installer le client immédiatement, mais l’émission de la facture définitive sera refusée par le serveur tant que chaque pièce obligatoire n’est pas validée — un dépôt seul ne suffit pas (code',
    complianceBannerBody_other:
      'Il reste {{count}} documents obligatoires à valider. Vous pouvez installer le client immédiatement, mais l’émission de la facture définitive sera refusée par le serveur tant que chaque pièce obligatoire n’est pas validée — un dépôt seul ne suffit pas (code',
    documentsTitle: 'Documents obligatoires',
    occupantsTitle: 'Occupants présents',
    occupantsHint:
      '{{announced}} personne(s) annoncée(s) · capacité maximale de la ressource : {{capacity}}',
    addOccupant: 'Ajouter',
    mainOccupant: 'Occupant principal',
    occupantNumber: 'Occupant {{index}}',
    occupantPlaceholder: 'Nom et prénoms',
    removeOccupant: 'Retirer cet occupant',
    arrivalTitle: 'Arrivée & remise des clés',
    auditedHint: 'Informations consignées dans le journal d’audit',
    actualArrival: 'Heure d’arrivée réelle',
    actualArrivalHint:
      'Check-in à partir de 12 h 00. Avant cette heure, cochez « arrivée anticipée demandée ».',
    agent: 'Agent d’accueil',
    earlyCheckin: 'Arrivée anticipée demandée (avant 12 h 00)',
    keysHanded: 'Jeu de clés remis au client',
    notes: 'Observations',
    notesPlaceholder: 'Remarques sur l’état des lieux, demandes particulières du client…',
    acknowledgeTitle: 'Documents non validés',
    acknowledgeBody:
      'Le check-in est possible, mais la facture définitive sera bloquée tant que ces pièces ne sont pas déposées puis validées. Votre confirmation est journalisée.',
    acknowledgeLabel: 'Je confirme le check-in avec documents manquants',
    submit: 'Valider le check-in',
    progressTitle: 'Progression du check-in',
    stepDone: 'fait',
    stepTodo: 'à faire',
    steps: {
      confirmed: 'Réservation confirmée',
      documents: 'Documents obligatoires validés',
      resource: 'Logement prêt',
      keys: 'Clés disponibles et remises',
    },
    billingEffectTitle: 'Effet sur la facturation',
    billingEffectStay: 'Check-in et séjour autorisés',
    billingEffectProforma: 'Proforma et encaissements autorisés',
    billingEffectInvoice: 'Facture définitive refusée par le serveur',
  },
  edit: {
    title: 'Modifier {{reference}}',
    subtitle: 'Dates, ressource, occupants et tarif. La disponibilité est revérifiée.',
    resourceHint: 'Les ressources occupées sur la période sont désactivées.',
  },
  detail: {
    subtitle:
      '{{guest}} · {{resource}} · du {{from}} au {{to}} · {{nights}} nuit(s) · facturé à {{billedTo}}',
    tabsLabel: 'Sections de la réservation',
    tabs: {
      stay: 'Séjour',
      customer: 'Client & facturation',
      documents: 'Documents & conformité',
      payments: 'Paiements',
      folio: 'Folio',
      history: 'Historique',
    },
    billingSubject: 'Location de {{resource}} du {{from}} au {{to}}',
    netDetail: 'Sous-total {{subtotal}}',
    folioDetail: 'dont folio {{amount}}',
    depositsCount: '{{count}} avance enregistrée',
    depositsCount_other: '{{count}} avances enregistrées',
    balanceDue: 'Exigible à l’arrivée',
    stayTitle: 'Détail du séjour',
    earlyCheckin: 'Arrivée anticipée demandée',
    linesTitle: 'Lignes tarifaires',
    lineLabel: 'Désignation',
    lineUnitPrice: 'P.U.',
    lineQuantity: 'Qté',
    lineAmount: 'Montant',
    notesTitle: 'Notes internes',
    guestTitle: 'Occupant',
    openCustomer: 'Ouvrir la fiche client',
    billingTitle: 'Facturé à',
    openBillingParty: 'Ouvrir la fiche',
    withholdingApplied: 'Retenue à la source de 5 % appliquée sur le montant remisé (D-012).',
    complianceIncompleteTitle: 'Conformité incomplète — {{count}} document obligatoire à valider',
    complianceIncompleteTitle_other:
      'Conformité incomplète — {{count}} documents obligatoires à valider',
    complianceIncompleteBody:
      'Le check-in reste autorisé. En revanche, l’émission de la facture définitive sera refusée par le serveur tant que toutes les pièces obligatoires ne sont pas validées — un simple dépôt ne suffit pas (règle R-001).',
    complianceMissingTypes: 'Pièces attendues : {{types}}.',
    complianceCompleteTitle: 'Conformité complète',
    complianceCompleteBody: 'La facture définitive pourra être émise.',
    complianceNotRequired: 'Aucun document de conformité requis pour cette ressource.',
    requirementsTitle: 'Exigences documentaires',
    requirementsCount: '{{validated}} sur {{total}} validés',
    documentProvided: 'Pièce enregistrée au dossier.',
    documentMissing: 'À enregistrer avant l’émission de la facture définitive.',
    provided: 'Fournie',
    missing: 'Manquante',
    uploadSoonTitle: 'Téléversement bientôt disponible',
    uploadSoonBody: 'Le dépôt des pièces (PDF, JPEG, PNG) arrive au sprint 2.4.',
    paymentsTitle: 'Avances encaissées',
    paymentsEmptyTitle: 'Aucune avance',
    paymentsEmptyBody: 'Enregistrez une avance pour permettre la confirmation de la réservation.',
    paymentReference: 'Référence',
    paymentDate: 'Date',
    paymentMethod: 'Mode',
    paymentAmount: 'Montant',
    paymentsFooter:
      'Les avances seront rattachées aux proformas et factures au sprint facturation.',
    historyTitle: 'Journal de la réservation',
    appendOnly: 'Append-only',
    historyEmptyTitle: 'Aucun évènement',
    actionsTitle: 'Actions',
    optionTitle: 'Option en cours',
    optionBody: 'Expire le {{date}} — au-delà, l’inventaire est libéré automatiquement.',
    complianceCardTitle: 'Conformité',
    requiredDocuments: 'Documents obligatoires',
    invoiceBlocked: 'Facture définitive bloquée tant que le dossier est incomplet.',
  },
  folio: {
    title: 'Folio de séjour',
    notInHouse: 'Les charges se posent sur un séjour en cours (après le check-in).',
    closedTitle: 'Folio clos',
    closedBody: 'Check-out effectué le {{date}} : plus aucune charge ni annulation.',
    addCharge: 'Charge manuelle',
    addChargeTitle: 'Poser une charge sur le séjour',
    addChargeBody:
      'Minibar, blanchisserie, dégât… La charge entre immédiatement dans le solde du séjour.',
    post: 'Poser {{amount}}',
    emptyTitle: 'Aucune charge',
    emptyBody:
      'Les additions imputées depuis le restaurant ou le bar et les charges de la réception apparaîtront ici.',
    columns: {
      postedAt: 'Posée le',
      label: 'Libellé',
      source: 'Provenance',
      signature: 'Bon signé',
      amount: 'Montant',
    },
    kind: { POS_ORDER: 'Point de vente', MANUAL: 'Réception' },
    signed: 'Signé',
    unsigned: 'Non joint',
    attachSignature: 'Joindre le bon signé',
    signTitle: 'Bon de transfert signé — {{reference}}',
    signBody:
      'Scannez ou photographiez le bon signé par le client : il sera rattaché au séjour et à la charge.',
    void: 'Annuler la charge',
    voidTitle: 'Annuler « {{label}} »',
    voidBody:
      'La charge reste visible avec son motif ; une addition imputée redevient ouverte au point de vente.',
    voidedBy: 'Annulée par {{name}} — {{reason}}',
    footer_one: '{{count}} charge active',
    footer_other: '{{count}} charges actives',
    fields: {
      label: 'Libellé',
      labelPlaceholder: 'Minibar, blanchisserie…',
      description: 'Détail',
      quantity: 'Quantité',
      unitPrice: 'Prix unitaire',
    },
    toasts: {
      posted: 'Charge posée sur le séjour.',
      voided: 'Charge annulée.',
      signed: 'Bon signé rattaché à la charge.',
    },
  },
  // Actions émises par l'API (`reservation_history.action`, point → souligné).
  historyActions: {
    reservation_create: 'Réservation créée',
    reservation_update: 'Réservation modifiée',
    reservation_hold: 'Option posée',
    reservation_confirm: 'Réservation confirmée',
    reservation_check_in: 'Check-in effectué',
    reservation_check_out: 'Check-out effectué',
    reservation_cancel: 'Réservation annulée',
    reservation_no_show: 'No-show déclaré',
    reservation_option_expired: 'Option expirée',
    reservation_deposit_recorded: 'Avance enregistrée',
    reservation_confirmation_sent: 'Confirmation envoyée',
  },
  errors: {
    notAvailableTitle: 'Période indisponible',
    notAvailableBody:
      'Une réservation ou un blocage occupe déjà l’une des unités de cette ressource sur la période demandée.',
    depositRequiredTitle: 'Avance requise',
    depositRequiredBody:
      'Une avance est nécessaire pour confirmer la réservation (D-020). Un profil Gérant ou Propriétaire peut confirmer sans avance avec un motif.',
    paymentExceedsTitle: 'Montant supérieur au solde',
    paymentExceedsBody:
      'Une avance ne peut pas dépasser le solde restant dû ({{balance}}) : aucun trop-perçu n’est conservé au MVP (R-008).',
    balanceDueTitle: 'Solde restant dû',
    balanceDueBody:
      'Le check-out avec solde nécessite la permission dédiée et un motif obligatoire (R-010).',
    invalidTransitionTitle: 'Transition impossible',
    invalidTransitionBody:
      'L’état actuel de la réservation ({{status}}) ne permet pas cette action. Rechargez la fiche : un collègue l’a peut-être modifiée.',
  },
  toasts: {
    created: 'Réservation {{reference}} créée.',
    updated: 'Réservation mise à jour.',
    hold: 'Option posée.',
    confirm: 'Réservation confirmée.',
    checkIn: 'Check-in enregistré.',
    checkOut: 'Check-out enregistré.',
    cancel: 'Réservation annulée.',
    noShow: 'No-show déclaré.',
    deposit: 'Avance enregistrée.',
    send: 'Confirmation envoyée.',
  },
};

export const documents = {
  title: 'Documents',
  unknownType: 'Type inconnu',
  type: {
    IDENTITY_DOCUMENT: 'CNIB ou passeport',
    POLICE_FORM: 'Fiche de police remplie',
    CONTRACT: 'Contrat',
    PURCHASE_ORDER: 'Bon de commande',
    PAYMENT_RECEIPT: 'Reçu de paiement',
    CONFIRMATION_PDF: 'Confirmation de séjour (PDF)',
    PROFORMA_PDF: 'Proforma (PDF)',
    INVOICE_PDF: 'Facture (PDF)',
    PHOTO: 'Photo',
    SIGNED_SLIP: 'Bon de transfert signé',
    OTHER: 'Autre pièce',
  },
  identityKind: {
    CNIB: 'CNIB',
    PASSPORT: 'Passeport',
    RESIDENCE_PERMIT: 'Carte de séjour',
    OTHER: 'Autre pièce d’identité',
  },
  status: {
    PENDING_UPLOAD: 'En attente d’envoi',
    PENDING_SCAN: 'Analyse antivirus',
    CLEAN: 'Vérifiée',
    REJECTED: 'Rejetée',
    DELETED: 'Supprimée',
  },
  fields: {
    type: 'Type de document',
    identityKind: 'Nature de la pièce',
    identityKindHint: 'CNIB pour les résidents, passeport pour les voyageurs étrangers.',
    label: 'Libellé (facultatif)',
    labelHint: 'Ex. « CNIB n° B0245789 » ou « Bon de commande ABC Burkina 2026-0451 ».',
  },
  upload: {
    dropTitle: 'Déposez un document ou cliquez pour parcourir',
    dropTitleFor: 'Déposez la pièce « {{type}} »',
    dropHint:
      'PDF, JPEG, PNG, WebP ou HEIC — {{max}} Mo maximum · stockage privé, accès par URL temporaire',
    browse: 'Choisir un fichier',
    camera: 'Prendre une photo',
    submit: 'Téléverser le document',
    remove: 'Retirer le fichier sélectionné',
    previewAlt: 'Aperçu de {{name}}',
    progressLabel: 'Progression du téléversement',
    progressValue: 'Téléversement : {{percent}} %',
  },
  actions: {
    add: 'Ajouter un document',
    preview: 'Voir',
    previewOf: 'Prévisualiser {{name}}',
    download: 'Télécharger',
    downloadOf: 'Télécharger {{name}}',
    deleteOf: 'Supprimer {{name}}',
  },
  list: {
    meta: '{{filename}} · {{size}} · chargé le {{date}} par {{author}}',
    unknownAuthor: 'un collègue',
    restricted: 'Accès restreint',
  },
  viewer: {
    title: 'Aperçu du document',
    subtitle: '{{type}} · {{size}} · {{date}}',
    sensitiveNotice:
      'Pièce d’identité : l’ouverture est journalisée nominativement et l’URL expire en quelques minutes.',
    openNewTab: 'Ouvrir dans un nouvel onglet',
  },
  delete: {
    title: 'Supprimer ce document ?',
    warning:
      'La suppression est tracée dans le journal d’audit. Une exigence de conformité satisfaite par cette pièce redeviendra manquante.',
    reason: 'Motif de la suppression',
    reasonHint: 'Obligatoire, 5 caractères minimum.',
    reasonTooShort: 'Le motif doit comporter au moins 5 caractères.',
    validatedForCompliance:
      'Cette pièce prouve une exigence de conformité déjà validée : rejetez d’abord l’exigence dans « Documents & conformité », puis supprimez le document (R-001).',
  },
  accessLog: {
    title: 'Historique des accès',
    subtitle: 'Consultations et téléchargements de la pièce (journal nominatif).',
    empty: 'Aucun accès enregistré pour l’instant.',
    action: {
      VIEW: 'Consultation',
      DOWNLOAD: 'Téléchargement',
      UPLOAD: 'Dépôt',
      DELETE: 'Suppression',
    },
    columns: { action: 'Action', user: 'Utilisateur', date: 'Date', ip: 'Adresse IP' },
  },
  others: {
    title: 'Autres pièces du dossier',
    subtitle: 'Contrat, bon de commande, reçu, photo…',
    emptyTitle: 'Aucune autre pièce',
    emptyBody: 'Ajoutez un contrat, un bon de commande ou une capture de confirmation.',
  },
  customer: {
    title: 'Pièces du client',
    subtitle:
      'Une pièce d’identité rattachée au client est réutilisable pour ses prochains séjours tant qu’elle est valide.',
    emptyTitle: 'Aucun document',
    emptyBody: 'Ajoutez la CNIB ou le passeport du client pour accélérer ses prochains check-in.',
  },
  errors: {
    uploadFailedTitle: 'Téléversement impossible',
    tooLarge: 'Fichier trop volumineux ({{max}} Mo maximum). Sur mobile, réduisez la photo.',
    unsupportedType:
      'Format non pris en charge. Utilisez une photo (JPEG, PNG, WebP, HEIC) ou un PDF.',
    forbiddenTitle: 'Accès refusé',
    forbiddenBody:
      'L’ouverture des pièces d’identité exige la permission « document.view_identity ». Demandez-la à la gérante.',
  },
  toasts: {
    uploaded: 'Document ajouté.',
    deleted: 'Document supprimé.',
  },
};

export const compliance = {
  title: 'Conformité',
  optional: 'facultatif',
  gauge: '{{validated}} sur {{total}}',
  gaugeLabel: 'Documents obligatoires validés',
  gaugeAwaiting: '{{count}} pièce déposée en attente de validation.',
  gaugeAwaiting_other: '{{count}} pièces déposées en attente de validation.',
  status: {
    MISSING: 'Manquante',
    UPLOADED: 'À vérifier',
    VALIDATED: 'Validée',
    REJECTED: 'Rejetée',
  },
  hints: {
    missing: 'À enregistrer avant l’émission de la facture définitive.',
    uploaded:
      'Chargée le {{date}} par {{author}} — en attente de validation : le dossier reste incomplet.',
    validated: 'Validée le {{date}} par {{author}}.',
    rejected: 'Rejetée : {{reason}}',
  },
  actions: {
    validate: 'Valider',
    reject: 'Rejeter',
    addFor: 'Enregistrer {{type}}',
    replace: 'Remplacer',
  },
  reject: {
    title: 'Rejeter la pièce',
    reason: 'Motif du rejet',
    reasonHint: 'Obligatoire, 5 caractères minimum. Le motif est visible par l’équipe.',
  },
  requirements: {
    title: 'Exigences documentaires',
    subtitle:
      'Documents exigés par type de ressource. Une exigence obligatoire non satisfaite bloque l’émission de la facture définitive (R-001).',
    columns: {
      resourceType: 'Type de ressource',
      document: 'Document',
      mandatory: 'Obligatoire',
      appliesTo: 'Occupants concernés',
      reminder: 'Rappel',
      actions: 'Actions',
    },
    appliesTo: { MAIN_GUEST: 'Occupant principal', ALL_OCCUPANTS: 'Tous les occupants' },
    mandatoryYes: 'Obligatoire',
    mandatoryNo: 'Facultatif',
    reminderNone: 'Aucun',
    reminderHours: 'Après {{count}} h',
    add: 'Ajouter une exigence',
    addTitle: 'Nouvelle exigence documentaire',
    save: 'Enregistrer l’exigence',
    delete: 'Supprimer l’exigence',
    deleteConfirm: 'Supprimer cette exigence ? Les séjours en cours seront recalculés.',
    emptyTitle: 'Aucune exigence configurée',
    emptyBody: 'Ajoutez la CNIB et la fiche de police pour les types d’hébergement.',
    noPermission:
      'La configuration des exigences demande la permission « compliance.manage_requirements ».',
    reminderLabel: 'Rappel après (heures)',
    reminderPlaceholder: 'Ex. 24',
  },
  toasts: {
    validated: 'Pièce validée : la conformité est mise à jour.',
    rejected: 'Pièce rejetée : l’exigence redevient à fournir.',
    requirementSaved: 'Exigence enregistrée.',
    requirementSavedResync: 'Exigence enregistrée · {{count}} séjour en cours recalculé.',
    requirementSavedResync_other: 'Exigence enregistrée · {{count}} séjours en cours recalculés.',
    requirementDeleted: 'Exigence supprimée.',
    requirementDeletedItems: 'Exigence supprimée · {{count}} pièce encore attendue retirée.',
    requirementDeletedItems_other:
      'Exigence supprimée · {{count}} pièces encore attendues retirées.',
  },
};

export const housekeeping = {
  title: 'Ménage du jour',
  subtitle: 'Plan des logements à préparer — {{date}}',
  countLabel: '{{count}} ressource',
  countLabel_other: '{{count}} ressources',
  status: {
    AVAILABLE: 'Disponible',
    OCCUPIED: 'Occupé',
    DIRTY: 'Sale',
    CLEANING: 'Ménage en cours',
    READY: 'Prêt',
    MAINTENANCE: 'Maintenance',
    BLOCKED: 'Bloqué',
  },
  filters: { label: 'Filtrer par statut', all: 'Tous les statuts' },
  card: {
    currentGuest: 'Occupant : {{name}}',
    vacant: 'Logement vacant',
    departure: 'Départ {{date}}',
    nextArrival: 'Prochaine arrivée {{date}}',
    nextGuest: 'Prochain client : {{name}}',
    noNextArrival: 'Aucune arrivée programmée',
    since: 'Statut inchangé depuis {{date}}',
  },
  actions: {
    start: 'Commencer le ménage',
    ready: 'Marquer « Prêt »',
    noPermission: 'Changer le statut demande la permission « housekeeping.update_status ».',
  },
  legend: 'Légende des statuts',
  emptyTitle: 'Rien à préparer',
  emptyBody: 'Tous les logements sont prêts ou occupés. Beau travail.',
  toasts: {
    CLEANING: 'Ménage commencé : {{name}}.',
    READY: '{{name}} est prêt.',
    DIRTY: '{{name}} repasse « Sale ».',
  },
};

export const tasks = {
  title: 'Tâches',
  subtitle: 'Dossiers à compléter, paiements attendus et options qui expirent.',
  countLabel: '{{count}} tâche ouverte',
  countLabel_other: '{{count}} tâches ouvertes',
  kind: {
    DOCUMENT_MISSING: 'Document manquant',
    PAYMENT_EXPECTED: 'Paiement attendu',
    RESERVATION_TO_CONFIRM: 'Réservation à confirmer',
    OPTION_EXPIRING: 'Option qui expire',
    ARRIVAL_TODAY: 'Arrivée du jour',
    DEPARTURE_TODAY: 'Départ du jour',
    HOUSEKEEPING: 'Ménage',
    MAINTENANCE: 'Maintenance',
    OTHER: 'Autre',
  },
  status: { OPEN: 'Ouverte', DONE: 'Terminée', DISMISSED: 'Ignorée' },
  filters: { status: 'Statut', kind: 'Type', allKinds: 'Tous les types' },
  due: 'Échéance {{date}}',
  noDue: 'Sans échéance',
  overdue: 'En retard',
  assignedTo: 'Assignée à {{name}}',
  actions: { complete: 'Terminer', dismiss: 'Ignorer', open: 'Ouvrir la fiche' },
  emptyTitle: 'Rien à faire',
  emptyBody: 'Aucune tâche ouverte : le dossier du jour est à jour.',
  dashboard: {
    title: 'Tâches',
    seeAll: 'Voir toutes les tâches',
    empty: 'Aucune tâche ouverte.',
  },
  toasts: { done: 'Tâche terminée.', dismissed: 'Tâche ignorée.' },
  notifications: {
    title: 'Notifications',
    subtitle: 'Alertes et rappels de l’équipe.',
    bell: 'Notifications',
    bellWithCount: 'Notifications — {{count}} non lue',
    bellWithCount_other: 'Notifications — {{count}} non lues',
    markRead: 'Marquer comme lue',
    markAllRead: 'Tout marquer comme lu',
    unread: 'Non lue',
    emptyTitle: 'Aucune notification',
    emptyBody: 'Les alertes de conformité et de paiement apparaîtront ici.',
    kind: {
      DOCUMENT_MISSING: 'Document manquant',
      TASK_ASSIGNED: 'Tâche assignée',
      PAYMENT_EXPECTED: 'Paiement attendu',
      SUPPORT_ACCESS_REQUESTED: 'Demande d’accès support',
      SUBSCRIPTION_INVOICE: 'Facture d’abonnement HOREVIA',
      SUBSCRIPTION_OVERDUE: 'Retard d’abonnement HOREVIA',
      OTHER: 'Information',
    },
  },
};

export const billing = {
  /* ---------------------- Envoi par e-mail (sprint 2.6) ------------------- */
  send: {
    title: 'Envoyer le document',
    description: 'Envoi de {{document}} par e-mail au client.',
    recipient: 'Destinataire',
    recipientHint: 'Pré-rempli depuis la fiche du client facturé ; modifiable.',
    recipientInvalid: 'Saisissez une adresse e-mail valide.',
    message: 'Message',
    messageHint: 'Ajouté au corps de l’e-mail avant le document joint.',
    submit: 'Envoyer',
    channelEmail: 'E-mail',
    channelWhatsapp: 'WhatsApp',
    channelWhatsappSoon: 'Le canal WhatsApp arrive avec le module Notifications.',
    soon: 'bientôt',
    toastSent: '{{document}} envoyé à {{to}}.',
  },

  /* ------------------------------- Document ------------------------------- */
  document: {
    title: {
      PROFORMA: 'Facture proforma',
      INVOICE: 'Facture',
      CREDIT_NOTE: 'Avoir',
    },
    ariaLabel: '{{title}} {{number}}',
    noNumber: 'sans numéro',
    draftNumber: 'Numéro attribué à l’émission',
    issuerActivity: 'Location d’appartements meublés & salle de réunion',
    phoneShort: 'Tél. {{phone}}',
    billTo: 'Facturé à',
    subject: 'Objet',
    occupant: 'occupant : {{name}}',
    currencyName: 'Franc CFA ({{code}})',
    meta: {
      placeAndDate: '{{city}}, le',
      dueDate: 'Date d’échéance',
      validUntil: 'Validité de l’offre',
      stay: 'Période de séjour',
      currency: 'Devise',
      reservation: 'Réservation',
      relatedInvoice: 'Facture d’origine',
    },
    columns: {
      designation: 'Désignation',
      unitPrice: 'Prix unitaire',
      quantity: 'Quantité',
      amount: 'Montant',
    },
    totals: {
      subtotal: 'Sous-total',
      discount: 'Remise commerciale',
      discountPercent: 'Remise commerciale ({{value}} %)',
      discounted: 'Montant remisé',
      vat: 'TVA — régime CME',
      vatNotApplicable: 'Non applicable',
      withholding: 'Retenue à la source ({{rate}} %) — sur le montant remisé',
      withholdingNotApplied: 'Non appliquée',
      net: 'Net à payer',
      creditTotal: 'Montant de l’avoir',
    },
    words: {
      PROFORMA: 'Arrêtée la présente facture proforma à la somme de',
      INVOICE: 'Arrêtée la présente facture à la somme de',
      CREDIT_NOTE: 'Arrêté le présent avoir à la somme de',
      withholdingNote:
        'Retenue à la source de 5 % appliquée sur le montant remisé, conformément aux obligations du client.',
    },
    payment: {
      title: 'Modalités de règlement',
      methods: ['Espèces', 'Orange Money', 'Moov Money', 'Virement bancaire', 'Chèque', 'TPE'],
      bank: 'Banque',
      account: 'Compte',
      holder: 'Titulaire',
    },
    mentions: {
      invoiceTerms:
        'Règlement à 15 jours date de facture. Tout retard de paiement pourra donner lieu à des pénalités conformément aux conditions générales.',
      proformaNonContractual:
        'Offre valable 15 jours. Document non contractuel — ne constitue pas une facture et ne peut être utilisé à des fins comptables ou fiscales.',
      creditNote:
        'Le présent avoir annule ou réduit la facture d’origine. Il est joint à la facture initiale pour toute justification comptable.',
    },
    signature: {
      for: 'Pour {{name}}',
      box: 'Signature & cachet',
      defaultRole: 'La Gérante',
    },
    footer: {
      phone: 'Tél.',
      rccm: 'RCCM',
      regime: 'Régime',
      bank: 'Banque',
      email: 'E-mail',
      ifu: 'IFU',
      taxDivision: 'Division fiscale',
      account: 'Compte',
    },
    print: 'Imprimer',
    downloadPdf: 'PDF',
    sendEmail: 'Envoyer par e-mail',
    sendSoon: 'Envoyer le document par e-mail au client.',
    previewTitle: 'Aperçu du document',
    previewLive: 'Aperçu en direct — le document reflète le brouillon en cours d’édition.',
  },

  /* ------------------------------- Statuts -------------------------------- */
  status: {
    proforma: {
      DRAFT: 'Brouillon',
      ISSUED: 'Émise',
      ACCEPTED: 'Acceptée',
      EXPIRED: 'Expirée',
      CANCELLED: 'Annulée',
    },
    invoice: {
      DRAFT: 'Brouillon',
      ISSUED: 'Émise',
      PARTIALLY_PAID: 'Partiellement payée',
      PAID: 'Payée',
      CANCELLED: 'Annulée',
    },
    creditNote: { DRAFT: 'Brouillon', ISSUED: 'Émis' },
    overridden: 'Émise avec dérogation',
    overriddenTitle: 'Dérogation R-001 — motif : {{reason}} · accordée par {{author}}',
    immutable: 'Immuable',
    converted: 'Convertie en facture',
    overdue: 'En retard {{count}} j',
    expiresIn: 'Expire dans {{count}} j',
    expiresToday: 'Expire aujourd’hui',
    blocked: 'Émission bloquée',
  },

  /* ------------------------------ Proformas ------------------------------- */
  proformas: {
    title: 'Proformas',
    subtitle: 'Devis et demandes d’acompte — numérotation PRO/AAAA/NNNNN, valables {{days}} jours.',
    listTitle: 'Toutes les proformas',
    create: 'Nouvelle proforma',
    createFromReservation: 'Créer une proforma',
    searchLabel: 'Rechercher une proforma',
    searchPlaceholder: 'Numéro, client…',
    countLabel: '{{count}} proforma',
    countLabel_other: '{{count}} proformas',
    emptyTitle: 'Aucune proforma',
    emptyBody: 'Créez une proforma depuis une réservation ou en saisie libre.',
    emptySearchTitle: 'Aucune proforma ne correspond',
    emptySearchBody: 'Modifiez la recherche ou effacez les filtres.',
    kpi: {
      issued: 'Émises',
      issuedFoot: '{{amount}} proposés',
      accepted: 'Acceptées',
      acceptedFoot: 'taux de transformation {{rate}} %',
      pending: 'En attente',
      pendingFoot: 'offres émises non acceptées',
      expired: 'Expirées',
      expiredFoot: 'à relancer ou archiver',
    },
    columns: {
      number: 'Numéro',
      billingParty: 'Client facturé',
      reservation: 'Réservation',
      issueDate: 'Émission',
      validUntil: 'Validité',
      net: 'Net à payer',
      status: 'Statut',
    },
    lifecycle: {
      title: 'Cycle de vie du document',
      draft: 'Brouillon',
      issued: 'Émise',
      accepted: 'Acceptée',
      converted: 'Convertie en facture',
    },
    convertNotice:
      'La conversion crée un brouillon de facture lié. L’émission de la facture reste soumise au contrôle de conformité R-001.',
    convertedNotice: 'Cette proforma a déjà été convertie en facture.',
    seeInvoice: 'Voir la facture',
    detailSubtitle: 'Proforma {{number}} — {{customer}}',
    draftSubtitle: 'Brouillon de proforma — {{customer}}',
  },

  /* ------------------------------- Factures ------------------------------- */
  invoices: {
    title: 'Factures',
    subtitle:
      'Numérotation sans trou FAC/AAAA/NNNNN — une facture émise est immuable et ne s’annule que par avoir.',
    listTitle: 'Toutes les factures',
    create: 'Nouvelle facture',
    createFromReservation: 'Émettre la facture',
    searchLabel: 'Rechercher une facture',
    searchPlaceholder: 'Numéro (FAC/…), client…',
    countLabel: '{{count}} facture',
    countLabel_other: '{{count}} factures',
    emptyTitle: 'Aucune facture',
    emptyBody: 'Les factures sont créées depuis une réservation ou une proforma acceptée.',
    emptySearchTitle: 'Aucune facture ne correspond',
    emptySearchBody: 'Modifiez la recherche ou effacez les filtres.',
    kpi: {
      invoiced: 'Facturé',
      invoicedFoot: '{{count}} facture émise',
      invoicedFoot_other: '{{count}} factures émises',
      collected: 'Encaissé',
      collectedFoot: '{{rate}} % du facturé',
      due: 'Restant dû',
      dueFoot: 'dont {{amount}} en retard',
      blocked: 'Émissions bloquées',
      blockedFoot: 'dossiers de conformité incomplets',
    },
    columns: {
      number: 'Numéro',
      billingParty: 'Client facturé',
      reservation: 'Réservation',
      issueDate: 'Émission',
      dueDate: 'Échéance',
      net: 'Net à payer',
      balance: 'Solde',
      status: 'Statut',
    },
    filters: {
      all: 'Toutes',
      balanceDue: 'Solde dû',
      overdue: 'En retard',
      from: 'Émises depuis le',
      to: 'Émises jusqu’au',
      status: 'Statut',
      allStatuses: 'Tous les statuts',
    },
    immutableBanner: {
      title: 'Document immuable — corrections par avoir',
      body: 'Depuis son émission, cette facture ne peut plus être modifiée ni supprimée. Un instantané, le PDF et son empreinte sont conservés (D-004).',
      issuedAt: 'Émise le',
      issuedBy: 'Par',
      hash: 'Empreinte SHA-256 du PDF',
    },
    overrideBanner: {
      title: 'Facture émise avec dérogation à la règle R-001',
      body: 'Des documents obligatoires manquaient au moment de l’émission. Motif : « {{reason}} ». Dérogation accordée par {{author}}.',
      completeFile: 'Compléter le dossier',
    },
    payments: {
      title: 'Paiements alloués',
      empty: 'Aucun paiement alloué à cette facture.',
      columns: { reference: 'Référence', date: 'Date', method: 'Méthode', amount: 'Montant' },
      soon: 'L’enregistrement d’un paiement arrive au sprint 2.6.',
    },
    creditNotes: {
      title: 'Avoirs liés',
      empty: 'Aucun avoir sur cette facture.',
    },
    settlement: {
      title: 'Règlement',
      net: 'Net à payer',
      paid: 'Payé',
      balance: 'Solde',
      dueOn: 'Échéance le {{date}}.',
      overdue: 'En retard de {{count}} jour.',
      overdue_other: 'En retard de {{count}} jours.',
    },
    detailSubtitle: 'Facture {{number}} — {{customer}}',
    draftSubtitle:
      'Projet de facture — {{customer}} · {{reference}} · numéro attribué à l’émission',
    numberOnIssue: 'Numéro attribué à l’émission',
    numberOnIssueHint:
      'La séquence est verrouillée en base au moment de l’émission afin de garantir une numérotation sans trou (ADR-008).',
  },

  /* -------------------------------- Avoirs -------------------------------- */
  creditNotes: {
    title: 'Avoirs',
    subtitle:
      'Seule voie d’annulation ou de correction d’une facture émise — numérotation AV/AAAA/NNNNN.',
    listTitle: 'Tous les avoirs',
    create: 'Créer un avoir',
    issueAction: 'Émettre l’avoir',
    draftNotice:
      'Cet avoir est encore un brouillon : aucun numéro n’a été consommé et la facture n’est pas encore imputée. Émettez-le pour le rendre définitif.',
    countLabel: '{{count}} avoir',
    countLabel_other: '{{count}} avoirs',
    emptyTitle: 'Aucun avoir',
    emptyBody: 'Un avoir se crée depuis une facture émise.',
    columns: {
      number: 'Numéro',
      invoice: 'Facture d’origine',
      billingParty: 'Client',
      issueDate: 'Émission',
      amount: 'Montant',
      reason: 'Motif',
      status: 'Statut',
    },
    drawer: {
      title: 'Créer un avoir',
      subtitle: 'Facture {{number}} — {{customer}} · {{amount}}',
      notice:
        'Une facture émise est immuable : l’avoir est la seule façon de l’annuler ou d’en corriger le montant (D-004).',
      scope: 'Portée de l’avoir',
      full: 'Avoir total — annule la facture',
      fullHint: 'Le montant de l’avoir est égal au net à payer de la facture.',
      partial: 'Avoir partiel — lignes sélectionnées',
      partialHint: 'Ajoutez les lignes à créditer ; le total ne peut pas dépasser la facture.',
      reason: 'Motif de l’avoir',
      reasonPlaceholder: 'Ex. nuitée du 18 septembre non consommée — départ anticipé du client',
      reasonHint:
        'Motif obligatoire (minimum 5 caractères), repris sur le document et dans l’audit.',
      submit: 'Créer l’avoir',
      exceeds: 'Le montant de l’avoir dépasse le net à payer de la facture ({{amount}}).',
      draftPending:
        'Le brouillon d’avoir a bien été créé mais son émission a échoué. Réessayez : seule l’émission sera rejouée, aucun second avoir ne sera créé.',
    },
    detailSubtitle: 'Avoir {{number}} — facture {{invoice}}',
  },

  /* ------------------------- Blocage R-001 & dérogation -------------------- */
  compliance: {
    blockedTitle: 'Émission de la facture refusée par le serveur',
    blockedBody:
      'La facture définitive de la réservation {{reference}} ne peut pas être émise : le dossier de conformité est au statut INCOMPLETE.',
    blockedRule:
      'Ce contrôle est appliqué côté serveur (règle métier R-001). Seul un profil Gérant ou Propriétaire peut lever le blocage, au moyen d’une dérogation motivée et tracée. La proforma, les encaissements et le check-in restent possibles.',
    missingTitle: 'Documents obligatoires manquants',
    missingCount: '{{provided}} sur {{total}} fournis',
    missing: 'Manquante',
    completeFile: 'Compléter le dossier',
    seeReservation: 'Voir la réservation',
    retry: 'Réessayer l’émission',
    overrideAvailable:
      'Vous êtes connecté en tant que {{name}} : la dérogation invoice.issue.override_compliance vous est accessible.',
    overrideUnavailable:
      'La dérogation à la règle R-001 est réservée aux profils Gérant et Propriétaire (D-026).',
    unblockTitle: 'Ce qui débloque l’émission',
    unblockStep1: 'Enregistrer les pièces manquantes depuis l’écran de check-in.',
    unblockStep2: 'Le statut de conformité passe automatiquement à COMPLETE.',
    unblockStep3: 'Émettre la facture définitive : numéro, PDF et empreinte sont figés.',
    goToCheckIn: 'Aller au check-in',
    alreadyInvoiced: 'Une facture définitive existe déjà pour cette réservation.',
    statusBlocked:
      'L’état actuel de la réservation ne permet pas d’émettre une facture définitive.',
    override: {
      action: 'Émettre avec dérogation',
      title: 'Dérogation à la règle de conformité',
      subtitle: '{{reference}} — {{customer}} · {{amount}}',
      notice:
        'La règle R-001 interdit l’émission d’une facture définitive lorsqu’un document obligatoire manque. Une dérogation est réservée aux profils Gérant et Propriétaire ; elle est journalisée et reste visible sur la facture émise.',
      reason: 'Motif de la dérogation',
      reasonPlaceholder:
        'Ex. client entreprise parti avant remise de la fiche de police — documents attendus sous 48 h',
      reasonHint:
        'Le motif sera visible dans le journal d’audit et sur la facture. Minimum 20 caractères — {{count}}/20.',
      commitment: 'Je confirme que les documents seront collectés',
      commitmentHint:
        'Une tâche de relance sera créée pour la réception, échéance 48 h après l’émission.',
      auditNotice:
        'L’événement invoice.issue.override_compliance sera enregistré avec votre identité, l’horodatage et le motif saisi. La facture émise portera la mention « Émise avec dérogation ».',
      submit: 'Émettre la facture avec dérogation',
      expectedBy: 'Documents attendus pour le',
      denied:
        'Dérogation refusée par le serveur : la permission invoice.issue.override_compliance est réservée aux profils Gérant et Propriétaire (D-026).',
    },
  },

  /* ----------------------------- Édition ---------------------------------- */
  editor: {
    title: 'Contenu du document',
    linesTitle: 'Prestations facturées',
    addLine: 'Ajouter une ligne',
    removeLine: 'Supprimer la ligne',
    lineLabel: 'Désignation',
    lineDescription: 'Description',
    lineQuantity: 'Quantité',
    lineUnitPrice: 'Prix unitaire',
    lineAmount: 'Montant',
    lineKind: 'Nature',
    kind: {
      ACCOMMODATION: 'Hébergement',
      EXTRA: 'Extra',
      FEE: 'Frais',
      DISCOUNT: 'Remise',
    },
    emptyLines: 'Aucune ligne : ajoutez au moins une prestation avant d’émettre le document.',
    discount: 'Remise commerciale',
    discountType: 'Type de remise',
    discountValue: 'Valeur',
    discountTypes: { NONE: 'Aucune', PERCENT: 'Pourcentage', AMOUNT: 'Montant fixe' },
    withholding: 'Appliquer la retenue à la source ({{rate}} %)',
    withholdingHint:
      'Calculée sur le montant remisé, jamais sur le sous-total. Option à activer document par document, selon les obligations du client facturé.',
    withholdingBase: 'Assiette : montant remisé {{amount}}',
    subject: 'Objet du document',
    subjectPlaceholder: 'Location de l’appartement F2 – 111 du 15 au 20 septembre 2026',
    billingParty: 'Client facturé',
    property: 'Établissement émetteur',
    reservation: 'Réservation liée',
    noReservation: 'Aucune (saisie libre)',
    validUntil: 'Validité de l’offre',
    dueDate: 'Date d’échéance',
    notes: 'Mentions particulières',
    stayFrom: 'Début de séjour',
    stayTo: 'Fin de séjour',
    save: 'Enregistrer le brouillon',
    saved: 'Brouillon enregistré.',
    unsaved: 'Modifications non enregistrées',
    readOnlyTitle: 'Document en lecture seule',
    readOnlyBody: 'Ce document n’est plus modifiable dans son état actuel.',
  },

  /* ------------------------------- Actions -------------------------------- */
  actions: {
    issue: 'Émettre',
    issueProforma: 'Émettre la proforma',
    issueInvoice: 'Émettre la facture',
    accept: 'Marquer acceptée',
    cancel: 'Annuler',
    convert: 'Convertir en facture',
    createCreditNote: 'Créer un avoir',
    recordPayment: 'Enregistrer un paiement',
    paymentSoon: 'Enregistrer un encaissement sur cette facture.',
    backToList: 'Retour à la liste',
  },
  dialogs: {
    issueProformaTitle: 'Émettre la proforma ?',
    issueProformaBody:
      'La proforma recevra un numéro PRO/{{year}}/NNNNN et son contenu sera figé. Elle reste annulable sans avoir.',
    issueInvoiceTitle: 'Émettre la facture ?',
    issueInvoiceBody:
      'La facture recevra un numéro FAC/{{year}}/NNNNN et deviendra immuable. Toute correction passera ensuite par un avoir.',
    acceptTitle: 'Marquer la proforma comme acceptée ?',
    acceptBody:
      'L’acceptation ouvre la conversion en facture. Renseignez la date d’acceptation si elle diffère d’aujourd’hui.',
    acceptedAt: 'Date d’acceptation',
    cancelTitle: 'Annuler la proforma ?',
    cancelBody: 'Une proforma annulée reste consultable ; aucun avoir n’est nécessaire.',
    cancelReason: 'Motif de l’annulation',
    cancelReasonPlaceholder: 'Ex. le client a renoncé au séjour',
    convertTitle: 'Convertir en facture ?',
    convertBody:
      'Un brouillon de facture lié à cette proforma sera créé avec les mêmes lignes. L’émission restera soumise à la conformité R-001.',
    dueDate: 'Date d’échéance de la facture',
  },
  toasts: {
    proformaCreated: 'Proforma créée.',
    proformaUpdated: 'Proforma mise à jour.',
    proformaIssued: 'Proforma {{number}} émise.',
    proformaAccepted: 'Proforma marquée comme acceptée.',
    proformaCancelled: 'Proforma annulée.',
    proformaConverted: 'Brouillon de facture créé.',
    invoiceCreated: 'Brouillon de facture créé.',
    invoiceUpdated: 'Facture mise à jour.',
    invoiceIssued: 'Facture {{number}} émise.',
    invoiceIssuedWithOverride:
      'Facture {{number}} émise avec dérogation — l’événement a été journalisé.',
    creditNoteCreated: 'Avoir créé.',
    creditNoteIssued: 'Avoir {{number}} émis.',
    settingsSaved: 'Paramètres de facturation enregistrés.',
    pdfOpened: 'PDF ouvert dans un nouvel onglet.',
  },

  /* ------------------- Onglet Facturation d’une réservation ---------------- */
  reservationTab: {
    title: 'Facturation',
    summaryTitle: 'Synthèse financière',
    deposits: 'Avances',
    invoiced: 'Facturé',
    paid: 'Payé',
    balance: 'Solde',
    proformasTitle: 'Proformas de la réservation',
    invoicesTitle: 'Factures de la réservation',
    noProformas: 'Aucune proforma pour cette réservation.',
    noInvoices: 'Aucune facture pour cette réservation.',
    createProforma: 'Créer une proforma',
    createInvoice: 'Émettre la facture',
    openInvoice: 'Ouvrir la facture',
  },
  customerTab: {
    invoicesTitle: 'Factures du client',
    empty: 'Aucune facture émise pour ce client.',
    balance: 'Solde client',
  },

  /* ------------------------------ Paramètres ------------------------------ */
  settings: {
    title: 'Facturation',
    subtitle:
      'Validité des proformas, échéances, lieu d’émission, signataire et mentions légales des documents.',
    proformaValidityDays: 'Validité d’une proforma (jours)',
    invoiceDueDays: 'Échéance d’une facture (jours)',
    placeOfIssue: 'Lieu d’émission',
    signatoryName: 'Signataire des documents',
    proformaTermsText: 'Mention de la proforma',
    invoicePaymentTermsText: 'Conditions de règlement de la facture',
    paymentMethodsText: 'Modalités de règlement acceptées',
    footerNote: 'Mention de pied de page (facultative)',
    numberingTitle: 'Formats de numérotation',
    numberingHint:
      'Séquences par exercice, consommées à l’émission et sans trou (ADR-008). Un nouveau format s’applique aux séquences créées ensuite (exercice suivant) ; les numéros déjà émis ne changent jamais.',
    numberingExample: 'Jetons : {YYYY} = exercice, {NNNNN} = compteur sur 5 chiffres.',
    numberingProforma: 'Proformas',
    numberingInvoice: 'Factures',
    numberingCreditNote: 'Avoirs',
    numberingOrder: 'Commandes POS',
    numberingPurchase: 'Bons d’achat (stock)',
    numberingCount: 'Inventaires (stock)',
    resetYearly: 'Réinitialisation annuelle',
    resetYearlyOn: 'Oui — la séquence repart à 1 chaque exercice',
    resetYearlyOff: 'Non — séquence continue',
    save: 'Enregistrer',
  },
};

/* -------------------------------------------------------------------------- */
/* Sprint 2.6 — Paiements                                                      */
/* -------------------------------------------------------------------------- */

export const payments = {
  list: {
    title: 'Paiements',
    subtitle:
      'Encaissements, affectations aux factures et reçus — espèces, mobile money, virement, chèque et TPE.',
    tableTitle: 'Tous les encaissements',
    countLabel: '{{count}} paiement',
    countLabel_other: '{{count}} paiements',
    searchLabel: 'Rechercher un paiement',
    searchPlaceholder: 'PAY-2026-000045, référence de transaction, client…',
    emptyTitle: 'Aucun paiement enregistré',
    emptyBody:
      'Enregistrez un encaissement depuis une facture, une réservation ou le bouton « Enregistrer un paiement ».',
    emptySearchTitle: 'Aucun paiement ne correspond',
    emptySearchBody: 'Modifiez la recherche ou effacez les filtres.',
    noCustomer: 'Client non renseigné',
    notAllocated: 'Non affecté',
    toAllocate: 'À affecter · {{amount}}',
    periodTotal: 'Total de la période',
    filters: {
      unallocated: 'Non affectés',
      from: 'Depuis le',
      to: 'Jusqu’au',
    },
  },
  kpi: {
    today: 'Encaissé aujourd’hui',
    todayFoot: '{{count}} opération',
    todayFoot_other: '{{count}} opérations',
    month: 'Encaissé ce mois',
    monthFoot: 'depuis le 1er du mois',
    monthCount: '{{count}} opération depuis le 1er du mois',
    monthCount_other: '{{count}} opérations depuis le 1er du mois',
    unallocatedCount: '{{count}} paiement à répartir',
    unallocatedCount_other: '{{count}} paiements à répartir',
    byMethodTitle: 'Répartition par mode de règlement',
    byMethodFoot: 'mois en cours',
    byMethodCount: '{{count}} opération',
    byMethodCount_other: '{{count}} opérations',
    unallocated: 'Non affecté',
    unallocatedFoot: 'à répartir sur des factures',
    refunds: 'Remboursements',
    refundsFoot: 'sur le mois en cours',
    cashOpen: 'Caisse ouverte · {{amount}}',
  },
  columns: {
    reference: 'Référence',
    date: 'Date',
    customer: 'Client',
    method: 'Mode',
    allocation: 'Affectation',
    amount: 'Montant',
    status: 'Statut',
  },
  method: {
    CASH: 'Espèces',
    MOBILE_MONEY: 'Mobile money',
    BANK_TRANSFER: 'Virement',
    CHEQUE: 'Chèque',
    CARD: 'TPE',
    OTHER: 'Autre',
  },
  provider: {
    ORANGE_MONEY: 'Orange Money',
    MOOV_MONEY: 'Moov Money',
    WAVE: 'Wave',
    CORIS_MONEY: 'Coris Money',
    CORIS_BANK: 'Coris Bank International',
    ECOBANK: 'Ecobank',
    UBA: 'UBA',
    OTHER: 'Autre établissement',
  },
  status: {
    RECORDED: 'Enregistré',
    CONFIRMED: 'Confirmé',
    REVERSED: 'Annulé',
    REFUND: 'Remboursement',
  },
  kind: {
    DEPOSIT: 'Avance',
    PAYMENT: 'Paiement',
    REFUND: 'Remboursement',
  },
  drawer: {
    title: 'Enregistrer un paiement',
    subtitleInvoice: '{{number}} — {{customer}} · solde {{balance}}',
    subtitleReservation: '{{reference}} — {{customer}} · solde {{balance}}',
    subtitleFree: 'Encaissement libre — à affecter à une facture ou à une réservation.',
    offline: 'Connexion requise pour enregistrer un paiement.',
    successTitle: 'Paiement enregistré',
    successBody: '{{amount}} encaissés · {{reference}}.',
    successUnallocated:
      '{{amount}} restent non affectés : répartissez-les depuis la fiche du paiement.',
    effect: 'Ce paiement soldera {{documents}} à la date du {{date}}.',
  },
  actions: {
    record: 'Enregistrer un paiement',
    downloadReceipt: 'Télécharger le reçu',
    sendReceipt: 'Envoyer le reçu',
    openPayment: 'Ouvrir la fiche du paiement',
    generateReceipt: 'Générer le reçu',
    refund: 'Rembourser',
    void: 'Annuler le paiement',
    editAllocations: 'Modifier les affectations',
  },
  fields: {
    amount: 'Montant reçu',
    amountHint: 'Solde restant dû : {{balance}}.',
    amountHintFree: 'Montant strictement positif, en francs CFA (sans décimale).',
    suggestBalance: 'Solde',
    suggestHalf: 'Moitié',
    method: 'Mode de paiement',
    provider: 'Opérateur / établissement',
    reference: 'Référence de la transaction',
    referenceHint: 'Numéro Orange Money, n° de chèque ou référence de virement.',
    chequeNumber: 'Numéro de chèque',
    bankName: 'Banque tirée',
    paidAt: 'Date et heure de l’encaissement',
    notes: 'Note interne',
    notesPlaceholder: 'Contexte de l’encaissement, interlocuteur…',
    proof: 'Justificatif',
    proofAdd: 'Joindre un justificatif',
    proofTitle: 'Capture Orange Money, bordereau, reçu de TPE…',
    proofAttached: 'Justificatif joint',
    cashSession: 'Caisse ouverte — théorique en caisse : {{balance}}.',
  },
  allocation: {
    legend: 'Affectation du paiement',
    hint: 'Répartissez le montant reçu entre les documents ouverts de ce client.',
    none: 'Aucun document ouvert : le paiement restera non affecté et pourra être réparti plus tard.',
    outstanding: 'Reste dû : {{amount}}',
    remaining: 'Reste à affecter',
    toggle: 'Affecter à {{label}}',
    amountFor: 'Montant affecté à {{label}}',
    unallocatedWarning:
      '{{amount}} resteront non affectés (trop-perçu). Le paiement apparaîtra « à affecter ».',
  },
  errors: {
    amountRequired: 'Indiquez un montant strictement positif.',
    referenceRequired: 'Indiquez la référence de la transaction.',
    chequeNumberRequired: 'Indiquez le numéro du chèque.',
    bankNameRequired: 'Indiquez la banque tirée.',
    reasonTooShort: 'Le motif doit comporter au moins 5 caractères.',
    cashSessionNotOpenTitle: 'Aucune session de caisse ouverte',
  },
  toasts: {
    recorded: 'Paiement de {{amount}} enregistré · {{reference}}.',
    refunded: 'Remboursement de {{amount}} enregistré · {{reference}}.',
    voided: 'Paiement annulé : une écriture compensatoire a été créée.',
    allocationsUpdated: 'Affectations mises à jour.',
    receiptGenerated: 'Reçu {{number}} généré.',
  },
  detail: {
    subtitle: '{{customer}} · encaissé le {{date}}',
    allocationsTitle: 'Affectations',
    allocationsEmptyTitle: 'Paiement non affecté',
    allocationsEmptyBody:
      'Ce montant n’est rattaché à aucune facture ni réservation. Modifiez les affectations pour le répartir.',
    allocationDocument: 'Document',
    historyTitle: 'Historique',
    appendOnly: 'Journal inaltérable',
    eventRecorded: 'Paiement enregistré',
    eventVoided: 'Paiement annulé',
    summaryTitle: 'Détail',
    allocated: 'Affecté',
    unallocated: 'Non affecté',
    refunded: 'Déjà remboursé',
    refundable: 'Remboursable',
    recordedBy: 'Enregistré par',
    openCashSession: 'Ouvrir la session',
    proofAttached: 'Un justificatif est joint à ce paiement.',
    reversedTitle: 'Paiement annulé',
    reversedBody: 'Motif : {{reason}} — annulé par {{author}} le {{date}}.',
    unallocatedNotice:
      '{{amount}} de ce paiement ne sont affectés à aucun document. Répartissez-les pour solder les factures concernées.',
  },
  refund: {
    title: 'Rembourser un paiement',
    subtitle: '{{reference}} — disponible : {{available}}',
    amount: 'Montant remboursé',
    amountHint: 'Au plus {{available}} (montant encaissé moins les remboursements déjà émis).',
    method: 'Mode de remboursement',
    reason: 'Motif du remboursement',
    reasonHint: 'Le motif est journalisé et apparaît sur la fiche du paiement.',
    reasonPlaceholder: 'Annulation du séjour à la demande du client…',
    submit: 'Enregistrer le remboursement',
  },
  void: {
    title: 'Annuler le paiement',
    description: '{{reference}} — cette opération est définitive.',
    warning:
      'Un paiement n’est jamais supprimé : l’annulation crée une écriture compensatoire tracée. Les factures concernées redeviendront partiellement payées ou impayées.',
    reason: 'Motif de l’annulation',
    reasonHint: 'Au moins 5 caractères, journalisé avec votre nom.',
    confirmLabel: 'Saisissez « {{reference}} » pour confirmer',
  },
};

/* -------------------------------------------------------------------------- */
/* Sprint 2.6 — Caisse                                                         */
/* -------------------------------------------------------------------------- */

export const cash = {
  title: 'Caisse',
  subtitle:
    'Session d’espèces de la réception : fond de caisse, encaissements, sorties, clôture et rapprochement.',
  closedTitle: 'Caisse fermée',
  closedBody:
    'Aucune session n’est ouverte : les paiements en espèces seront refusés tant que la caisse n’est pas ouverte.',
  openedAt: 'ouverte à {{time}} par {{author}}',
  movementsTitle: 'Mouvements du jour',
  movementsCount: '{{count}} mouvement',
  movementsCount_other: '{{count}} mouvements',
  movementsEmptyTitle: 'Aucun mouvement',
  movementsEmptyBody: 'Les encaissements en espèces et les sorties apparaîtront ici.',
  expensesNoticeTitle: 'Les dépenses se saisissent dans Suivi des dépenses',
  expensesNoticeBody:
    'Une dépense en espèces crée elle-même sa sortie de caisse dans la session ouverte ; la caisse ne propose plus de mouvement « Dépense » (restent entrée, sortie et ajustement).',
  expenseLink: 'Dépense {{reference}}',
  expenseLinkUnknown: 'Dépense saisie dans Suivi des dépenses',
  historyTitle: 'Historique des sessions',
  historyEmptyTitle: 'Aucune session de caisse',
  status: {
    OPEN: 'Ouverte',
    CLOSED: 'Clôturée',
    reconciled: 'Écart justifié',
  },
  fields: {
    openingBalance: 'Fond de caisse',
    ins: 'Entrées',
    outs: 'Sorties',
    expenses: 'Dépenses',
    refunds: 'Remboursements',
    payments: 'Encaissements espèces',
    expectedBalance: 'Théorique en caisse',
    actualBalance: 'Comptage réel',
    variance: 'Écart',
    notes: 'Notes',
    closedBy: 'Clôturée par',
  },
  kpi: {
    paymentsFoot: 'dont {{amount}} d’encaissements',
    expensesFoot: 'dont {{amount}} de dépenses',
  },
  columns: {
    time: 'Heure',
    kind: 'Type',
    description: 'Libellé',
    amount: 'Montant',
    openedAt: 'Ouverture',
    openedBy: 'Ouverte par',
    opening: 'Fond',
    expected: 'Théorique',
    counted: 'Compté',
    variance: 'Écart',
    status: 'Statut',
  },
  movementKind: {
    IN: 'Entrée',
    OUT: 'Sortie',
    EXPENSE: 'Dépense',
    ADJUSTMENT: 'Ajustement',
    PAYMENT: 'Encaissement',
    REFUND: 'Remboursement',
  },
  category: {
    APPORT: 'Apport de fonds',
    REMBOURSEMENT_FOURNISSEUR: 'Remboursement fournisseur',
    REMISE_BANQUE: 'Remise en banque',
    AVANCE_PERSONNEL: 'Avance au personnel',
    FOURNITURES: 'Fournitures',
    CARBURANT: 'Carburant groupe électrogène',
    ENTRETIEN: 'Entretien et réparations',
    TRANSPORT: 'Transport',
    CORRECTION_SAISIE: 'Correction de saisie',
    AUTRE: 'Autre',
  },
  actions: {
    openSession: 'Ouvrir la caisse',
    closeSession: 'Clôturer la caisse',
    recordMovement: 'Mouvement',
    reconcile: 'Justifier l’écart',
    downloadReport: 'Rapport PDF',
  },
  open: {
    title: 'Ouvrir une session de caisse',
    description: 'Le fond de caisse initial sert de base au solde théorique.',
    openingBalance: 'Fond de caisse',
    openingBalanceHint: 'Montant en espèces présent dans le tiroir à l’ouverture (0 accepté).',
  },
  movement: {
    title: 'Mouvement de caisse',
    description: 'Théorique en caisse avant mouvement : {{balance}}.',
    kind: 'Type de mouvement',
    category: 'Catégorie',
    direction: 'Sens de l’ajustement',
    directionIn: 'Entrée en caisse',
    directionOut: 'Sortie de caisse',
    descriptionLabel: 'Libellé',
    descriptionPlaceholder: 'Achat d’ampoules — quincaillerie Gounghin',
    amount: 'Montant',
    submit: 'Enregistrer le mouvement',
  },
  close: {
    title: 'Clôturer la session de caisse',
    description: 'Comptez les espèces présentes puis saisissez le montant réel.',
    counted: 'Comptage réel',
    countedHint: 'Total des billets et pièces effectivement en caisse.',
    variance: 'Écart (réel − théorique)',
    varianceWarning:
      'Un écart est constaté : expliquez-le ici. La justification formelle passe ensuite par le rapprochement.',
  },
  reconcile: {
    title: 'Justifier un écart de caisse',
    description: 'Écart constaté à la clôture : {{amount}}.',
    justification: 'Justification de l’écart',
    justificationHint:
      'Au moins 5 caractères, journalisé avec votre nom (permission cash.reconcile).',
    justificationPlaceholder: 'Erreur de rendu de monnaie sur le paiement PAY-2026-000045…',
    pendingTitle: 'Écart de caisse non justifié',
    pendingBody: 'Écart de {{amount}} sur la session clôturée le {{date}}.',
  },
  errors: {
    amountRequired: 'Indiquez un montant strictement positif.',
    descriptionRequired: 'Indiquez un libellé (2 caractères minimum).',
    countRequired: 'Saisissez le montant compté.',
    notesRequired: 'Expliquez l’écart constaté (5 caractères minimum).',
    justificationRequired: 'La justification doit comporter au moins 5 caractères.',
  },
  toasts: {
    sessionOpened: 'Session de caisse ouverte.',
    movementRecorded: 'Mouvement enregistré.',
    sessionClosed: 'Session clôturée sans écart.',
    sessionClosedWithVariance: 'Session clôturée avec un écart de {{amount}}.',
    reconciled: 'Écart justifié et rapproché.',
  },
  detail: {
    title: 'Session du {{date}}',
    subtitle: 'Ouverte par {{author}}',
    journalTitle: 'Journal des mouvements',
    summaryTitle: 'Synthèse',
    justificationTitle: 'Écart justifié',
    justificationBody: '{{justification}} — rapproché par {{author}}.',
  },
};

export const analytics = {
  period: {
    label: 'Période d’analyse',
    from: 'Début de période',
    to: 'Fin de période',
    range: 'Du {{from}} au {{to}}',
    compare: 'Comparer à la période précédente',
    presets: {
      TODAY: 'Aujourd’hui',
      LAST_7_DAYS: '7 jours',
      THIS_MONTH: 'Ce mois',
      LAST_MONTH: 'Mois dernier',
      THIS_QUARTER: 'Ce trimestre',
      THIS_YEAR: 'Cette année',
      CUSTOM: 'Personnalisé',
    },
  },
  delta: {
    points: '{{value}} pts',
    aria: {
      up: 'En hausse de {{value}} par rapport à la période précédente',
      down: 'En baisse de {{value}} par rapport à la période précédente',
      flat: 'Stable par rapport à la période précédente',
    },
  },
  performance: {
    title: 'Performance',
    noPermission: 'Les indicateurs d’activité demandent la permission « Rapports d’occupation ».',
  },
  finance: {
    title: 'Finance',
    badge: '{{from}} → {{to}}',
    invoiced: 'Facturé',
    collected: 'Encaissé',
    outstanding: 'Restant dû',
    overdue: 'En retard',
    deposits: 'Avances reçues',
    refunds: 'Remboursements',
    expenses: 'Dépenses',
    seeExpenses: 'Voir les dépenses',
    seeInvoices: 'Voir les factures',
    seePayments: 'Voir les encaissements',
    seeOutstanding: 'Voir les factures partiellement réglées',
    seeOverdue: 'Voir les factures échues',
    seeReports: 'Ouvrir les rapports',
  },
  kpi: {
    revenue: 'Chiffre d’affaires',
    revenueFoot: 'sur {{count}} jour',
    revenueFoot_other: 'sur {{count}} jours',
    occupancy: 'Taux d’occupation',
    occupancyFoot: 'unités louables occupées',
    adr: 'Prix moyen (ADR)',
    adrFoot: 'par nuitée vendue',
    revpar: 'RevPAR',
    revparFoot: 'par unité disponible',
    averageStay: 'Durée moyenne de séjour',
    averageStayFoot: 'par réservation',
    nightsUnit: 'nuits',
    reservations: 'Réservations créées',
    reservationsFoot: 'sur la période',
    cancelled: 'Annulations',
    cancelledFoot: 'dont {{count}} no-show',
    noShow: 'No-shows',
    noShowFoot: 'arrivées non honorées',
  },
  charts: {
    dailyTitle: 'Activité quotidienne',
    dailyDescription:
      'Chiffre d’affaires et encaissements par jour du {{from}} au {{to}} : {{revenue}} facturés, {{collected}} encaissés. Le détail chiffré est disponible dans le tableau « Voir les données ».',
    dailyTableCaption: 'Chiffre d’affaires, encaissements et occupation par jour',
    revenue: 'Chiffre d’affaires',
    collected: 'Encaissé',
    collectedHidden: 'encaissements non affichés (permission absente)',
    occupancy: 'Taux d’occupation',
    thousands: 'en milliers de {{currency}}',
    thousandsShort: 'k{{currency}}',
    showData: 'Voir les données',
    byResourceTitle: 'Revenus par ressource',
    byResourceDescription:
      'Classement des {{count}} ressources louables par chiffre d’affaires de la période. Le détail chiffré est disponible dans le tableau « Voir les données ».',
    bySourceTitle: 'Revenus par canal',
    bySourceDescription:
      'Répartition du chiffre d’affaires entre {{count}} canaux de réservation. Le détail chiffré est disponible dans le tableau « Voir les données ».',
    resourceSub: '{{nights}} nuitées · {{rate}} % d’occupation',
    columns: {
      date: 'Jour',
      resource: 'Ressource',
      source: 'Canal',
      nights: 'Nuitées',
      reservations: 'Réservations',
    },
  },
  empty: {
    title: 'Aucune activité sur cette période',
    body: 'Aucun séjour facturable ne couvre les dates sélectionnées. Élargissez la période.',
  },
};

export const search = {
  placeholder: 'Rechercher une réservation, un client, une facture…',
  searching: 'Recherche en cours…',
  tooShort: 'Saisissez au moins {{count}} caractères.',
  resultCount: '{{count}} résultat',
  resultCount_other: '{{count}} résultats',
  noResults: 'Aucun résultat pour « {{query}} ».',
  groups: {
    RESERVATION: 'Réservations',
    CUSTOMER: 'Personnes',
    COMPANY: 'Entreprises',
    INVOICE: 'Factures',
    PROFORMA: 'Proformas',
    PAYMENT: 'Paiements',
    RESOURCE: 'Ressources',
    EXPENSE: 'Dépenses',
  },
  status: {
    DRAFT: 'Brouillon',
    PENDING_CONFIRMATION: 'En attente',
    OPTION: 'Option',
    CONFIRMED: 'Confirmée',
    CHECKED_IN: 'En séjour',
    CHECKED_OUT: 'Terminée',
    CANCELLED: 'Annulée',
    NO_SHOW: 'No-show',
    ISSUED: 'Émise',
    PAID: 'Réglée',
    PARTIALLY_PAID: 'Partiellement réglée',
    ACCEPTED: 'Acceptée',
    EXPIRED: 'Expirée',
    PENDING: 'En attente',
    SETTLED: 'Encaissé',
    REVERSED: 'Annulé',
    ARCHIVED: 'Archivé',
    AVAILABLE: 'Disponible',
    OCCUPIED: 'Occupée',
    DIRTY: 'À nettoyer',
    CLEANING: 'En nettoyage',
    READY: 'Prête',
    MAINTENANCE: 'Maintenance',
    BLOCKED: 'Bloquée',
  },
};

export const reports = {
  title: 'Rapports',
  subtitle:
    'Rapports d’activité, de ventes, de finance, de clientèle et de ressources, exportables en CSV.',
  open: 'Ouvrir le rapport',
  exportHint: 'Choisissez un rapport, puis « Exporter CSV ».',
  emptyTitle: 'Aucun rapport accessible',
  emptyBody: 'Votre rôle ne donne accès à aucun rapport. Contactez la gérante du tenant.',
  emptyResultTitle: 'Aucune donnée sur cette période',
  emptyResultBody: 'Élargissez la période ou retirez le filtre de statut.',
  filtersTitle: 'Filtres',
  tableTitle: 'Résultats',
  groupBy: 'Regrouper par',
  statusFilter: 'Statut',
  totals: 'Total',
  totalsFoot: '{{count}} ligne',
  totalsFoot_other: '{{count}} lignes',
  generatedAt: '{{count}} ligne',
  generatedAt_other: '{{count}} lignes',
  families: {
    ACTIVITY: 'Activité',
    SALES: 'Ventes & stocks',
    FINANCE: 'Finance',
    CUSTOMERS: 'Clients',
    RESOURCES: 'Ressources',
  },
  groupByOptions: {
    DAY: 'Jour',
    WEEK: 'Semaine',
    MONTH: 'Mois',
    RESOURCE: 'Ressource',
    RESOURCE_TYPE: 'Type de ressource',
    SOURCE: 'Canal',
    CUSTOMER: 'Client',
    COMPANY: 'Entreprise',
    METHOD: 'Mode de règlement',
    CATEGORY: 'Catégorie',
    OUTLET: 'Point de vente',
    PRODUCT: 'Produit',
    SERVER: 'Serveur',
    HOUR: 'Heure',
    WEEKDAY: 'Jour de semaine',
    SERVICE_TYPE: 'Type de service',
    ITEM: 'Article',
    MODULE: 'Famille',
  },
  scope: {
    label: 'Périmètre',
    ENGAGED: 'Engagées',
    ALL: 'Toutes',
    CANCELLED: 'Annulées',
    hint: 'Engagées = confirmées, en séjour ou terminées. Les annulations et no-shows ne se cumulent que sur « Toutes » ou « Annulées ».',
  },
  actions: {
    exportCsv: 'Exporter CSV',
    print: 'Imprimer',
  },
  table: {
    caption: 'Rapport {{kind}} — {{count}} lignes',
    sortBy: 'Trier par {{column}}',
  },
  toasts: {
    exported: 'Export « {{name}} » prêt.',
  },
  status: {
    DRAFT: 'Brouillon',
    PENDING_CONFIRMATION: 'En attente',
    OPTION: 'Option',
    CONFIRMED: 'Confirmée',
    CHECKED_IN: 'En séjour',
    CHECKED_OUT: 'Terminée',
    CANCELLED: 'Annulée',
    NO_SHOW: 'No-show',
    ISSUED: 'Émise',
    PAID: 'Réglée',
    PARTIALLY_PAID: 'Partiellement réglée',
    OVERDUE: 'Échue',
    PENDING: 'En attente',
    SETTLED: 'Encaissé',
    REVERSED: 'Annulé',
  },
  kinds: {
    REVENUE: {
      title: 'Chiffre d’affaires',
      description:
        'CA des prestations par jour, semaine, mois, ressource ou canal, avec facturé et encaissé.',
    },
    OCCUPANCY: {
      title: 'Occupation',
      description:
        'Nuitées offertes et occupées, taux d’occupation par jour, ressource ou type de ressource.',
    },
    RESERVATIONS: {
      title: 'Réservations',
      description: 'Détail des réservations créées sur la période, par statut et canal.',
    },
    CUSTOMERS: {
      title: 'Clients',
      description: 'Nuitées et chiffre d’affaires par personne hébergée.',
    },
    COMPANIES: {
      title: 'Entreprises',
      description: 'Nuitées et chiffre d’affaires par entreprise facturée.',
    },
    PAYMENTS: {
      title: 'Encaissements',
      description: 'Règlements par jour ou par mode (espèces, mobile money, virement…).',
    },
    RECEIVABLES: {
      title: 'Créances',
      description: 'Factures non soldées, retard en jours et restant dû par client.',
    },
    DISCOUNTS: {
      title: 'Remises',
      description: 'Remises accordées par facture, en montant et en taux.',
    },
    TAXES: {
      title: 'Taxes & retenues',
      description: 'Taxes et retenue à la source de 5 % par période (R-012).',
    },
    RESOURCE_PERFORMANCE: {
      title: 'Performance des ressources',
      description: 'Revenus, nuitées et occupation par logement ou par salle.',
    },
    CASH: {
      title: 'Caisse',
      description: 'Encaissements en espèces par jour, pour le rapprochement de caisse.',
    },
    EXPENSES: {
      title: 'Dépenses',
      description:
        'Décaissements par jour, semaine, mois, moyen de règlement ou catégorie (annulations exclues).',
    },
    SALES: {
      title: 'Ventes',
      description:
        'Commandes encaissées et imputées au séjour par point de vente, catégorie, produit, heure, jour, serveur, type de service ou période.',
    },
    CONSOLIDATED_REVENUE: {
      title: 'CA consolidé',
      description:
        'Chiffre d’affaires par famille (hébergement, restauration, bar…) ou par période, chaque vente comptée une fois.',
    },
    PRODUCT_MARGIN: {
      title: 'Marges par produit',
      description: 'CA HT, coût des ventes au déstockage et marge brute de chaque produit vendu.',
    },
    STOCK_CONSUMPTION: {
      title: 'Consommations de stock',
      description:
        'Quantités et coûts consommés, achetés et perdus par article, catégorie ou période.',
    },
    CUSTOMER_ACTIVITY: {
      title: 'Activité des clients',
      description:
        'Visites, séjours, commandes et dépenses de chaque client sur la période, palier et solde de points.',
    },
    LOYALTY: {
      title: 'Fidélité',
      description: 'Points acquis, utilisés et ajustés par jour, semaine, mois ou client.',
    },
  },
};

export const expenses = {
  title: 'Dépenses',
  subtitle:
    'Suivi des décaissements de l’établissement — espèces, mobile money, chèque, virement et retrait en banque.',
  list: {
    tableTitle: 'Dépenses de la période',
    countLabel: '{{count}} dépense',
    countLabel_other: '{{count}} dépenses',
    searchLabel: 'Rechercher une dépense',
    searchPlaceholder: 'EXP-2026-000003, bénéficiaire, libellé…',
    emptyTitle: 'Aucune dépense sur cette période',
    emptyBody:
      'Enregistrez une dépense avec le bouton « Nouvelle dépense » ou élargissez la période.',
    emptySearchTitle: 'Aucune dépense ne correspond',
    emptySearchBody: 'Modifiez la recherche ou effacez les filtres.',
    periodTotal: 'Total affiché',
    filters: {
      category: 'Catégorie',
      allCategories: 'Toutes les catégories',
      status: 'Statut',
    },
  },
  kpi: {
    total: 'Total de la période',
    totalFoot: '{{count}} dépense enregistrée',
    totalFoot_other: '{{count}} dépenses enregistrées',
    cash: 'Espèces (sorties de caisse)',
    mobileMoney: 'Mobile money',
    bank: 'Chèque, virement, retrait',
    byMethodTitle: 'Par moyen de règlement',
    byCategoryTitle: 'Par catégorie',
    byFoot: 'Période sélectionnée, dépenses annulées exclues.',
    count: '{{count}} opération',
    count_other: '{{count}} opérations',
  },
  columns: {
    reference: 'Référence',
    date: 'Date',
    beneficiary: 'Bénéficiaire',
    category: 'Catégorie',
    method: 'Moyen',
    amount: 'Montant',
    status: 'Statut',
    recordedBy: 'Saisi par',
  },
  method: {
    CASH: 'Espèces',
    MOBILE_MONEY: 'Mobile money',
    CHEQUE: 'Chèque',
    BANK_TRANSFER: 'Virement',
    BANK_WITHDRAWAL: 'Retrait en banque',
  },
  provider: {
    ORANGE_MONEY: 'Orange Money',
    MOOV_MONEY: 'Moov Money',
    WAVE: 'Wave',
    OTHER: 'Autre opérateur',
  },
  category: {
    SUPPLIES: 'Fournitures',
    FUEL: 'Carburant',
    MAINTENANCE: 'Entretien et réparations',
    TRANSPORT: 'Transport',
    UTILITIES: 'Eau, électricité, internet',
    SALARY_ADVANCE: 'Avance sur salaire',
    TAXES_FEES: 'Taxes et frais',
    BANK_DEPOSIT: 'Remise en banque',
    OTHER: 'Autre',
  },
  status: {
    RECORDED: 'Enregistrée',
    CANCELLED: 'Annulée',
  },
  actions: {
    record: 'Nouvelle dépense',
    submit: 'Enregistrer la dépense',
    cancel: 'Annuler la dépense',
    confirmCancel: 'Confirmer l’annulation',
    exportCsv: 'Exporter CSV',
    openExpense: 'Ouvrir la dépense',
    openCash: 'Ouvrir la caisse',
    viewCashSession: 'Voir la session de caisse',
    viewExpenses: 'Voir les dépenses',
  },
  drawer: {
    title: 'Nouvelle dépense',
    subtitle:
      'Un décaissement est numéroté EXP-AAAA-NNNNNN et ne se supprime jamais : il s’annule avec un motif.',
    cashWarningTitle: 'Dépense en espèces',
    cashWarning:
      'Exige une session de caisse ouverte : la dépense crée elle-même la sortie de caisse dans la session en cours.',
    cashOpenBalance: 'Caisse ouverte — théorique en caisse : {{balance}}.',
    offline:
      'Hors ligne : l’enregistrement d’une dépense sera possible dès le retour de la connexion.',
  },
  fields: {
    expenseDate: 'Date de la dépense',
    amount: 'Montant',
    amountHint: 'Montant décaissé, en francs CFA.',
    method: 'Moyen de règlement',
    provider: 'Opérateur mobile money',
    chequeNumber: 'Numéro de chèque',
    reference: 'Référence de transaction',
    referenceHint: 'Facultatif : référence Orange Money, numéro de virement ou de retrait.',
    category: 'Catégorie',
    beneficiary: 'Bénéficiaire ou fournisseur',
    beneficiaryPlaceholder: 'Station Total Ouaga 2000',
    description: 'Libellé',
    descriptionPlaceholder: 'Carburant du groupe électrogène — coupure SONABEL du 6 septembre',
  },
  errors: {
    amountRequired: 'Indiquez un montant strictement positif.',
    dateRequired: 'Indiquez la date de la dépense.',
    providerRequired: 'Choisissez l’opérateur mobile money.',
    chequeNumberRequired: 'Le numéro de chèque est obligatoire.',
    descriptionRequired: 'Indiquez un libellé (3 caractères minimum).',
    reasonRequired: 'Le motif doit comporter au moins 5 caractères.',
  },
  cancel: {
    title: 'Annuler la dépense {{reference}}',
    description:
      'La dépense reste visible avec le statut « Annulée » ; le motif est journalisé avec votre nom.',
    cashNotice:
      'Dépense en espèces : l’annulation crée le mouvement inverse dans la caisse ouverte.',
    reason: 'Motif de l’annulation',
    reasonPlaceholder: 'Saisie en double, montant erroné, facture fournisseur annulée…',
  },
  detail: {
    subtitle: '{{category}} · {{date}}',
    summaryTitle: 'Détail',
    cashTitle: 'Caisse',
    cashBody: 'Sortie de caisse créée dans la session du {{date}}.',
    cashBodyNoSession: 'Sortie de caisse liée à la session de caisse d’origine.',
    cancelledTitle: 'Dépense annulée',
    cancelledBody: '{{reason}} — {{author}}, le {{date}}.',
    recordedBy: 'Saisie par',
    recordedAt: 'Enregistrée le',
    transactionReference: 'Référence',
    noBeneficiary: 'Bénéficiaire non renseigné',
    historyTitle: 'Historique',
    eventRecorded: 'Dépense enregistrée',
    eventCancelled: 'Dépense annulée',
  },
  toasts: {
    recorded: 'Dépense {{reference}} enregistrée ({{amount}}).',
    cancelled: 'Dépense {{reference}} annulée.',
    exported: 'Export « {{name}} » prêt.',
  },
};

export const taxes = {
  title: 'Taxes et retenues',
  subtitle:
    'Règles fiscales appliquées aux proformas et factures. Un changement de régime (TVA) se déclare ici, sans intervention technique.',
  create: 'Nouvelle règle',
  kindHelp:
    'Taxe : ajoutée au montant à payer (ex. TVA). Retenue : déduite (ex. retenue à la source 5 %).',
  noDeleteHelp:
    'Une règle ne se supprime pas : les documents déjà émis la citent. Désactivez-la pour cesser de l’appliquer aux nouveaux documents.',
  help: {
    title: 'Facturer la TVA un jour ?',
    body: 'Si votre régime fiscal n’applique aucune TVA (par exemple CME), aucune règle n’est nécessaire. Le jour venu, créez la règle TVA sur le montant remisé (par exemple code TVA18, 18 %) : elle s’appliquera aux nouveaux documents sans modification du logiciel.',
    prefill: 'Pré-remplir cet exemple',
  },
  count: '{{count}} règle',
  count_other: '{{count}} règles',
  filters: { active: 'Actives', inactive: 'Inactives', all: 'Toutes' },
  columns: {
    rule: 'Règle',
    code: 'Code',
    kind: 'Nature',
    rate: 'Taux',
    base: 'Assiette',
    appliesTo: 'Portée',
    validity: 'Validité',
    status: 'Statut',
    actions: 'Actions',
  },
  kind: { TAX: 'Taxe', WITHHOLDING: 'Retenue' },
  kindDescription: {
    TAX: 'Ajoutée au montant à payer (ex. TVA).',
    WITHHOLDING: 'Déduite du montant à payer (ex. retenue à la source 5 %).',
  },
  base: { SUBTOTAL: 'Sous-total brut', DISCOUNTED_SUBTOTAL: 'Montant remisé' },
  appliesTo: { ALL: 'Tout', ACCOMMODATION: 'Hébergement', SERVICES: 'Services' },
  flags: { inclusive: 'Incluse dans les prix', optional: 'Optionnelle' },
  status: { active: 'Active', inactive: 'Inactive' },
  validity: {
    open: 'Sans limite',
    from: 'Depuis le {{date}}',
    until: 'Jusqu’au {{date}}',
    between: 'Du {{from}} au {{to}}',
  },
  actions: {
    edit: 'Modifier',
    deactivate: 'Désactiver',
    activate: 'Réactiver',
  },
  confirm: {
    deactivateTitle: 'Désactiver {{name}} ?',
    deactivateBody:
      'La règle ne sera plus appliquée aux nouveaux documents. Les proformas et factures déjà émises restent inchangées.',
    deactivateConfirm: 'Désactiver la règle',
    activateTitle: 'Réactiver {{name}} ?',
    activateBody:
      'La règle sera de nouveau appliquée aux nouveaux documents, selon sa période de validité.',
    activateConfirm: 'Réactiver la règle',
  },
  drawer: {
    createTitle: 'Nouvelle règle fiscale',
    editTitle: 'Modifier {{name}}',
    kind: 'Nature',
    kindLocked:
      'La nature d’une règle ne change pas après création : les documents émis la citent.',
    code: 'Code',
    codeHint:
      'De 2 à 20 caractères : lettres, chiffres, tiret ou souligné. Mis en majuscules ; non modifiable après création.',
    name: 'Libellé',
    nameHint: 'Tel qu’il apparaît sur les proformas et factures.',
    rate: 'Taux (%)',
    rateHint: 'Saisissez 18 pour 18 %.',
    base: 'Assiette',
    baseHint: 'Montant sur lequel le taux s’applique.',
    appliesTo: 'Portée',
    appliesToHint: 'Lignes concernées : tout, hébergement seul ou services seuls.',
    isInclusive: 'Taux inclus dans les prix affichés',
    isInclusiveHint:
      'Les tarifs sont réputés toutes taxes comprises : la taxe est extraite du montant.',
    isOptional: 'Optionnelle, activable document par document',
    isOptionalHint: 'Une case « Appliquer » est proposée sur chaque proforma ou facture.',
    validFrom: 'Valable du',
    validTo: 'Valable jusqu’au',
    validityHint: 'Laissez vide pour une validité sans limite.',
    sortOrder: 'Ordre d’affichage',
    sortOrderHint: 'De 0 à 1000 ; les règles sont listées par ordre croissant.',
    submitCreate: 'Créer la règle',
    submitEdit: 'Enregistrer',
    reload: 'Recharger la règle',
  },
  validation: {
    code: 'De 2 à 20 caractères : lettres, chiffres, tiret ou souligné.',
    name: 'Entre 2 et 120 caractères.',
    rate: 'Saisissez un taux entre 0,01 et 100.',
    sortOrder: 'Nombre entier entre 0 et 1000.',
    validity: 'La fin de validité doit être postérieure au début.',
    codeExists: 'Ce code est déjà utilisé par une autre règle.',
  },
  toasts: {
    created: 'Règle {{code}} créée.',
    updated: 'Règle mise à jour.',
    deactivated: 'Règle {{code}} désactivée.',
    activated: 'Règle {{code}} réactivée.',
  },
  emptyTitle: 'Aucune règle fiscale',
  emptyBody:
    'Aucune taxe ni retenue n’est configurée : les documents sont émis sans taxe (régime CME).',
  emptyFilteredTitle: 'Aucune règle pour ce filtre',
  emptyFilteredBody: 'Modifiez le filtre pour afficher les autres règles.',
};

const pos = {
  title: 'Caisse',
  subtitle: 'Prise de commande, envoi en cuisine et encaissement.',
  noOutlet: {
    title: 'Aucun point de vente',
    body: 'Créez un point de vente (restaurant, bar…) pour cet établissement avant d’ouvrir la caisse.',
    action: 'Points de vente & impression',
  },
  bar: {
    outlet: 'Point de vente',
    cashOpen: 'Caisse ouverte',
    cashClosed: 'Caisse fermée',
    server: 'Serveur',
    openOrders_one: '{{count}} commande ouverte',
    openOrders_other: '{{count}} commandes ouvertes',
    newOrder: 'Nouvelle commande',
    happyHour: 'Happy hour',
    happyHourUntil: 'jusqu’à {{time}}',
    happyHourAll: 'toute la carte',
    tables: 'Tables',
    fullscreen: 'Plein écran',
    exitFullscreen: 'Quitter le plein écran',
    exit: 'Quitter la caisse',
    clock: 'Heure',
    views: 'Affichage',
    viewCatalog: 'Carte',
    viewTicket_one: 'Commande · {{count}} article · {{total}}',
    viewTicket_other: 'Commande · {{count}} articles · {{total}}',
  },
  context: {
    title: 'Table et service',
    hint: 'Touchez une table libre pour l’attribuer, ou choisissez le mode de service.',
    browseTitle: 'Tables',
    browseHint:
      'Touchez une table occupée pour reprendre sa commande, une table libre pour en ouvrir une.',
    apply: 'Valider',
    tables: 'Tables',
    noTable: 'Sans table',
    noTables: 'Aucune table pour ce point de vente.',
    current: 'Table de la commande',
    coversMore: 'Un couvert de plus',
    coversLess: 'Un couvert de moins',
  },
  serviceType: {
    DINE_IN: 'Sur place',
    COUNTER: 'Comptoir',
    TAKEAWAY: 'À emporter',
    DELIVERY: 'Livraison',
    ROOM_SERVICE: 'Room service',
  },
  status: {
    OPEN: 'Ouverte',
    PAID: 'Encaissée',
    TRANSFERRED: 'Imputée au séjour',
    CANCELLED: 'Annulée',
  },
  preparation: {
    NEW: 'Nouvelle',
    IN_PREPARATION: 'En préparation',
    READY: 'Prête',
    SERVED: 'Servie',
  },
  itemStatus: {
    PENDING: 'À envoyer',
    SENT: 'En préparation',
    READY: 'Prête',
    SERVED: 'Servie',
    CANCELLED: 'Annulée',
  },
  newOrder: {
    title: 'Nouvelle commande',
    description: 'Choisissez une table libre ou un service sans table.',
    descriptionBar: 'Ouvrez une note au comptoir ou choisissez une table.',
    table: 'Table',
    noTable: 'Sans table',
    occupied: 'occupée',
    covers: 'Couverts',
    serviceType: 'Type de service',
    tabName: 'Nom de la note',
    tabNameHint:
      'Prénom du client, « chemise bleue », numéro de jeton… unique parmi les notes ouvertes.',
    notes: 'Note',
    create: 'Ouvrir la commande',
  },
  categories: {
    all: 'Tout',
    search: 'Rechercher un produit…',
    empty: 'Aucun produit dans cette catégorie.',
    clear: 'Effacer',
  },
  product: {
    unavailable: 'Rupture',
    options: 'Options',
    happyHour: 'Happy hour',
    add: 'Ajouter {{name}}',
    increment: 'Ajouter une unité',
    decrement: 'Retirer une unité',
  },
  ticket: {
    title: 'Addition',
    order: 'Commande',
    empty: 'Aucune commande sélectionnée',
    emptyHint: 'Touchez un plat pour commencer la commande.',
    next: 'Nouvelle commande',
    nextHint: 'Créée au premier plat',
    lines: 'Lignes de la commande',
    assignTable: 'Attribuer à une table',
    customer: 'Client',
    receiptShort: 'Ticket',
    more: 'Plus',
    payAction: 'Paiement',
    paySendsFirst_one: 'envoie d’abord {{count}} ligne en cuisine',
    paySendsFirst_other: 'envoie d’abord {{count}} lignes en cuisine',
    noLines: 'Ajoutez des produits depuis la carte.',
    pending: 'À envoyer',
    sent: 'Envoyé en cuisine',
    subtotal: 'Sous-total',
    discount: 'Remise',
    tax: 'Taxes',
    total: 'Total',
    paid: 'Encaissé',
    balance: 'Reste à payer',
    send: 'Envoyer en cuisine',
    sendCount: 'Envoyer en cuisine ({{count}})',
    requestBill: 'Demander l’addition',
    billRequested: 'Addition demandée',
    discountAction: 'Remise',
    cancelOrder: 'Annuler la commande',
    cancelItem: 'Annuler la ligne',
    remove: 'Retirer',
    receipt: 'Ticket de caisse',
    printReceipt: 'Imprimer le ticket',
    covers_one: '{{count}} couvert',
    covers_other: '{{count}} couverts',
    payWith: 'Encaisser',
    pay: {
      CASH: 'Espèces',
      MOBILE_MONEY: 'Mobile money',
      CARD: 'Carte',
      BANK_TRANSFER: 'Virement',
      CHEQUE: 'Chèque',
      OTHER: 'Autre',
    },
    closed: 'Commande encaissée',
    cancelled: 'Commande annulée',
    markServed: 'Servie',
    transfer: 'Imputer au séjour',
    transferredTo: 'Imputée au séjour',
    transferSlip: 'Bon de transfert',
    tab: 'Note {{name}}',
    listPrice: 'prix carte {{price}}',
    repeatRound: 'Répéter la tournée',
  },
  tabs: {
    title: 'Comptoir',
    subtitle: 'Notes ouvertes du point de vente : reprise en caisse d’un geste.',
    empty: 'Aucune note ouverte',
    emptyHint: 'Ouvrez une note au comptoir depuis la caisse.',
    newTab: 'Nouvelle note',
    resume: 'Reprendre',
    items_one: '{{count}} article',
    items_other: '{{count}} articles',
    since: 'depuis {{time}}',
    noName: 'Sans nom',
  },
  transfer: {
    title: 'Imputer la commande #{{number}} à un séjour',
    description:
      'Le total de {{total}} sera reporté sur la note de la chambre. Le bon de transfert est imprimé pour signature du client.',
    search: 'Séjour en cours',
    searchPlaceholder: 'Numéro de chambre, nom du client, référence…',
    stays: 'Séjours en cours',
    emptyTitle: 'Aucun séjour en cours',
    emptyBody:
      'Seules les réservations en check-in de l’établissement peuvent recevoir une addition.',
    confirm: 'Imputer à {{room}}',
    confirmEmpty: 'Choisir un séjour',
    folioSoFar: 'déjà {{amount}} au folio',
    done: 'Addition imputée au séjour {{reference}} — bon de transfert à faire signer.',
    blockedByPayments:
      'Des paiements sont enregistrés : une addition partiellement réglée ne s’impute pas.',
  },
  optionsDialog: {
    title: 'Options — {{name}}',
    required: 'obligatoire',
    chooseOne: 'Choisir une option',
    chooseUpTo: 'Jusqu’à {{count}} options',
    quantity: 'Quantité',
    notes: 'Instructions',
    notesPlaceholder: 'Sans oignons, bien cuit…',
    add: 'Ajouter à la commande',
  },
  payment: {
    title: 'Paiement',
    back: 'Retour à la commande',
    summary: 'Commande à encaisser',
    method: 'Moyen de paiement',
    due: 'Total à payer',
    received: 'Montant reçu',
    remainingAfter: 'Restera à payer après cet encaissement : {{amount}}',
    exceeds: 'Le montant dépasse le reste à payer.',
    quick: 'Montants rapides',
    exact: 'Montant exact',
    payments: 'Encaissements',
    room: 'Chambre',
    keypad: 'Pavé numérique',
    backspace: 'Effacer le dernier chiffre',
    clear: 'Tout effacer',
    validate: 'Valider',
    validatePartial: 'Encaisser une partie',
    printReceipt: 'Imprimer le ticket',
    transferredTitle: 'Addition imputée au séjour',
    amount: 'Montant encaissé',
    remaining: 'Reste à payer : {{amount}}',
    provider: 'Opérateur',
    tendered: 'Espèces remises',
    change: 'Monnaie à rendre',
    reference: 'Référence de transaction (facultatif)',
    notes: 'Note',
    confirm: 'Valider l’encaissement',
    cashClosed: 'Ouvrez une session de caisse pour encaisser en espèces.',
    openCash: 'Ouvrir la caisse',
    paidTitle: 'Commande encaissée',
    paidBody: 'Total {{total}} · monnaie à rendre {{change}}',
    paidBodyNoChange: 'Total {{total}}',
    partial: 'Encaissement partiel enregistré : reste {{balance}}.',
  },
  reason: {
    cancelOrderTitle: 'Annuler la commande',
    cancelOrderBody:
      'Les lignes envoyées produiront un ticket d’annulation en cuisine. Cette action est irréversible.',
    cancelItemTitle: 'Annuler la ligne « {{label}} »',
    cancelItemBody: 'Un ticket d’annulation part vers la cuisine.',
    discountTitle: 'Remise sur la commande',
    label: 'Motif',
    placeholder: 'Motif (5 caractères minimum)',
    confirm: 'Confirmer',
    discountType: 'Type de remise',
    percent: 'Pourcentage',
    amount: 'Montant',
    none: 'Aucune remise',
    value: 'Valeur',
    removeDiscount: 'Retirer la remise',
  },
  kitchen: {
    title: 'Cuisine',
    subtitle: 'Tickets en préparation, du plus ancien au plus récent.',
    empty: 'Rien en préparation',
    emptyHint: 'Les tickets apparaissent ici dès qu’une commande est envoyée.',
    ready: 'Prêt',
    served: 'Servi',
    reprint: 'Réimprimer',
    reprinted: 'Ticket réimprimé.',
    destination: 'Destination',
    allDestinations: 'Toutes les destinations',
    age: '{{count}} min',
    late: 'En retard',
    cancelTicket: 'Annulation',
    showText: 'Voir le ticket',
    print: 'Imprimer',
    table: 'Table {{code}}',
  },
  tables: {
    title: 'Plan de salle',
    subtitle: 'État des tables et commandes ouvertes.',
    legend: { FREE: 'Libre', OCCUPIED: 'Occupée', BILL_REQUESTED: 'Addition demandée' },
    edit: 'Modifier le plan',
    done: 'Terminer',
    newArea: 'Nouvelle salle',
    newTable: 'Nouvelle table',
    editTable: 'Modifier la table',
    editArea: 'Modifier la salle',
    area: 'Salle',
    noArea: 'Sans salle',
    seats_one: '{{count}} place',
    seats_other: '{{count}} places',
    shape: { SQUARE: 'Carrée', ROUND: 'Ronde', RECT: 'Rectangulaire' },
    code: 'Numéro',
    name: 'Nom',
    seats: 'Couverts',
    shapeLabel: 'Forme',
    active: 'Active',
    open: 'Ouvrir une commande',
    resume: 'Reprendre la commande',
    empty: 'Aucune table',
    emptyHint: 'Créez vos salles et vos tables pour visualiser le service.',
    since: 'depuis {{time}}',
    toasts: { tableSaved: 'Table enregistrée.', areaSaved: 'Salle enregistrée.' },
  },
  catalog: {
    title: 'Carte',
    subtitle: 'Catégories, produits, prix et options de la carte.',
    newCategory: 'Nouvelle catégorie',
    newProduct: 'Nouveau produit',
    editCategory: 'Modifier la catégorie',
    editProduct: 'Modifier le produit',
    allCategories: 'Toutes les catégories',
    search: 'Rechercher…',
    empty: 'Aucun produit',
    emptyHint: 'Ajoutez un premier produit à cette catégorie.',
    showInactive: 'Afficher les éléments inactifs',
    unavailable: 'Rupture',
    inactive: 'Inactif',
    options_one: '{{count}} groupe d’options',
    options_other: '{{count}} groupes d’options',
    fields: {
      code: 'Code',
      name: 'Nom',
      description: 'Description',
      price: 'Prix',
      unit: 'Unité',
      taxRules: 'Règles de taxes',
      taxRulesHint: 'Codes séparés par des virgules (ex. TVA18). Vide = aucune taxe.',
      destination: 'Destination d’impression',
      destinationInherit: 'Comme la catégorie',
      destinationNone: 'Par défaut du point de vente',
      outlet: 'Réservée au point de vente',
      outletAll: 'Tous les points de vente',
      icon: 'Icône',
      color: 'Couleur',
      sortOrder: 'Ordre',
      available: 'Disponible à la vente',
      active: 'Actif',
      category: 'Catégorie',
      optionGroups: 'Groupes d’options',
      groupName: 'Nom du groupe',
      groupKind: 'Choix',
      SINGLE: 'Un seul',
      MULTI: 'Plusieurs',
      minChoices: 'Minimum',
      maxChoices: 'Maximum',
      unlimited: 'Illimité',
      optionName: 'Option',
      priceDelta: 'Supplément',
      addGroup: 'Ajouter un groupe',
      addOption: 'Ajouter une option',
      removeGroup: 'Retirer le groupe',
      removeOption: 'Retirer',
    },
    colors: {
      GREEN: 'Vert',
      GOLD: 'Or',
      SLATE: 'Ardoise',
      OLIVE: 'Olive',
      TERRACOTTA: 'Terre cuite',
    },
    toasts: { categorySaved: 'Catégorie enregistrée.', productSaved: 'Produit enregistré.' },
  },
  settings: {
    title: 'Points de vente & impression',
    subtitle:
      'Points de vente de l’établissement et destinations d’impression (cuisine, bar, caisse).',
    outlets: 'Points de vente',
    destinations: 'Destinations d’impression',
    newOutlet: 'Nouveau point de vente',
    newDestination: 'Nouvelle destination',
    editOutlet: 'Modifier le point de vente',
    editDestination: 'Modifier la destination',
    test: 'Tester',
    tested: 'Ticket de test imprimé.',
    testedBrowser: 'Destination sans imprimante réseau : ticket de test généré.',
    default: 'Par défaut',
    inactive: 'Inactif',
    emptyOutlets: 'Aucun point de vente',
    emptyOutletsHint: 'Un point de vente porte sa carte, ses tables et ses imprimantes.',
    emptyDestinations: 'Aucune destination',
    emptyDestinationsHint: 'Sans destination, les tickets restent consultables à l’écran cuisine.',
    fields: {
      code: 'Code',
      name: 'Nom',
      kind: 'Type',
      driver: 'Pilote',
      host: 'Adresse IP de l’imprimante',
      port: 'Port',
      width: 'Largeur du papier',
      copies: 'Exemplaires',
      isDefault: 'Destination par défaut du point de vente',
      active: 'Actif',
      paymentMethods: 'Moyens de paiement acceptés à la caisse',
      paymentMethodsHint:
        'Proposés à l’étape « Paiement », dans cet ordre. Un moyen décoché est refusé pour ce point de vente.',
    },
    outletKind: {
      RESTAURANT: 'Restaurant',
      BAR: 'Bar',
      ROOM_SERVICE: 'Room service',
      SHOP: 'Boutique',
      OTHER: 'Autre',
    },
    destinationKind: {
      KITCHEN: 'Cuisine',
      BAR: 'Bar',
      GRILL: 'Grill',
      PASTRY: 'Pâtisserie',
      CASHIER: 'Caisse',
      OTHER: 'Autre',
    },
    driver: {
      BROWSER: 'Navigateur (impression depuis le poste)',
      ESCPOS_NETWORK: 'Imprimante réseau ESC/POS',
      NONE: 'Écran seulement',
    },
    happyHours: 'Happy hours',
    newHappyHour: 'Nouvelle happy hour',
    editHappyHour: 'Modifier la happy hour',
    emptyHappyHours: 'Aucune happy hour',
    emptyHappyHoursHint:
      'Une happy hour baisse le prix d’une partie de la carte sur une plage horaire récurrente ; le prix réduit est figé à l’ajout de la ligne.',
    happyHourFields: {
      name: 'Nom',
      days: 'Jours',
      start: 'Début',
      end: 'Fin',
      overnight: 'Une fin antérieure au début franchit minuit.',
      discountType: 'Remise',
      discountValue: 'Valeur',
      categories: 'Catégories',
      allCategories: 'Toute la carte',
      active: 'Active',
      schedule: 'Plage',
      scope: 'Périmètre',
    },
    days: { 1: 'Lun', 2: 'Mar', 3: 'Mer', 4: 'Jeu', 5: 'Ven', 6: 'Sam', 7: 'Dim' },
    toasts: {
      outletSaved: 'Point de vente enregistré.',
      destinationSaved: 'Destination enregistrée.',
      happyHourSaved: 'Happy hour enregistrée.',
    },
  },
  orders: {
    title: 'Commandes',
    subtitle: 'Historique et suivi des commandes du point de vente.',
    stayShort: 'Séjour {{reference}}',
    search: 'Référence, numéro ou note…',
    allStatuses: 'Tous les statuts',
    columns: {
      number: 'N°',
      reference: 'Référence',
      table: 'Table',
      status: 'Statut',
      preparation: 'Préparation',
      items: 'Lignes',
      total: 'Total',
      balance: 'Reste dû',
      server: 'Serveur',
      openedAt: 'Ouverte le',
    },
    empty: 'Aucune commande',
    emptyHint: 'Les commandes apparaissent ici dès la première prise de commande.',
    kpi: {
      revenue: 'CA encaissé',
      paid: 'Commandes encaissées',
      average: 'Panier moyen',
      open: 'En cours',
    },
    topProducts: 'Meilleures ventes',
    byMethod: 'Par moyen de paiement',
    detail: {
      lines: 'Lignes',
      payments: 'Paiements',
      tickets: 'Tickets cuisine',
      taxes: 'Taxes',
      noPayments: 'Aucun paiement',
      noTickets: 'Aucun ticket',
      openInPos: 'Ouvrir dans la caisse',
      stay: 'Séjour {{reference}}',
      discountReason: 'Motif de la remise',
      cancellationReason: 'Motif de l’annulation',
    },
  },
  toasts: {
    orderCreated: 'Commande #{{number}} ouverte.',
    roundRepeated: 'Tournée répétée : lignes à envoyer.',
    sent: 'Envoyé en cuisine.',
    cancelled: 'Commande annulée.',
    itemCancelled: 'Ligne annulée.',
    discountApplied: 'Remise appliquée.',
    billRequested: 'Addition demandée.',
    ticketReady: 'Ticket prêt.',
    ticketServed: 'Ticket servi.',
    receiptPrinted: 'Ticket de caisse imprimé.',
    slipPrinted: 'Bon de transfert imprimé.',
    slipBrowser: 'Aucune imprimante de caisse : bon de transfert ouvert dans le navigateur.',
    receiptBrowser: 'Aucune imprimante caisse réseau : ticket ouvert dans le navigateur.',
  },
};

export const stock = {
  title: 'Stocks',
  nav: {
    levels: 'Niveaux & alertes',
    movements: 'Mouvements',
    purchases: 'Achats',
    counts: 'Inventaires',
    items: 'Articles & lieux',
  },
  noProperty: {
    title: 'Aucun établissement',
    body: 'Sélectionnez un établissement pour consulter son stock.',
  },
  category: { BEVERAGE: 'Boissons', FOOD: 'Denrées', SUPPLY: 'Consommables', OTHER: 'Autres' },
  unit: {
    PIECE: 'pièce',
    BOTTLE: 'bouteille',
    CAN: 'canette',
    L: 'l',
    CL: 'cl',
    KG: 'kg',
    G: 'g',
    PORTION: 'portion',
  },
  movementType: {
    PURCHASE: 'Achat',
    SALE: 'Vente',
    SALE_REVERSAL: 'Annulation de vente',
    ADJUSTMENT: 'Ajustement',
    LOSS: 'Perte',
    TRANSFER_OUT: 'Transfert (sortie)',
    TRANSFER_IN: 'Transfert (entrée)',
    COUNT: 'Inventaire',
  },
  levels: {
    title: 'Niveaux & alertes',
    subtitle: 'Quantités par lieu, seuils d’alerte et valeur du stock au coût moyen.',
    kpi: {
      items: 'Articles suivis',
      alerts: 'En alerte',
      value: 'Valeur du stock',
      locations: 'Lieux',
    },
    search: 'Rechercher un article',
    allCategories: 'Toutes catégories',
    allLocations: 'Tous les lieux',
    alertsOnly: 'Alertes seulement',
    columns: {
      item: 'Article',
      locations: 'Par lieu',
      total: 'Total',
      min: 'Seuil',
      value: 'Valeur',
      actions: 'Actions',
    },
    empty: 'Aucun article',
    emptyHint:
      'Créez vos articles et vos lieux dans « Articles & lieux », puis enregistrez une entrée.',
    noAlert: 'Aucune alerte : tous les articles sont au-dessus de leur seuil.',
    alert: 'Alerte',
    negative: 'Négatif',
    adjust: 'Ajuster / perte',
    transfer: 'Transférer',
  },
  movement: {
    title: 'Mouvement de stock',
    transferTitle: 'Transfert entre lieux',
    kind: 'Nature',
    adjustment: 'Ajustement (signé)',
    loss: 'Perte (casse, périmé)',
    item: 'Article',
    location: 'Lieu',
    from: 'Depuis',
    to: 'Vers',
    quantity: 'Quantité',
    quantityHint: 'En {{unit}} ; négatif pour une sortie, positif pour une entrée.',
    lossHint: 'Quantité retirée, en {{unit}}.',
    unitCost: 'Coût unitaire (entrée)',
    unitCostHint: 'Facultatif : met à jour le coût moyen pondéré.',
    reason: 'Motif',
    reasonHint: 'Obligatoire : il apparaît dans le journal (R-INV-08).',
    submit: 'Enregistrer le mouvement',
    submitTransfer: 'Transférer',
    saved: 'Mouvement enregistré.',
    transferred: 'Transfert enregistré.',
  },
  movements: {
    title: 'Mouvements',
    subtitle:
      'Journal immuable : chaque variation de quantité, son auteur, son motif et sa source.',
    allTypes: 'Tous les types',
    columns: {
      date: 'Date',
      type: 'Type',
      item: 'Article',
      location: 'Lieu',
      quantity: 'Quantité',
      after: 'Après',
      reason: 'Motif / source',
      author: 'Auteur',
    },
    empty: 'Aucun mouvement',
    emptyHint: 'Les entrées, ventes, pertes, transferts et inventaires apparaîtront ici.',
  },
  items: {
    title: 'Articles & lieux',
    subtitle:
      'Articles suivis en stock (unité de gestion, conditionnement d’achat, seuil) et lieux de stockage.',
    itemsCard: 'Articles',
    locationsCard: 'Lieux de stockage',
    newItem: 'Nouvel article',
    editItem: 'Modifier l’article',
    newLocation: 'Nouveau lieu',
    editLocation: 'Modifier le lieu',
    showInactive: 'Afficher les inactifs',
    columns: {
      code: 'Code',
      name: 'Nom',
      category: 'Catégorie',
      unit: 'Unité',
      package: 'Conditionnement',
      min: 'Seuil',
      cost: 'Coût moyen',
      outlet: 'Point de vente',
      default: 'Par défaut',
      status: 'Statut',
    },
    active: 'Actif',
    inactive: 'Inactif',
    isDefault: 'Lieu par défaut',
    emptyItems: 'Aucun article',
    emptyItemsHint: 'Un article est ce que vous comptez : une bouteille, un kilo, une portion.',
    emptyLocations: 'Aucun lieu',
    emptyLocationsHint: 'Réserve, bar, cuisine… Le premier lieu créé devient le lieu par défaut.',
    fields: {
      code: 'Code',
      name: 'Nom',
      category: 'Catégorie',
      unit: 'Unité de gestion',
      packageLabel: 'Conditionnement d’achat',
      packageLabelHint: 'Ex. « Casier de 24 », « Bouteille 70 cl ».',
      packageQuantity: 'Unités par conditionnement',
      minQuantity: 'Seuil d’alerte',
      minQuantityHint: 'En unité de gestion ; vide = pas d’alerte de seuil.',
      outlet: 'Point de vente servi depuis ce lieu',
      noOutlet: 'Aucun (réserve, cuisine…)',
      isDefault: 'Lieu par défaut (réception des achats)',
      isActive: 'Actif',
    },
    toasts: { itemSaved: 'Article enregistré.', locationSaved: 'Lieu enregistré.' },
  },
  recipe: {
    title: 'Recette de déstockage',
    description:
      'Ce que consomme une unité vendue, en unité de gestion de chaque article. Sans recette, le produit ne touche pas au stock.',
    button: 'Recette',
    empty: 'Aucun article : ce produit ne déstocke rien.',
    addLine: 'Ajouter un article',
    item: 'Article',
    quantity: 'Quantité par unité vendue',
    saved: 'Recette enregistrée.',
    lines: '{{count}} article(s) déstocké(s)',
  },
  purchases: {
    title: 'Achats',
    subtitle:
      'Bons d’achat en conditionnements ; la réception fait entrer le stock et recalcule le coût moyen.',
    new: 'Nouveau bon d’achat',
    allStatuses: 'Tous les statuts',
    status: { DRAFT: 'Brouillon', RECEIVED: 'Reçu', CANCELLED: 'Annulé' },
    columns: {
      reference: 'Référence',
      supplier: 'Fournisseur',
      location: 'Lieu',
      date: 'Date',
      lines: 'Lignes',
      total: 'Total',
      status: 'Statut',
    },
    receive: 'Réceptionner',
    cancel: 'Annuler le bon',
    cancelTitle: 'Annuler ce bon d’achat ?',
    cancelDescription: 'Le brouillon sera annulé sans mouvement de stock.',
    empty: 'Aucun bon d’achat',
    emptyHint: 'Saisissez un bon en conditionnements, puis réceptionnez-le à la livraison.',
    drawer: {
      supplier: 'Fournisseur',
      supplierReference: 'Référence fournisseur',
      location: 'Lieu de réception',
      orderedAt: 'Date',
      notes: 'Notes',
      lines: 'Lignes',
      item: 'Article',
      packages: 'Conditionnements',
      packageCost: 'Coût du conditionnement',
      addLine: 'Ajouter une ligne',
      units: '{{count}} {{unit}}',
      total: 'Total',
    },
    toasts: {
      created: 'Bon d’achat créé.',
      received: 'Bon d’achat réceptionné : le stock est à jour.',
      cancelled: 'Bon d’achat annulé.',
    },
    lineSummary: '{{count}} ligne(s)',
  },
  counts: {
    title: 'Inventaires',
    subtitle:
      'Comptage physique par lieu : théorique figé à l’ouverture, écarts validés en mouvements.',
    new: 'Ouvrir un inventaire',
    location: 'Lieu à compter',
    category: 'Limiter à une catégorie',
    allCategories: 'Tous les articles',
    notes: 'Notes',
    status: { OPEN: 'En cours', VALIDATED: 'Validé', CANCELLED: 'Annulé' },
    columns: {
      reference: 'Référence',
      location: 'Lieu',
      started: 'Ouvert le',
      progress: 'Compté',
      status: 'Statut',
    },
    detail: 'Saisie de l’inventaire',
    expected: 'Théorique',
    counted: 'Compté',
    variance: 'Écart',
    save: 'Enregistrer la saisie',
    validate: 'Valider l’inventaire',
    validateTitle: 'Valider cet inventaire ?',
    validateDescription:
      'Chaque écart non nul deviendra un mouvement d’inventaire ; les lignes non comptées sont ignorées. L’inventaire sera clos.',
    cancel: 'Annuler l’inventaire',
    cancelTitle: 'Annuler cet inventaire ?',
    cancelDescription: 'Aucun mouvement ne sera créé.',
    open: 'Ouvrir',
    empty: 'Aucun inventaire',
    emptyHint:
      'Ouvrez un comptage sur un lieu : les quantités théoriques sont figées à cet instant.',
    toasts: {
      opened: 'Inventaire ouvert.',
      saved: 'Saisie enregistrée.',
      validated: 'Inventaire validé : les écarts sont enregistrés.',
      cancelled: 'Inventaire annulé.',
    },
    progress: '{{counted}} / {{total}}',
  },
};

/** Console plateforme (phase H6, ADR-021) : tenants, abonnements, modules, Owner. */
export const platform = {
  title: 'Plateforme',
  locales: { fr: 'Français', en: 'Anglais' },
  activities: { HOTEL: 'Hôtel', RESTAURANT: 'Restaurant', BAR: 'Bar', OTHER: 'Autre' },
  status: { TRIAL: 'Essai', ACTIVE: 'Actif', SUSPENDED: 'Suspendu' },
  subscriptionStatus: {
    TRIAL: 'Essai',
    ACTIVE: 'Actif',
    PAST_DUE: 'Impayé (grâce)',
    SUSPENDED: 'Suspendu',
    CANCELLED: 'Résilié',
  },
  moduleStatus: { AVAILABLE: 'Disponible', COMING_SOON: 'Bientôt' },
  mfa: {
    title: 'Double authentification non activée',
    body: 'La console plateforme exige le second facteur en production.',
    link: 'Activer la double authentification',
  },
  overview: {
    title: 'Vue d’ensemble',
    subtitle: 'Tenants, abonnements, adoption des modules et essais à échéance.',
    kpi: { total: 'Tenants' },
    plans: 'Abonnements par plan',
    modules: 'Adoption des modules',
    trials: 'Essais à échéance (14 jours)',
    recent: 'Derniers tenants créés',
    noSubscription: 'Aucun abonnement vivant.',
    noTrial: 'Aucun essai n’expire dans les quatorze jours.',
    trialExpired: 'Expiré',
    trialDays_one: '{{count}} jour',
    trialDays_other: '{{count}} jours',
    columns: {
      plan: 'Plan',
      tenants: 'Tenants',
      module: 'Module',
      availability: 'Disponibilité',
      trialEnds: 'Fin d’essai',
    },
  },
  tenants: {
    title: 'Tenants',
    subtitle: 'Clients de la plateforme : fiche, abonnement, modules et comptes.',
    new: 'Nouveau tenant',
    search: 'Rechercher un tenant',
    allPlans: 'Tous les plans',
    empty: 'Aucun tenant',
    emptyHint: 'Provisionnez votre premier client avec « Nouveau tenant ».',
    neverLoggedIn: 'Jamais connecté',
    columns: {
      tenant: 'Tenant',
      status: 'Statut',
      plan: 'Plan',
      modules: 'Modules',
      properties: 'Établissements',
      users: 'Comptes',
      lastLogin: 'Dernière connexion',
      created: 'Créé',
    },
  },
  form: {
    title: 'Nouveau tenant',
    description:
      'Fiche, premier établissement, abonnement et compte Owner sont créés ensemble ; le Owner reçoit un lien d’activation.',
    submit: 'Provisionner',
    sections: {
      identity: 'Organisation',
      subscription: 'Abonnement',
      property: 'Premier établissement',
      owner: 'Compte Owner',
    },
    legalName: 'Raison sociale',
    tradeName: 'Nom commercial',
    slug: 'Identifiant',
    slugHint: 'Minuscules, chiffres et tirets ; immuable après création.',
    countryCode: 'Pays (ISO)',
    currencyCode: 'Devise (ISO)',
    timezone: 'Fuseau horaire',
    defaultLocale: 'Langue',
    plan: 'Plan',
    status: 'Statut',
    planModules: 'Modules du plan : {{modules}}',
    trialEndsAt: 'Fin d’essai',
    trialHint:
      'Informative hors plateforme ; en facturé, la première facture est émise ce jour-là.',
    addons: 'Options hors plan',
    addonRequires: 'Requiert : {{modules}}',
    notes: 'Notes internes',
    propertyCode: 'Code',
    propertyName: 'Nom de l’établissement',
    activities: 'Activités',
    activitiesRequired: 'Au moins une activité.',
    ownerFullName: 'Nom complet',
    ownerEmail: 'E-mail',
    ownerLocale: 'Langue du Owner',
    ownerNotice:
      'L’adresse doit être unique sur toute la plateforme. Le lien d’activation vous sera remis à l’écran, en plus de l’e-mail.',
  },
  detail: {
    identity: 'Fiche',
    editTitle: 'Modifier la fiche',
    slugImmutable: 'L’identifiant ne change jamais.',
    properties: 'Établissements',
    noProperty: 'Aucun établissement',
    inactive: 'Inactif',
    suspend: 'Suspendre',
    reactivate: 'Réactiver',
    suspendedNotice:
      'Tenant suspendu : ses utilisateurs ne peuvent plus se connecter. Aucune donnée n’est supprimée.',
  },
  subscription: {
    title: 'Abonnement',
    edit: 'Modifier',
    editTitle: 'Abonnement',
    editDescription: 'Plan, statut d’essai ou actif, échéance et notes internes.',
    none: 'Aucun abonnement vivant.',
    since: 'Depuis le {{date}}',
    trialEnds: 'fin d’essai le {{date}}',
    ends: 'fin le {{date}}',
    startsAt: 'Début',
    history: 'Historique des abonnements',
    planChangeNotice:
      'Changer de plan recalcule les modules du plan ; les options restent activées. Un abonnement actif n’a pas d’échéance d’essai.',
    billingSection: 'Facturation par HOREVIA',
    billingMode: 'Mode de facturation',
    billingPeriod: 'Périodicité',
    priceAmount: 'Prix par période ({{currency}})',
    priceSuggested: 'Catalogue : {{amount}} (plan {{plan}}{{addons}}).',
    priceNoCatalog: 'Aucun prix catalogué dans cette devise : saisissez le prix négocié.',
    autoSuspend: 'Coupure automatique après préavis en cas d’impayé',
    limits: 'Limites (vide = celles du plan, 0 = illimité)',
    limitProperties: 'Établissements',
    limitResources: 'Ressources',
    limitUsers: 'Comptes',
    endsAt: 'Fin d’abonnement (résiliation programmée)',
    invoicedNotice:
      'Un abonnement actif facturé reçoit sa facture immédiatement, puis à chaque période ; en essai, à la fin de l’essai. Retard après {{grace}} jours, suspension automatique un jour ouvré après préavis.',
  },
  modules: {
    title: 'Modules',
    plan: 'Inclus dans le plan',
    addon: 'Option',
    inPlanDisabled: 'Inclus, désactivé',
    off: 'Non activé',
    toggle: 'Activer ou désactiver {{module}}',
  },
  owner: {
    title: 'Comptes Owner',
    invite: 'Inviter',
    inviteTitle: 'Inviter un Owner',
    inviteDescription:
      'Nouveau lien pour un compte encore invité, ou nouveau compte Owner pour ce tenant.',
    inviteSubmit: 'Envoyer l’invitation',
    inviteNotice: 'Le lien d’activation vous sera remis à l’écran, en plus de l’e-mail.',
    none: 'Aucun compte Owner',
    invitationPending: 'Invitation en attente',
    mfa: 'MFA',
    columns: { account: 'Compte', status: 'Statut', lastLogin: 'Dernière connexion' },
  },
  suspend: {
    title: 'Suspendre {{name}}',
    description:
      'Les sessions sont révoquées et la connexion refusée jusqu’à réactivation. Le motif est journalisé, y compris pour le tenant.',
    reason: 'Motif',
    confirm: 'Suspendre le tenant',
  },
  billing: {
    title: 'Facturation',
    subtitle:
      'Abonnements facturés par HOREVIA : revenu récurrent, factures, règlements et retards.',
    kpi: {
      mrr: 'Revenu mensuel récurrent',
      outstanding: 'Encours',
      overdue: 'En retard',
      paid30: 'Réglé sur 30 jours',
    },
    kpiInvoices_one: '{{count}} facture',
    kpiInvoices_other: '{{count}} factures',
    kpiSubscriptions_one: '{{count}} abonnement facturé',
    kpiSubscriptions_other: '{{count}} abonnements facturés',
    noMoney: '—',
    run: 'Lancer le cycle',
    runDone:
      'Cycle exécuté : {{activated}} activation(s), {{invoiced}} facture(s), {{pastDue}} retard(s), {{suspended}} suspension(s).',
    invoices: 'Factures',
    none: 'Aucune facture d’abonnement.',
    noneHint:
      'Passez un abonnement en « Facturé par HOREVIA » depuis la fiche du tenant : la première facture est émise aussitôt.',
    allStatuses: 'Tous les statuts',
    overdueOnly: 'Échues seulement',
    columns: {
      number: 'Numéro',
      tenant: 'Tenant',
      period: 'Période',
      issued: 'Émise le',
      due: 'Échéance',
      total: 'Total',
      balance: 'Solde',
      status: 'Statut',
      actions: 'Actions',
    },
    status: {
      ISSUED: 'Émise',
      PARTIALLY_PAID: 'Partiellement réglée',
      PAID: 'Réglée',
      CANCELLED: 'Annulée',
    },
    overdue: 'Échue',
    overdueTenants: 'Tenants en retard de règlement',
    noOverdue: 'Aucun retard de règlement.',
    upcoming: 'Prochaines émissions (30 jours)',
    noUpcoming: 'Aucune émission prévue sous trente jours.',
    upcomingKind: { RENEWAL: 'Renouvellement', TRIAL_END: 'Fin d’essai' },
    suspensionOn: 'Suspension le {{date}}',
    oldestDue: 'Échue depuis le {{date}}',
    issueNext: 'Émettre la prochaine facture',
    download: 'PDF',
    pay: 'Régler',
    cancel: 'Annuler',
    reverse: 'Annuler ce règlement',
    payments: 'Règlements',
    reversed: 'annulé',
    mode: { MANUAL: 'Hors plateforme', INVOICED: 'Facturé par HOREVIA' },
    period: { MONTHLY: 'Mensuel', YEARLY: 'Annuel' },
    perPeriod: { MONTHLY: '/ mois', YEARLY: '/ an' },
    payment: {
      title: 'Enregistrer un règlement',
      description: 'Facture {{number}} · solde restant {{balance}}.',
      amount: 'Montant',
      method: 'Mode de règlement',
      provider: 'Opérateur ou banque',
      reference: 'Référence',
      paidAt: 'Date du règlement',
      notes: 'Note',
      confirm: 'Enregistrer',
      methods: {
        BANK_TRANSFER: 'Virement',
        MOBILE_MONEY: 'Mobile money',
        CASH: 'Espèces',
        CHEQUE: 'Chèque',
        OTHER: 'Autre',
      },
    },
    cancelInvoice: {
      title: 'Annuler la facture {{number}}',
      description:
        'Seule une facture émise sans aucun règlement peut être annulée. Le numéro reste consommé ; la période pourra être refacturée.',
      reason: 'Motif',
      confirm: 'Annuler la facture',
    },
    reversePayment: {
      title: 'Annuler un règlement',
      description:
        'Le règlement de {{amount}} sera marqué annulé et le solde de la facture recalculé.',
      reason: 'Motif',
      confirm: 'Annuler le règlement',
    },
    card: {
      title: 'Facturation',
      mode: 'Mode',
      price: 'Prix',
      currentPeriod: 'Période en cours',
      nextInvoice: 'Prochaine facture',
      autoSuspend: 'Coupure automatique',
      on: 'Oui',
      off: 'Non',
      pastDue: 'En retard depuis le {{date}}',
      suspension: 'Suspension prévue le {{date}}',
      limits: 'Limites',
      unlimited: 'illimité',
      manualHint:
        'Abonnement hors plateforme : aucune facture ni coupure automatique. Modifiez l’abonnement pour le facturer.',
      trialHint: 'La première facture sera émise à la fin de l’essai.',
    },
    toasts: {
      paymentRecorded: 'Règlement enregistré.',
      invoiceCancelled: 'Facture annulée.',
      paymentReversed: 'Règlement annulé.',
      issued: 'Facture émise.',
    },
  },
  pricing: {
    title: 'Tarifs et limites',
    subtitle:
      'Prix catalogués par plan et par option (proposés à la souscription, jamais appliqués sans être recopiés sur l’abonnement) et limites par plan.',
    currency: 'Devise',
    plans: 'Plans',
    modules: 'Options',
    columns: {
      plan: 'Plan',
      module: 'Option',
      monthly: 'Mensuel',
      yearly: 'Annuel',
      properties: 'Établissements',
      resources: 'Ressources',
      users: 'Comptes',
    },
    limitHint: 'Vide = illimité.',
    priceHint: 'Vide = non proposé dans cette devise.',
    save: 'Enregistrer les tarifs',
    toasts: { saved: 'Tarifs et limites enregistrés.' },
  },
  toasts: {
    created: 'Tenant « {{name}} » provisionné.',
    updated: 'Fiche mise à jour.',
    subscriptionUpdated: 'Abonnement mis à jour.',
    moduleEnabled: 'Module activé pour le tenant.',
    moduleDisabled: 'Module désactivé pour le tenant.',
    suspended: 'Tenant suspendu.',
    reactivated: 'Tenant réactivé.',
    ownerInvited: 'Invitation envoyée.',
    ownerInvitedNoEmail: 'Invitation créée : transmettez le lien vous-même.',
  },
};

export const support = {
  title: 'Accès support',
  subtitle:
    'Demandes des opérateurs HOREVIA d’accéder à vos données en lecture seule, pour vous assister. Vous décidez, vous pouvez révoquer à tout moment, et chaque étape est inscrite dans votre journal d’audit.',
  state: {
    PENDING: 'En attente',
    APPROVED: 'Approuvé',
    EXPIRED: 'Expiré',
    ENDED: 'Terminé',
    DECLINED: 'Refusé',
    CANCELLED: 'Retiré',
    REVOKED: 'Révoqué',
  },
  columns: {
    tenant: 'Tenant',
    operator: 'Opérateur',
    request: 'Demande',
    reason: 'Motif',
    state: 'État',
    decision: 'Décision',
    actions: 'Actions',
  },
  requestedBy: 'Demandé par {{name}}',
  requestedDuration: 'Durée demandée : {{duration}}',
  approvedDuration: 'Durée accordée : {{duration}}',
  decidedBy: 'Décidé par {{name}}',
  until: 'jusqu’au {{date}}',
  requestsServed_one: '{{count}} requête servie',
  requestsServed_other: '{{count}} requêtes servies',
  note: 'Note (facultative, visible par l’autre partie)',
  listTitle: 'Demandes reçues',
  none: 'Aucune demande d’accès support.',
  noneTenant:
    'Aucun opérateur de la plateforme n’a demandé à accéder à vos données. Vous serez prévenu par e-mail et par notification.',
  card: {
    title: 'Accès support',
    hint: 'Un accès se demande ici ; le Owner l’approuve depuis son application.',
    request: 'Demander un accès',
    enter: 'Entrer',
    cancel: 'Retirer',
    mine: 'Mes accès support',
  },
  request: {
    title: 'Demander un accès support',
    description:
      'Le Owner de {{name}} recevra un e-mail et une notification ; il peut approuver, réduire la durée ou refuser.',
    reason: 'Motif (visible par le tenant)',
    minutes: 'Durée souhaitée en minutes (au plus {{max}})',
    submit: 'Envoyer la demande',
    notice:
      'L’accès sera en lecture seule : aucune modification, aucun export, aucune pièce d’identité. Chaque étape est journalisée chez le tenant et sur la plateforme.',
  },
  approve: {
    action: 'Approuver',
    title: 'Approuver l’accès support',
    description:
      '{{name}} pourra consulter vos données en lecture seule pendant la durée accordée. Vous pouvez révoquer à tout moment.',
    minutes: 'Durée accordée en minutes (au plus {{max}})',
    confirm: 'Approuver',
  },
  decline: {
    action: 'Refuser',
    title: 'Refuser la demande',
    description: '{{name}} sera informé du refus ; aucun accès ne sera ouvert.',
    confirm: 'Refuser',
  },
  revoke: {
    action: 'Révoquer',
    title: 'Révoquer l’accès',
    description: '{{name}} perd l’accès dès sa prochaine action.',
    confirm: 'Révoquer',
  },
  banner: {
    title: 'Accès support chez {{name}} — lecture seule',
    body: 'Jusqu’au {{date}}. Motif : {{reason}}',
    leave: 'Quitter',
    end: 'Terminer l’accès',
    ended: 'L’accès support est terminé.',
  },
  toasts: {
    requested: 'Demande envoyée au Owner.',
    cancelled: 'Demande retirée.',
    approved: 'Accès approuvé.',
    declined: 'Demande refusée.',
    revoked: 'Accès révoqué.',
    entered: 'Vous êtes chez {{name}}, en lecture seule.',
    left: 'Retour à la console plateforme.',
  },
};

export const onboarding = {
  title: 'Mise en route',
  subtitle:
    'Ce qu’il reste à configurer avant d’exploiter HOREVIA au quotidien. Calculé sur vos données réelles, adapté à vos modules ; rien ne bloque l’application.',
  progress: '{{done}} sur {{total}} étapes',
  count_one: '{{count}} élément',
  count_other: '{{count}} éléments',
  complete: 'Tout est configuré. L’assistant n’apparaît plus sur le tableau de bord.',
  hiddenNotice: 'L’assistant est masqué : il n’apparaît plus sur le tableau de bord.',
  dismiss: 'Masquer l’assistant',
  restore: 'Réafficher l’assistant',
  status: { DONE: 'Fait', TODO: 'À faire', SKIPPED: 'Ignoré' },
  actions: { configure: 'Configurer', skip: 'Ignorer', unskip: 'Rétablir' },
  groups: { identity: 'Identité', property: 'Établissement', sales: 'Ventes', team: 'Équipe' },
  steps: {
    identity: {
      title: 'Coordonnées de contact',
      description: 'E-mail ou téléphone affichés sur vos documents et vos e-mails.',
    },
    legal: {
      title: 'Mentions légales',
      description: 'RCCM ou IFU, régime fiscal, forme juridique, activité.',
    },
    branding: { title: 'Logo', description: 'Votre logo sur les documents et dans l’application.' },
    property: {
      title: 'Adresse de l’établissement',
      description: 'Adresse et horaires d’arrivée et de départ.',
    },
    taxes: {
      title: 'Taxes',
      description: 'Au moins une règle de taxe active — ou aucune taxe : ignorez l’étape.',
    },
    billing: {
      title: 'Facturation',
      description: 'Numérotation, délais et mentions des proformas et factures.',
    },
    resources: {
      title: 'Chambres et ressources',
      description: 'Au moins une ressource à réserver.',
    },
    ratePlans: { title: 'Tarifs', description: 'Au moins un tarif actif sur une ressource.' },
    compliance: {
      title: 'Documents obligatoires',
      description: 'Pièces exigées à l’arrivée (CNIB, passeport, fiche de police).',
    },
    outlets: { title: 'Points de vente', description: 'Restaurant, bar, boutique…' },
    catalog: { title: 'Carte', description: 'Au moins un produit actif à la carte.' },
    printing: {
      title: 'Impression',
      description: 'Une destination d’impression (cuisine, bar, caisse) — ou aucune : ignorez.',
    },
    users: { title: 'Équipe', description: 'Invitez au moins un collègue.' },
  },
  card: { title: 'Mise en route', open: 'Ouvrir l’assistant' },
  toasts: { updated: 'Assistant mis à jour.' },
};

/** Mon abonnement, côté tenant (phase H8, ADR-023, D-H52). */
export const subscription = {
  title: 'Abonnement',
  subtitle: 'Votre abonnement HOREVIA : plan, période, limites, factures et règlement.',
  plan: 'Plan',
  status: 'Statut',
  mode: 'Facturation',
  modes: { MANUAL: 'Hors plateforme', INVOICED: 'Facturée par HOREVIA' },
  price: 'Prix',
  perPeriod: { MONTHLY: '/ mois', YEARLY: '/ an' },
  currentPeriod: 'Période en cours',
  nextInvoice: 'Prochaine facture',
  trialEnds: 'Fin d’essai',
  ends: 'Fin d’abonnement',
  since: 'Depuis le {{date}}',
  none: 'Aucun abonnement actif. Contactez HOREVIA.',
  pastDue: 'Une facture est en retard de règlement depuis le {{date}}.',
  suspension: 'Sans règlement, l’accès sera suspendu le {{date}}.',
  limits: {
    title: 'Limites du plan',
    properties: 'Établissements',
    resources: 'Ressources',
    users: 'Comptes',
    unlimited: 'illimité',
    usage: '{{used}} / {{max}}',
    hint: 'Les limites s’appliquent à la création : l’existant n’est jamais bloqué.',
  },
  invoices: {
    title: 'Factures d’abonnement',
    none: 'Aucune facture : votre abonnement n’est pas facturé via la plateforme.',
    download: 'PDF',
    columns: {
      number: 'Numéro',
      period: 'Période',
      issued: 'Émise le',
      due: 'Échéance',
      total: 'Total',
      balance: 'Solde',
      status: 'Statut',
    },
    status: {
      ISSUED: 'À régler',
      PARTIALLY_PAID: 'Partiellement réglée',
      PAID: 'Réglée',
      CANCELLED: 'Annulée',
    },
    overdue: 'Échue',
    payments: 'Règlements reçus',
  },
  payment: {
    title: 'Comment régler',
    issuer: 'Bénéficiaire',
    bank: 'Banque',
    account: 'Compte',
    iban: 'IBAN',
    swift: 'SWIFT',
    methods: 'Modalités acceptées',
    terms: 'Conditions',
    contact: 'Contact',
    reference:
      'Rappelez le numéro de facture et votre identifiant client « {{slug}} » lors du règlement.',
  },
  banner: {
    TRIAL_ENDING: 'Votre essai HOREVIA se termine le {{date}}.',
    PAST_DUE:
      'La facture d’abonnement {{number}} est échue depuis le {{date}} : {{balance}} restant à régler.',
    SUSPENSION_SCHEDULED:
      'Facture {{number}} impayée ({{balance}}) : sans règlement, l’accès sera suspendu le {{date}}.',
    ENDING: 'Votre abonnement HOREVIA prend fin le {{date}}.',
    open: 'Voir mon abonnement',
  },
};

export const insights = {
  title: 'Analytics',
  overview: {
    title: 'Vue consolidée',
    subtitle:
      'Chiffre d’affaires de l’hébergement, de la restauration et du bar sur la période — chaque vente comptée une fois.',
  },
  sales: {
    title: 'Ventes',
    subtitle:
      'Commandes encaissées et imputées au séjour, par point de vente, catégorie, produit, heure, jour, serveur et type de service.',
  },
  stock: {
    title: 'Stocks & marges',
    subtitle:
      'Consommations au déstockage, achats reçus, pertes, écarts d’inventaire et marge par produit vendu.',
  },
  modules: {
    ACCOMMODATION: 'Hébergement',
    RESTAURANT: 'Restauration',
    BAR: 'Bar',
    ROOM_SERVICE: 'Room service',
    SHOP: 'Boutique',
    OTHER: 'Autres ventes',
  },
  kpi: {
    revenue: 'CA consolidé',
    salesRevenue: 'CA des ventes',
    revenueFoot: 'sur {{count}} jour',
    revenueFoot_other: 'sur {{count}} jours',
    collected: 'Encaissé',
    collectedFoot: 'tous modules, remboursements déduits',
    expenses: 'Dépenses',
    expensesFoot: 'décaissements de la période',
    costOfSales: 'Coût des ventes',
    costOfSalesFoot: 'déstockages au coût moyen',
    grossMargin: 'Marge brute',
    grossMarginFoot: 'CA HT des ventes − coût',
    grossMarginRate: 'Taux de marge',
    orders: 'Commandes',
    ordersFoot: 'encaissées ou imputées',
    covers: 'Couverts',
    averageTicket: 'Ticket moyen',
    happyHour: 'Remises happy hour',
    transferred: 'Imputées au séjour',
    transferredFoot: '{{count}} commande',
    transferredFoot_other: '{{count}} commandes',
    cancelled: 'Annulées',
    occupancy: 'Taux d’occupation',
    adr: 'Prix moyen (ADR)',
    revpar: 'RevPAR',
    stays: 'Séjours',
    consumedCost: 'Consommé',
    consumedFoot: 'déstockages à la vente',
    purchasedCost: 'Achats reçus',
    lostCost: 'Pertes',
    countVariance: 'Écarts d’inventaire',
    stockValue: 'Valeur du stock',
    stockValueFoot: 'en fin de période, au coût moyen',
    revenueExclTax: 'CA HT (coût connu)',
  },
  sections: {
    hotel: 'Hébergement',
    pos: 'Points de vente',
    finance: 'Encaissements & charges',
    byModule: 'Répartition par famille',
    daily: 'CA par jour et par famille',
    topOutlets: 'Meilleurs points de vente',
    topProducts: 'Produits phares',
    collectedByMethod: 'Encaissements par méthode',
    paymentsByMethod: 'Ventes encaissées par méthode',
    byItem: 'Par article',
    byCategory: 'Par catégorie',
    margins: 'Marges par produit',
  },
  charts: {
    dailyDescription:
      'Chiffre d’affaires par jour du {{from}} au {{to}}, empilé par famille : {{total}} au total. Le détail chiffré est disponible dans le tableau « Voir les données ».',
    byModuleDescription:
      'Part de chaque famille dans le chiffre d’affaires consolidé de la période ({{count}} familles).',
    breakdownDescription:
      'Chiffre d’affaires des ventes par {{axis}} sur la période ({{count}} lignes).',
    showData: 'Voir les données',
    thousands: 'en milliers de {{currency}}',
    thousandsShort: 'k{{currency}}',
    columns: {
      date: 'Jour',
      module: 'Famille',
      amount: 'Montant',
      outlet: 'Point de vente',
      product: 'Produit',
      quantity: 'Quantité',
      orders: 'Commandes',
      method: 'Méthode',
      count: 'Opérations',
    },
  },
  axes: {
    OUTLET: 'Points de vente',
    CATEGORY: 'Catégories',
    PRODUCT: 'Produits',
    HOUR: 'Heures',
    WEEKDAY: 'Jours de semaine',
    SERVER: 'Serveurs',
    SERVICE_TYPE: 'Types de service',
  },
  axisSingular: {
    OUTLET: 'point de vente',
    CATEGORY: 'catégorie',
    PRODUCT: 'produit',
    HOUR: 'heure',
    WEEKDAY: 'jour de semaine',
    SERVER: 'serveur',
    SERVICE_TYPE: 'type de service',
  },
  weekdays: {
    '1': 'Lundi',
    '2': 'Mardi',
    '3': 'Mercredi',
    '4': 'Jeudi',
    '5': 'Vendredi',
    '6': 'Samedi',
    '7': 'Dimanche',
  },
  serviceTypes: {
    DINE_IN: 'Sur place',
    COUNTER: 'Comptoir',
    TAKEAWAY: 'À emporter',
    DELIVERY: 'Livraison',
    ROOM_SERVICE: 'Room service',
  },
  methods: {
    CASH: 'Espèces',
    MOBILE_MONEY: 'Mobile money',
    BANK_TRANSFER: 'Virement',
    CHEQUE: 'Chèque',
    CARD: 'Carte',
    OTHER: 'Autre',
  },
  table: {
    label: 'Libellé',
    orders: 'Commandes',
    covers: 'Couverts',
    quantity: 'Quantité',
    revenue: 'CA',
    share: 'Part',
    averageTicket: 'Ticket moyen',
    happyHour: 'Happy hour',
    item: 'Article',
    category: 'Catégorie',
    unit: 'Unité',
    consumed: 'Consommé',
    consumedCost: 'Coût consommé',
    purchased: 'Acheté',
    purchasedCost: 'Coût acheté',
    lost: 'Pertes',
    lostCost: 'Coût des pertes',
    variance: 'Écart d’inventaire',
    product: 'Produit',
    revenueExclTax: 'CA HT',
    cost: 'Coût',
    margin: 'Marge',
    marginRate: 'Taux',
    costUnknown: 'Coût inconnu',
    costUnknownHint:
      'Ce produit n’a pas de recette de déstockage : sa marge ne peut pas être calculée.',
    noServer: 'Sans serveur',
    noCategory: 'Sans catégorie',
    caption: '{{axis}} — {{count}} lignes',
  },
  filters: {
    outlet: 'Point de vente',
    allOutlets: 'Tous les points de vente',
    axis: 'Axe d’analyse',
  },
  actions: {
    exportCsv: 'Exporter CSV',
    openReport: 'Ouvrir le rapport',
    openSales: 'Voir les ventes',
    openStock: 'Voir les stocks',
    openAnalytics: 'Ouvrir Analytics',
  },
  empty: {
    title: 'Aucune vente sur cette période',
    body: 'Élargissez la période ou changez de point de vente.',
    stockTitle: 'Aucun mouvement de stock sur cette période',
    stockBody: 'Aucune consommation, aucun achat ni aucune perte n’est enregistré sur ces dates.',
  },
  noModule: {
    pos: 'Le module POS n’est pas actif : aucune vente à analyser.',
    inventory: 'Le module Inventory n’est pas actif : consommations et marges indisponibles.',
    analytics:
      'Horevia Analytics n’est pas activé pour votre organisation. Activez-le depuis les modules.',
  },
  financeHidden:
    'Les montants encaissés, les dépenses, les coûts et les marges demandent la permission « Rapports financiers ».',
  dashboard: {
    salesTitle: 'Ventes du jour',
    salesOrders: '{{count}} commande encaissée',
    salesOrders_other: '{{count}} commandes encaissées',
    salesOpen: '{{count}} en cours',
    salesAverage: 'ticket moyen {{amount}}',
    salesEmpty: 'Aucune vente encaissée aujourd’hui.',
    consolidatedTitle: 'Vue consolidée du mois',
    consolidatedFoot: 'du {{from}} au {{to}}',
  },
};

export default {
  common,
  nav,
  auth,
  dashboard,
  analytics,
  search,
  reports,
  customers,
  reservations,
  users,
  roles,
  audit,
  settings,
  profile,
  resources,
  calendar,
  availability,
  maintenance,
  errors,
  documents,
  compliance,
  housekeeping,
  tasks,
  billing,
  payments,
  cash,
  expenses,
  taxes,
  pos,
  stock,
  platform,
  support,
  onboarding,
  subscription,
  insights,
  crm,
};
